var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateMethod = (obj, member, method) => {
  __accessCheck(obj, member, "access private method");
  return method;
};

// node_modules/pubsub-js/src/pubsub.js
var require_pubsub = __commonJS({
  "node_modules/pubsub-js/src/pubsub.js"(exports, module) {
    (function(root, factory) {
      "use strict";
      var PubSub2 = {};
      if (root.PubSub) {
        PubSub2 = root.PubSub;
        console.warn("PubSub already loaded, using existing version");
      } else {
        root.PubSub = PubSub2;
        factory(PubSub2);
      }
      if (typeof exports === "object") {
        if (module !== void 0 && module.exports) {
          exports = module.exports = PubSub2;
        }
        exports.PubSub = PubSub2;
        module.exports = exports = PubSub2;
      } else if (typeof define === "function" && define.amd) {
        define(function() {
          return PubSub2;
        });
      }
    })(typeof window === "object" && window || exports || global, function(PubSub2) {
      "use strict";
      var messages = {}, lastUid = -1, ALL_SUBSCRIBING_MSG = "*";
      function hasKeys(obj) {
        var key;
        for (key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            return true;
          }
        }
        return false;
      }
      function throwException(ex) {
        return function reThrowException() {
          throw ex;
        };
      }
      function callSubscriberWithDelayedExceptions(subscriber, message, data) {
        try {
          subscriber(message, data);
        } catch (ex) {
          setTimeout(throwException(ex), 0);
        }
      }
      function callSubscriberWithImmediateExceptions(subscriber, message, data) {
        subscriber(message, data);
      }
      function deliverMessage(originalMessage, matchedMessage, data, immediateExceptions) {
        var subscribers = messages[matchedMessage], callSubscriber = immediateExceptions ? callSubscriberWithImmediateExceptions : callSubscriberWithDelayedExceptions, s2;
        if (!Object.prototype.hasOwnProperty.call(messages, matchedMessage)) {
          return;
        }
        for (s2 in subscribers) {
          if (Object.prototype.hasOwnProperty.call(subscribers, s2)) {
            callSubscriber(subscribers[s2], originalMessage, data);
          }
        }
      }
      function createDeliveryFunction(message, data, immediateExceptions) {
        return function deliverNamespaced() {
          var topic = String(message), position = topic.lastIndexOf(".");
          deliverMessage(message, message, data, immediateExceptions);
          while (position !== -1) {
            topic = topic.substr(0, position);
            position = topic.lastIndexOf(".");
            deliverMessage(message, topic, data, immediateExceptions);
          }
          deliverMessage(message, ALL_SUBSCRIBING_MSG, data, immediateExceptions);
        };
      }
      function hasDirectSubscribersFor(message) {
        var topic = String(message), found = Boolean(Object.prototype.hasOwnProperty.call(messages, topic) && hasKeys(messages[topic]));
        return found;
      }
      function messageHasSubscribers(message) {
        var topic = String(message), found = hasDirectSubscribersFor(topic) || hasDirectSubscribersFor(ALL_SUBSCRIBING_MSG), position = topic.lastIndexOf(".");
        while (!found && position !== -1) {
          topic = topic.substr(0, position);
          position = topic.lastIndexOf(".");
          found = hasDirectSubscribersFor(topic);
        }
        return found;
      }
      function publish(message, data, sync, immediateExceptions) {
        message = typeof message === "symbol" ? message.toString() : message;
        var deliver = createDeliveryFunction(message, data, immediateExceptions), hasSubscribers = messageHasSubscribers(message);
        if (!hasSubscribers) {
          return false;
        }
        if (sync === true) {
          deliver();
        } else {
          setTimeout(deliver, 0);
        }
        return true;
      }
      PubSub2.publish = function(message, data) {
        return publish(message, data, false, PubSub2.immediateExceptions);
      };
      PubSub2.publishSync = function(message, data) {
        return publish(message, data, true, PubSub2.immediateExceptions);
      };
      PubSub2.subscribe = function(message, func) {
        if (typeof func !== "function") {
          return false;
        }
        message = typeof message === "symbol" ? message.toString() : message;
        if (!Object.prototype.hasOwnProperty.call(messages, message)) {
          messages[message] = {};
        }
        var token = "uid_" + String(++lastUid);
        messages[message][token] = func;
        return token;
      };
      PubSub2.subscribeAll = function(func) {
        return PubSub2.subscribe(ALL_SUBSCRIBING_MSG, func);
      };
      PubSub2.subscribeOnce = function(message, func) {
        var token = PubSub2.subscribe(message, function() {
          PubSub2.unsubscribe(token);
          func.apply(this, arguments);
        });
        return PubSub2;
      };
      PubSub2.clearAllSubscriptions = function clearAllSubscriptions() {
        messages = {};
      };
      PubSub2.clearSubscriptions = function clearSubscriptions(topic) {
        var m;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            delete messages[m];
          }
        }
      };
      PubSub2.countSubscriptions = function countSubscriptions(topic) {
        var m;
        var token;
        var count = 0;
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            for (token in messages[m]) {
              count++;
            }
            break;
          }
        }
        return count;
      };
      PubSub2.getSubscriptions = function getSubscriptions(topic) {
        var m;
        var list = [];
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m) && m.indexOf(topic) === 0) {
            list.push(m);
          }
        }
        return list;
      };
      PubSub2.unsubscribe = function(value) {
        var descendantTopicExists = function(topic) {
          var m2;
          for (m2 in messages) {
            if (Object.prototype.hasOwnProperty.call(messages, m2) && m2.indexOf(topic) === 0) {
              return true;
            }
          }
          return false;
        }, isTopic = typeof value === "string" && (Object.prototype.hasOwnProperty.call(messages, value) || descendantTopicExists(value)), isToken = !isTopic && typeof value === "string", isFunction = typeof value === "function", result = false, m, message, t2;
        if (isTopic) {
          PubSub2.clearSubscriptions(value);
          return;
        }
        for (m in messages) {
          if (Object.prototype.hasOwnProperty.call(messages, m)) {
            message = messages[m];
            if (isToken && message[value]) {
              delete message[value];
              result = value;
              break;
            }
            if (isFunction) {
              for (t2 in message) {
                if (Object.prototype.hasOwnProperty.call(message, t2) && message[t2] === value) {
                  delete message[t2];
                  result = true;
                }
              }
            }
          }
        }
        return result;
      };
    });
  }
});

// src/utils/body-lock.js
var BodyLock, body_lock_default;
var init_body_lock = __esm({
  "src/utils/body-lock.js"() {
    BodyLock = class {
      /**
       * lock the body to prevent scrolling.
       */
      lock() {
        const bodyElement = document.querySelector("body");
        bodyElement.classList.add("js-scroll-lock");
      }
      /**
       * unlock the scrolling of the body.
       */
      unlock() {
        const bodyElement = document.querySelector("body");
        bodyElement.classList.remove("js-scroll-lock");
      }
    };
    body_lock_default = new BodyLock();
  }
});

// src/extenders/surf-modal.js
var _hideOnClickOutside, hideOnClickOutside_fn, _addCloseEventListener, addCloseEventListener_fn, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn, _sendCustomEvent, sendCustomEvent_fn, SurfModal, surf_modal_default;
var init_surf_modal = __esm({
  "src/extenders/surf-modal.js"() {
    init_body_lock();
    SurfModal = class {
      constructor() {
        __privateAdd(this, _hideOnClickOutside);
        /**
         * Add close event listener
         */
        __privateAdd(this, _addCloseEventListener);
        /**
         * Get correct modal by target id
         *
         * @param {string} targetId
         *
         * @returns {element}
         */
        __privateAdd(this, _getCorrectModalByTargetId);
        __privateAdd(this, _sendCustomEvent);
      }
      /**
       * Open modal.
       */
      openModal(targetId, triggerElement, deeplinkTarget) {
        const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
        if (modal) {
          modal.classList.remove("initial-load");
          modal.classList.add("js-modal-open");
          modal.setAttribute("aria-hidden", "false");
          modal.setAttribute("aria-expanded", "true");
          __privateMethod(this, _addCloseEventListener, addCloseEventListener_fn).call(this, modal, targetId);
          __privateMethod(this, _hideOnClickOutside, hideOnClickOutside_fn).call(this, modal, targetId);
          body_lock_default.lock();
          __privateMethod(this, _sendCustomEvent, sendCustomEvent_fn).call(this, "open", targetId, triggerElement, deeplinkTarget);
        }
      }
      /**
       * Close modal.
       */
      closeModal(targetId) {
        const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
        if (modal) {
          modal.classList.remove("js-modal-open");
          modal.setAttribute("aria-hidden", "true");
          modal.setAttribute("aria-expanded", "false");
          body_lock_default.unlock();
          __privateMethod(this, _sendCustomEvent, sendCustomEvent_fn).call(this, "close", targetId);
        }
      }
      /**
       * Get current state of the cart modal.
       *
       * @returns {{state: string, isCartOpen: boolean}}
       */
      getCurrentState(targetId) {
        const modal = __privateMethod(this, _getCorrectModalByTargetId, getCorrectModalByTargetId_fn).call(this, targetId);
        if (modal.classList.contains("js-modal-open")) {
          return {
            state: "open",
            isModalOpen: true
          };
        } else {
          return {
            state: "closed",
            isModalOpen: false
          };
        }
      }
    };
    _hideOnClickOutside = new WeakSet();
    hideOnClickOutside_fn = function(modal, targetId) {
      const outsideClickListener = (event2) => {
        const target = event2.target;
        const allModalOpeners = document.querySelectorAll(".js-open-modal");
        const arrayAllModalOpeners = [...allModalOpeners];
        if (target !== modal && target.closest(".modal") || arrayAllModalOpeners.filter(
          (modalOpener) => modalOpener === target.closest(".js-open-modal")
        ).length !== 0) {
        } else {
          this.closeModal(targetId);
          removeClickListener();
        }
      };
      const removeClickListener = () => {
        document.removeEventListener("click", outsideClickListener);
      };
      document.addEventListener("click", outsideClickListener);
    };
    _addCloseEventListener = new WeakSet();
    addCloseEventListener_fn = function(modal, targetId) {
      const allCloseModalButtons = modal.querySelectorAll(".js-close-modal");
      const submitButton = modal.querySelector(".js-modal-submit");
      if (allCloseModalButtons) {
        allCloseModalButtons.forEach((closeModalButton2) => {
          const closeClick = () => {
            this.closeModal(targetId);
            removeClickListener();
          };
          const removeClickListener = () => {
            closeModalButton2.removeEventListener("click", closeClick);
          };
          closeModalButton2.addEventListener("click", () => {
            closeClick();
          });
        });
      }
      if (submitButton) {
        const closeClick = () => {
          this.closeModal(targetId);
          removeClickListener();
        };
        const removeClickListener = () => {
          closeModalButton.removeEventListener("click", closeClick);
        };
        submitButton.addEventListener("click", closeClick);
      }
    };
    _getCorrectModalByTargetId = new WeakSet();
    getCorrectModalByTargetId_fn = function(targetId) {
      const modalChild = document.querySelector(`#${targetId}`);
      const modalElement = modalChild ? modalChild.closest(".modal") : null;
      if (modalElement)
        return modalElement;
    };
    _sendCustomEvent = new WeakSet();
    sendCustomEvent_fn = function(state, targetId, triggerElement, deeplinkTarget) {
      const event2 = new CustomEvent("modal-state", {
        detail: {
          state,
          targetId: `${targetId}`,
          element: triggerElement ? triggerElement : null,
          deeplinkTarget
        }
      });
      document.dispatchEvent(event2);
    };
    surf_modal_default = SurfModal;
  }
});

// node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "node_modules/axios/lib/helpers/bind.js"(exports, module) {
    "use strict";
    module.exports = function bind(fn, thisArg) {
      return function wrap3() {
        var args = new Array(arguments.length);
        for (var i2 = 0; i2 < args.length; i2++) {
          args[i2] = arguments[i2];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "node_modules/axios/lib/utils.js"(exports, module) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    function isArray(val) {
      return toString.call(val) === "[object Array]";
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    function isArrayBuffer(val) {
      return toString.call(val) === "[object ArrayBuffer]";
    }
    function isFormData(val) {
      return typeof FormData !== "undefined" && val instanceof FormData;
    }
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && val.buffer instanceof ArrayBuffer;
      }
      return result;
    }
    function isString(val) {
      return typeof val === "string";
    }
    function isNumber(val) {
      return typeof val === "number";
    }
    function isObject(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject(val) {
      if (toString.call(val) !== "[object Object]") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    function isDate(val) {
      return toString.call(val) === "[object Date]";
    }
    function isFile(val) {
      return toString.call(val) === "[object File]";
    }
    function isBlob(val) {
      return toString.call(val) === "[object Blob]";
    }
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject(val) && isFunction(val.pipe);
    }
    function isURLSearchParams(val) {
      return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
    }
    function trim(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i2 = 0, l = obj.length; i2 < l; i2++) {
          fn.call(null, obj[i2], i2, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject(result[key]) && isPlainObject(val)) {
          result[key] = merge(result[key], val);
        } else if (isPlainObject(val)) {
          result[key] = merge({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i2 = 0, l = arguments.length; i2 < l; i2++) {
        forEach(arguments[i2], assignValue);
      }
      return result;
    }
    function extend(a2, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a2[key] = bind(val, thisArg);
        } else {
          a2[key] = val;
        }
      });
      return a2;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    module.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString,
      isNumber,
      isObject,
      isPlainObject,
      isUndefined,
      isDate,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge,
      extend,
      trim,
      stripBOM
    };
  }
});

// node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "node_modules/axios/lib/helpers/buildURL.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module.exports = function buildURL(url, params, paramsSerializer) {
      if (!params) {
        return url;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) {
          url = url.slice(0, hashmarkIndex);
        }
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url;
    };
  }
});

// node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "node_modules/axios/lib/core/InterceptorManager.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module.exports = InterceptorManager;
  }
});

// node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// node_modules/axios/lib/core/enhanceError.js
var require_enhanceError = __commonJS({
  "node_modules/axios/lib/core/enhanceError.js"(exports, module) {
    "use strict";
    module.exports = function enhanceError(error, config3, code, request, response) {
      error.config = config3;
      if (code) {
        error.code = code;
      }
      error.request = request;
      error.response = response;
      error.isAxiosError = true;
      error.toJSON = function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      };
      return error;
    };
  }
});

// node_modules/axios/lib/core/createError.js
var require_createError = __commonJS({
  "node_modules/axios/lib/core/createError.js"(exports, module) {
    "use strict";
    var enhanceError = require_enhanceError();
    module.exports = function createError(message, config3, code, request, response) {
      var error = new Error(message);
      return enhanceError(error, config3, code, request, response);
    };
  }
});

// node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "node_modules/axios/lib/core/settle.js"(exports, module) {
    "use strict";
    var createError = require_createError();
    module.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(createError(
          "Request failed with status code " + response.status,
          response.config,
          null,
          response.request,
          response
        ));
      }
    };
  }
});

// node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "node_modules/axios/lib/helpers/cookies.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      /* @__PURE__ */ function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path)) {
              cookie.push("path=" + path);
            }
            if (utils.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove() {
          }
        };
      }()
    );
  }
});

// node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module) {
    "use strict";
    module.exports = function isAbsoluteURL(url) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
    };
  }
});

// node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "node_modules/axios/lib/helpers/combineURLs.js"(exports, module) {
    "use strict";
    module.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "node_modules/axios/lib/core/buildFullPath.js"(exports, module) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "node_modules/axios/lib/helpers/parseHeaders.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i2;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line) {
        i2 = line.indexOf(":");
        key = utils.trim(line.substr(0, i2)).toLowerCase();
        val = utils.trim(line.substr(i2 + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url) {
          var href = url;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      /* @__PURE__ */ function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// node_modules/axios/lib/cancel/Cancel.js
var require_Cancel = __commonJS({
  "node_modules/axios/lib/cancel/Cancel.js"(exports, module) {
    "use strict";
    function Cancel(message) {
      this.message = message;
    }
    Cancel.prototype.toString = function toString() {
      return "Cancel" + (this.message ? ": " + this.message : "");
    };
    Cancel.prototype.__CANCEL__ = true;
    module.exports = Cancel;
  }
});

// node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "node_modules/axios/lib/adapters/xhr.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var createError = require_createError();
    var defaults2 = require_defaults();
    var Cancel = require_Cancel();
    module.exports = function xhrAdapter(config3) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config3.data;
        var requestHeaders = config3.headers;
        var responseType = config3.responseType;
        var onCanceled;
        function done() {
          if (config3.cancelToken) {
            config3.cancelToken.unsubscribe(onCanceled);
          }
          if (config3.signal) {
            config3.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData)) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config3.auth) {
          var username = config3.auth.username || "";
          var password = config3.auth.password ? unescape(encodeURIComponent(config3.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config3.baseURL, config3.url);
        request.open(config3.method.toUpperCase(), buildURL(fullPath, config3.params, config3.paramsSerializer), true);
        request.timeout = config3.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config: config3,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(createError("Request aborted", config3, "ECONNABORTED", request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(createError("Network Error", config3, null, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config3.timeout ? "timeout of " + config3.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config3.transitional || defaults2.transitional;
          if (config3.timeoutErrorMessage) {
            timeoutErrorMessage = config3.timeoutErrorMessage;
          }
          reject(createError(
            timeoutErrorMessage,
            config3,
            transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config3.withCredentials || isURLSameOrigin(fullPath)) && config3.xsrfCookieName ? cookies.read(config3.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config3.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config3.withCredentials)) {
          request.withCredentials = !!config3.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config3.responseType;
        }
        if (typeof config3.onDownloadProgress === "function") {
          request.addEventListener("progress", config3.onDownloadProgress);
        }
        if (typeof config3.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config3.onUploadProgress);
        }
        if (config3.cancelToken || config3.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new Cancel("canceled") : cancel);
            request.abort();
            request = null;
          };
          config3.cancelToken && config3.cancelToken.subscribe(onCanceled);
          if (config3.signal) {
            config3.signal.aborted ? onCanceled() : config3.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        request.send(requestData);
      });
    };
  }
});

// node_modules/axios/lib/defaults.js
var require_defaults = __commonJS({
  "node_modules/axios/lib/defaults.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var enhanceError = require_enhanceError();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_xhr();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e2) {
          if (e2.name !== "SyntaxError") {
            throw e2;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults2 = {
      transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
      },
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        if (utils.isObject(data) || headers && headers["Content-Type"] === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults2.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e2) {
            if (strictJSONParsing) {
              if (e2.name === "SyntaxError") {
                throw enhanceError(e2, this, "E_JSON_PARSE");
              }
              throw e2;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method) {
      defaults2.headers[method] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      defaults2.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module.exports = defaults2;
  }
});

// node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "node_modules/axios/lib/core/transformData.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var defaults2 = require_defaults();
    module.exports = function transformData(data, headers, fns) {
      var context = this || defaults2;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "node_modules/axios/lib/cancel/isCancel.js"(exports, module) {
    "use strict";
    module.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "node_modules/axios/lib/core/dispatchRequest.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults2 = require_defaults();
    var Cancel = require_Cancel();
    function throwIfCancellationRequested(config3) {
      if (config3.cancelToken) {
        config3.cancelToken.throwIfRequested();
      }
      if (config3.signal && config3.signal.aborted) {
        throw new Cancel("canceled");
      }
    }
    module.exports = function dispatchRequest(config3) {
      throwIfCancellationRequested(config3);
      config3.headers = config3.headers || {};
      config3.data = transformData.call(
        config3,
        config3.data,
        config3.headers,
        config3.transformRequest
      );
      config3.headers = utils.merge(
        config3.headers.common || {},
        config3.headers[config3.method] || {},
        config3.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method) {
          delete config3.headers[method];
        }
      );
      var adapter = config3.adapter || defaults2.adapter;
      return adapter(config3).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config3);
        response.data = transformData.call(
          config3,
          response.data,
          response.headers,
          config3.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config3);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config3,
              reason.response.data,
              reason.response.headers,
              config3.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "node_modules/axios/lib/core/mergeConfig.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    module.exports = function mergeConfig(config1, config22) {
      config22 = config22 || {};
      var config3 = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config22[prop])) {
          return getMergedValue(config1[prop], config22[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config22[prop])) {
          return getMergedValue(void 0, config22[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config22[prop])) {
          return getMergedValue(void 0, config22[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config22) {
          return getMergedValue(config1[prop], config22[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config22)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        utils.isUndefined(configValue) && merge !== mergeDirectKeys || (config3[prop] = configValue);
      });
      return config3;
    };
  }
});

// node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "node_modules/axios/lib/env/data.js"(exports, module) {
    module.exports = {
      "version": "0.24.0"
    };
  }
});

// node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "node_modules/axios/lib/helpers/validator.js"(exports, module) {
    "use strict";
    var VERSION = require_data().version;
    var validators = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type, i2) {
      validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i2 < 1 ? "n " : " ") + type;
      };
    });
    var deprecatedWarnings = {};
    validators.transitional = function transitional(validator, version, message) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new Error(formatMessage(opt, " has been removed" + (version ? " in " + version : "")));
        }
        if (version && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new TypeError("options must be an object");
      }
      var keys = Object.keys(options);
      var i2 = keys.length;
      while (i2-- > 0) {
        var opt = keys[i2];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new TypeError("option " + opt + " must be " + result);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw Error("Unknown option " + opt);
        }
      }
    }
    module.exports = {
      assertOptions,
      validators
    };
  }
});

// node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "node_modules/axios/lib/core/Axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig = require_mergeConfig();
    var validator = require_validator();
    var validators = validator.validators;
    function Axios(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios.prototype.request = function request(config3) {
      if (typeof config3 === "string") {
        config3 = arguments[1] || {};
        config3.url = arguments[0];
      } else {
        config3 = config3 || {};
      }
      config3 = mergeConfig(this.defaults, config3);
      if (config3.method) {
        config3.method = config3.method.toLowerCase();
      } else if (this.defaults.method) {
        config3.method = this.defaults.method.toLowerCase();
      } else {
        config3.method = "get";
      }
      var transitional = config3.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators.transitional(validators.boolean),
          forcedJSONParsing: validators.transitional(validators.boolean),
          clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config3) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config3);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config3;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios.prototype.getUri = function getUri(config3) {
      config3 = mergeConfig(this.defaults, config3);
      return buildURL(config3.url, config3.params, config3.paramsSerializer).replace(/^\?/, "");
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
      Axios.prototype[method] = function(url, config3) {
        return this.request(mergeConfig(config3 || {}, {
          method,
          url,
          data: (config3 || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
      Axios.prototype[method] = function(url, data, config3) {
        return this.request(mergeConfig(config3 || {}, {
          method,
          url,
          data
        }));
      };
    });
    module.exports = Axios;
  }
});

// node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "node_modules/axios/lib/cancel/CancelToken.js"(exports, module) {
    "use strict";
    var Cancel = require_Cancel();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token = this;
      this.promise.then(function(cancel) {
        if (!token._listeners)
          return;
        var i2;
        var l = token._listeners.length;
        for (i2 = 0; i2 < l; i2++) {
          token._listeners[i2](cancel);
        }
        token._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message) {
        if (token.reason) {
          return;
        }
        token.reason = new Cancel(message);
        resolvePromise(token.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index = this._listeners.indexOf(listener);
      if (index !== -1) {
        this._listeners.splice(index, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token = new CancelToken(function executor(c2) {
        cancel = c2;
      });
      return {
        token,
        cancel
      };
    };
    module.exports = CancelToken;
  }
});

// node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "node_modules/axios/lib/helpers/spread.js"(exports, module) {
    "use strict";
    module.exports = function spread(callback) {
      return function wrap3(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "node_modules/axios/lib/helpers/isAxiosError.js"(exports, module) {
    "use strict";
    module.exports = function isAxiosError(payload) {
      return typeof payload === "object" && payload.isAxiosError === true;
    };
  }
});

// node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "node_modules/axios/lib/axios.js"(exports, module) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios = require_Axios();
    var mergeConfig = require_mergeConfig();
    var defaults2 = require_defaults();
    function createInstance(defaultConfig) {
      var context = new Axios(defaultConfig);
      var instance = bind(Axios.prototype.request, context);
      utils.extend(instance, Axios.prototype, context);
      utils.extend(instance, context);
      instance.create = function create(instanceConfig) {
        return createInstance(mergeConfig(defaultConfig, instanceConfig));
      };
      return instance;
    }
    var axios3 = createInstance(defaults2);
    axios3.Axios = Axios;
    axios3.Cancel = require_Cancel();
    axios3.CancelToken = require_CancelToken();
    axios3.isCancel = require_isCancel();
    axios3.VERSION = require_data().version;
    axios3.all = function all(promises) {
      return Promise.all(promises);
    };
    axios3.spread = require_spread();
    axios3.isAxiosError = require_isAxiosError();
    module.exports = axios3;
    module.exports.default = axios3;
  }
});

// node_modules/axios/index.js
var require_axios2 = __commonJS({
  "node_modules/axios/index.js"(exports, module) {
    module.exports = require_axios();
  }
});

// src/components/cart-notification-state.js
var cartNotification, cart_notification_state_default;
var init_cart_notification_state = __esm({
  "src/components/cart-notification-state.js"() {
    cartNotification = class {
      /**
       * Show cart notification.
       */
      showNotification() {
        const cartNotificationModal = document.querySelector(".cart-notification");
        const iconCartBubbleElement = document.querySelector(".icon-cart");
        cartNotificationModal.classList.add("js-modal-open");
        if (iconCartBubbleElement) {
          iconCartBubbleElement.classList.add("js-active");
        }
        setTimeout(this.closeNotification, 3e3);
      }
      /**
       * Close cart notification.
       */
      closeNotification() {
        const cartNotificationModal = document.querySelector(".cart-notification");
        const iconCartBubbleElement = document.querySelector(".icon-cart");
        cartNotificationModal.classList.remove("js-modal-open");
        if (iconCartBubbleElement) {
          iconCartBubbleElement.classList.remove("js-active");
        }
      }
    };
    cart_notification_state_default = new cartNotification();
  }
});

// src/utils/get-sections.js
var getCartSectionsToRender;
var init_get_sections = __esm({
  "src/utils/get-sections.js"() {
    getCartSectionsToRender = (productId) => [
      {
        id: "cart-items",
        section: "cart-items",
        selector: "#cart-items"
      },
      {
        id: "cart-item-counter",
        section: "cart-item-counter",
        selector: "#cart-item-counter"
      },
      {
        id: "cart-summary",
        section: "cart-summary",
        selector: "#cart-summary"
      },
      {
        id: "cart-notification-product",
        section: "cart-notification-product",
        selector: `#cart-notification-product-${productId}`
      }
    ];
  }
});

// src/utils/section-injection.js
var getSectionFromHTML, createElementFromString;
var init_section_injection = __esm({
  "src/utils/section-injection.js"() {
    getSectionFromHTML = (html, selector3) => {
      if (html) {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector3).innerHTML;
      }
    };
    createElementFromString = (string) => {
      if (string) {
        return new DOMParser().parseFromString(string, "text/html").body.childNodes[0];
      }
    };
  }
});

// src/components/cart-state.js
var cart_state_exports = {};
__export(cart_state_exports, {
  handleChangeCart: () => handleChangeCart
});
var handleChangeCart;
var init_cart_state = __esm({
  "src/components/cart-state.js"() {
    init_cart_notification_state();
    init_surf_modal();
    init_get_sections();
    init_section_injection();
    handleChangeCart = (responseData) => {
      const targetId = "cart";
      const baseModal = new surf_modal_default();
      const isCartModalOpen = baseModal.getCurrentState(targetId);
      if (isCartModalOpen.isModalOpen === false) {
        cart_notification_state_default.showNotification();
        setTimeout(() => {
          baseModal.openModal(targetId);
        }, 1e3);
      }
      getCartSectionsToRender().forEach((section) => {
        if (section.id === "cart-notification-product") {
          const productId = responseData.id || responseData.items[responseData.items.length - 1].id;
          if (productId) {
            getCartSectionsToRender(productId).forEach((section2) => {
              const sectionElement = document.getElementById(section2.id);
              if (sectionElement != null) {
                sectionElement.innerHTML = getSectionFromHTML(
                  responseData.sections[section2.id],
                  section2.selector
                );
              }
            });
          }
        } else {
          const elementToReplace = document.querySelectorAll(section.selector) || document.getElementById(section.id).querySelector(section.selector);
          if (elementToReplace !== null) {
            elementToReplace.forEach((element) => {
              element.innerHTML = getSectionFromHTML(
                responseData.sections[section.section],
                section.selector
              );
            });
          }
        }
      });
    };
  }
});

// node_modules/marquee3000/marquee3k.js
var require_marquee3k = __commonJS({
  "node_modules/marquee3000/marquee3k.js"(exports, module) {
    ;
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof exports === "object") {
        module.exports = factory();
      } else {
        root.Marquee3k = factory();
      }
    })(exports, function() {
      "use strict";
      let animationId = 0;
      class Marquee3k2 {
        constructor(element, options) {
          this.element = element;
          this.selector = options.selector;
          this.speed = element.dataset.speed || 0.25;
          this.pausable = element.dataset.pausable;
          this.reverse = element.dataset.reverse;
          this.paused = false;
          this.parent = element.parentElement;
          this.parentProps = this.parent.getBoundingClientRect();
          this.content = element.children[0];
          this.innerContent = this.content.innerHTML;
          this.wrapStyles = "";
          this.offset = 0;
          this._setupWrapper();
          this._setupContent();
          this._setupEvents();
          this.wrapper.appendChild(this.content);
          this.element.appendChild(this.wrapper);
        }
        _setupWrapper() {
          this.wrapper = document.createElement("div");
          this.wrapper.classList.add("marquee3k__wrapper");
          this.wrapper.style.whiteSpace = "nowrap";
        }
        _setupContent() {
          this.content.classList.add(`${this.selector}__copy`);
          this.content.style.display = "inline-block";
          this.contentWidth = this.content.offsetWidth;
          this.requiredReps = this.contentWidth > this.parentProps.width ? 2 : Math.ceil((this.parentProps.width - this.contentWidth) / this.contentWidth) + 1;
          for (let i2 = 0; i2 < this.requiredReps; i2++) {
            this._createClone();
          }
          if (this.reverse) {
            this.offset = this.contentWidth * -1;
          }
          this.element.classList.add("is-init");
        }
        _setupEvents() {
          this.element.addEventListener("mouseenter", () => {
            if (this.pausable)
              this.paused = true;
          });
          this.element.addEventListener("mouseleave", () => {
            if (this.pausable)
              this.paused = false;
          });
        }
        _createClone() {
          const clone = this.content.cloneNode(true);
          clone.style.display = "inline-block";
          clone.classList.add(`${this.selector}__copy`);
          this.wrapper.appendChild(clone);
        }
        animate() {
          if (!this.paused) {
            const isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1;
            const direction = this.reverse ? -1 : 1;
            const reset = this.reverse ? this.contentWidth * -1 : 0;
            if (isScrolled)
              this.offset -= this.speed * direction;
            else
              this.offset = reset;
            this.wrapper.style.whiteSpace = "nowrap";
            this.wrapper.style.transform = `translate(${this.offset}px, 0) translateZ(0)`;
          }
        }
        _refresh() {
          this.contentWidth = this.content.offsetWidth;
        }
        repopulate(difference, isLarger) {
          this.contentWidth = this.content.offsetWidth;
          if (isLarger) {
            const amount = Math.ceil(difference / this.contentWidth) + 1;
            for (let i2 = 0; i2 < amount; i2++) {
              this._createClone();
            }
          }
        }
        static refresh(index) {
          MARQUEES[index]._refresh();
        }
        static pause(index) {
          MARQUEES[index].paused = true;
        }
        static play(index) {
          MARQUEES[index].paused = false;
        }
        static toggle(index) {
          MARQUEES[index].paused = !MARQUEES[index].paused;
        }
        static refreshAll() {
          for (let i2 = 0; i2 < MARQUEES.length; i2++) {
            MARQUEES[i2]._refresh();
          }
        }
        static pauseAll() {
          for (let i2 = 0; i2 < MARQUEES.length; i2++) {
            MARQUEES[i2].paused = true;
          }
        }
        static playAll() {
          for (let i2 = 0; i2 < MARQUEES.length; i2++) {
            MARQUEES[i2].paused = false;
          }
        }
        static toggleAll() {
          for (let i2 = 0; i2 < MARQUEES.length; i2++) {
            MARQUEES[i2].paused = !MARQUEES[i2].paused;
          }
        }
        static init(options = { selector: "marquee3k" }) {
          if (animationId)
            window.cancelAnimationFrame(animationId);
          window.MARQUEES = [];
          const marquees = Array.from(document.querySelectorAll(`.${options.selector}`));
          let previousWidth = window.innerWidth;
          let timer;
          for (let i2 = 0; i2 < marquees.length; i2++) {
            const marquee = marquees[i2];
            const instance = new Marquee3k2(marquee, options);
            MARQUEES.push(instance);
          }
          animate();
          function animate() {
            for (let i2 = 0; i2 < MARQUEES.length; i2++) {
              MARQUEES[i2].animate();
            }
            animationId = window.requestAnimationFrame(animate);
          }
          window.addEventListener("resize", () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
              const isLarger = previousWidth < window.innerWidth;
              const difference = window.innerWidth - previousWidth;
              for (let i2 = 0; i2 < MARQUEES.length; i2++) {
                MARQUEES[i2].repopulate(difference, isLarger);
              }
              previousWidth = this.innerWidth;
            }, 250);
          });
        }
      }
      return Marquee3k2;
    });
  }
});

// src/templates/product-media-slide.js
var createProductMediaSlider = (image, baseImage, color, index) => {
  let enableLazyLoading = true;
  if (index === 0) {
    enableLazyLoading = false;
  }
  return `
  <div class="slide" data-index="${index}">
    <product-detail-image>
      <figure>

        <div class="image-holder">
          <img
              src="${baseImage}"
              srcset="
                ${insertImageFormat(image, "_550x550")} 550w,
                ${insertImageFormat(image, "_1100x1100")} 1100w,
                ${insertImageFormat(image, "_1445x1445")} 1445w,
                ${insertImageFormat(image, "_1680x1680")} 1680w,
                ${insertImageFormat(image, "_2048x2048")} 2048w,
                ${baseImage} 613w
              "
              sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
              ${enableLazyLoading ? 'loading="lazy"' : ""}
              height="420"
              width="320"
              alt="${color}"
          >
        </div>
      </figure>
    </product-detail-image>

  </div>
`;
};
var createProductMediaThumbnail = (thumbnailImage, color, index) => `
  <div class="slide" data-index="${index}">
    <div class="image-holder">
      <img
        src="${thumbnailImage}"
        loading="lazy"
        height="40px"
        width="30px"
        alt="${color}"
      >
    </div>

  </div>
`;

// src/utils/type-check.js
var returnArrayOrNull = (inputValue) => {
  if (Array.isArray(inputValue)) {
    if (inputValue.length > 0) {
      return inputValue;
    }
  }
  return null;
};
var returnStringOrNull = (inputValue) => {
  if (inputValue === "null") {
    return null;
  }
  if (typeof inputValue === "string") {
    if (inputValue.length > 0) {
      return inputValue;
    }
  }
  return null;
};
var returnNumberOrNull = (inputValue) => {
  if (typeof inputValue === "number") {
    return inputValue;
  }
  return null;
};
var returnObjectOrNull = (inputValue) => {
  if (typeof inputValue === "object") {
    if (inputValue !== null) {
      return inputValue;
    }
  }
  return null;
};
var returnBooleanOrNull = (inputValue) => {
  if (typeof inputValue === "boolean") {
    return inputValue;
  }
  return null;
};

// node_modules/gsap/gsap-core.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var _config = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, _defaults = {
  duration: 0.5,
  overwrite: false,
  delay: 0
}, _suppressOverwrites, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString2(value) {
  return typeof value === "string";
}, _isFunction = function _isFunction2(value) {
  return typeof value === "function";
}, _isNumber = function _isNumber2(value) {
  return typeof value === "number";
}, _isUndefined = function _isUndefined2(value) {
  return typeof value === "undefined";
}, _isObject = function _isObject2(value) {
  return typeof value === "object";
}, _isNotFalse = function _isNotFalse2(value) {
  return value !== false;
}, _windowExists = function _windowExists2() {
  return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString2(value) {
  return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {
}, _isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, _relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, _unitExp = /[\d.+\-=]+(?:e[-+]\d*)*/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install2(scope) {
  return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin2(property, value) {
  return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn2(message, suppress) {
  return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal2(name, obj) {
  return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc2() {
  return 0;
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness2(targets) {
  var target = targets[0], harnessPlugin, i2;
  _isObject(target) || _isFunction(target) || (targets = [targets]);
  if (!(harnessPlugin = (target._gsap || {}).harness)) {
    i2 = _harnessPlugins.length;
    while (i2-- && !_harnessPlugins[i2].targetTest(target)) {
    }
    harnessPlugin = _harnessPlugins[i2];
  }
  i2 = targets.length;
  while (i2--) {
    targets[i2] && (targets[i2]._gsap || (targets[i2]._gsap = new GSCache(targets[i2], harnessPlugin))) || targets.splice(i2, 1);
  }
  return targets;
}, _getCache = function _getCache2(target) {
  return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty2(target, property, v) {
  return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName2(names, func) {
  return (names = names.split(",")).forEach(func) || names;
}, _round = function _round2(value) {
  return Math.round(value * 1e5) / 1e5 || 0;
}, _roundPrecise = function _roundPrecise2(value) {
  return Math.round(value * 1e7) / 1e7 || 0;
}, _arrayContainsAny = function _arrayContainsAny2(toSearch, toFind) {
  var l = toFind.length, i2 = 0;
  for (; toSearch.indexOf(toFind[i2]) < 0 && ++i2 < l; ) {
  }
  return i2 < l;
}, _lazyRender = function _lazyRender2() {
  var l = _lazyTweens.length, a2 = _lazyTweens.slice(0), i2, tween;
  _lazyLookup = {};
  _lazyTweens.length = 0;
  for (i2 = 0; i2 < l; i2++) {
    tween = a2[i2];
    tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
  }
}, _lazySafeRender = function _lazySafeRender2(animation, time, suppressEvents, force) {
  _lazyTweens.length && _lazyRender();
  animation.render(time, suppressEvents, force);
  _lazyTweens.length && _lazyRender();
}, _numericIfPossible = function _numericIfPossible2(value) {
  var n2 = parseFloat(value);
  return (n2 || n2 === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n2 : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough2(p) {
  return p;
}, _setDefaults = function _setDefaults2(obj, defaults2) {
  for (var p in defaults2) {
    p in obj || (obj[p] = defaults2[p]);
  }
  return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults2(excludeDuration) {
  return function(obj, defaults2) {
    for (var p in defaults2) {
      p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults2[p]);
    }
  };
}, _merge = function _merge2(base, toMerge) {
  for (var p in toMerge) {
    base[p] = toMerge[p];
  }
  return base;
}, _mergeDeep = function _mergeDeep2(base, toMerge) {
  for (var p in toMerge) {
    p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep2(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
  }
  return base;
}, _copyExcluding = function _copyExcluding2(obj, excluding) {
  var copy = {}, p;
  for (p in obj) {
    p in excluding || (copy[p] = obj[p]);
  }
  return copy;
}, _inheritDefaults = function _inheritDefaults2(vars) {
  var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
  if (_isNotFalse(vars.inherit)) {
    while (parent) {
      func(vars, parent.vars.defaults);
      parent = parent.parent || parent._dp;
    }
  }
  return vars;
}, _arraysMatch = function _arraysMatch2(a1, a2) {
  var i2 = a1.length, match = i2 === a2.length;
  while (match && i2-- && a1[i2] === a2[i2]) {
  }
  return i2 < 0;
}, _addLinkedListItem = function _addLinkedListItem2(parent, child, firstProp, lastProp, sortBy) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }
  if (lastProp === void 0) {
    lastProp = "_last";
  }
  var prev = parent[lastProp], t2;
  if (sortBy) {
    t2 = child[sortBy];
    while (prev && prev[sortBy] > t2) {
      prev = prev._prev;
    }
  }
  if (prev) {
    child._next = prev._next;
    prev._next = child;
  } else {
    child._next = parent[firstProp];
    parent[firstProp] = child;
  }
  if (child._next) {
    child._next._prev = child;
  } else {
    parent[lastProp] = child;
  }
  child._prev = prev;
  child.parent = child._dp = parent;
  return child;
}, _removeLinkedListItem = function _removeLinkedListItem2(parent, child, firstProp, lastProp) {
  if (firstProp === void 0) {
    firstProp = "_first";
  }
  if (lastProp === void 0) {
    lastProp = "_last";
  }
  var prev = child._prev, next = child._next;
  if (prev) {
    prev._next = next;
  } else if (parent[firstProp] === child) {
    parent[firstProp] = next;
  }
  if (next) {
    next._prev = prev;
  } else if (parent[lastProp] === child) {
    parent[lastProp] = prev;
  }
  child._next = child._prev = child.parent = null;
}, _removeFromParent = function _removeFromParent2(child, onlyIfParentHasAutoRemove) {
  child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove(child);
  child._act = 0;
}, _uncache = function _uncache2(animation, child) {
  if (animation && (!child || child._end > animation._dur || child._start < 0)) {
    var a2 = animation;
    while (a2) {
      a2._dirty = 1;
      a2 = a2.parent;
    }
  }
  return animation;
}, _recacheAncestors = function _recacheAncestors2(animation) {
  var parent = animation.parent;
  while (parent && parent.parent) {
    parent._dirty = 1;
    parent.totalDuration();
    parent = parent.parent;
  }
  return animation;
}, _hasNoPausedAncestors = function _hasNoPausedAncestors2(animation) {
  return !animation || animation._ts && _hasNoPausedAncestors2(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration2(animation) {
  return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, _animationCycle = function _animationCycle2(tTime, cycleDuration) {
  var whole = Math.floor(tTime /= cycleDuration);
  return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime2(parentTime, child) {
  return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd2(animation) {
  return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead2(animation, totalTime) {
  var parent = animation._dp;
  if (parent && parent.smoothChildTiming && animation._ts) {
    animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
    _setEnd(animation);
    parent._dirty || _uncache(parent, animation);
  }
  return animation;
}, _postAddChecks = function _postAddChecks2(timeline2, child) {
  var t2;
  if (child._time || child._initted && !child._dur) {
    t2 = _parentToChildTotalTime(timeline2.rawTime(), child);
    if (!child._dur || _clamp(0, child.totalDuration(), t2) - child._tTime > _tinyNum) {
      child.render(t2, true);
    }
  }
  if (_uncache(timeline2, child)._dp && timeline2._initted && timeline2._time >= timeline2._dur && timeline2._ts) {
    if (timeline2._dur < timeline2.duration()) {
      t2 = timeline2;
      while (t2._dp) {
        t2.rawTime() >= 0 && t2.totalTime(t2._tTime);
        t2 = t2._dp;
      }
    }
    timeline2._zTime = -_tinyNum;
  }
}, _addToTimeline = function _addToTimeline2(timeline2, child, position, skipChecks) {
  child.parent && _removeFromParent(child);
  child._start = _roundPrecise((_isNumber(position) ? position : position || timeline2 !== _globalTimeline ? _parsePosition(timeline2, position, child) : timeline2._time) + child._delay);
  child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
  _addLinkedListItem(timeline2, child, "_first", "_last", timeline2._sort ? "_start" : 0);
  _isFromOrFromStart(child) || (timeline2._recent = child);
  skipChecks || _postAddChecks(timeline2, child);
  return timeline2;
}, _scrollTrigger = function _scrollTrigger2(animation, trigger) {
  return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween2(tween, totalTime, force, suppressEvents) {
  _initTween(tween, totalTime);
  if (!tween._initted) {
    return 1;
  }
  if (!force && tween._pt && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
    _lazyTweens.push(tween);
    tween._lazy = [totalTime, suppressEvents];
    return 1;
  }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart2(_ref) {
  var parent = _ref.parent;
  return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart2(parent));
}, _isFromOrFromStart = function _isFromOrFromStart2(_ref2) {
  var data = _ref2.data;
  return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween2(tween, totalTime, suppressEvents, force) {
  var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
  if (repeatDelay && tween._repeat) {
    tTime = _clamp(0, tween._tDur, totalTime);
    iteration = _animationCycle(tTime, repeatDelay);
    tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
    if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
      prevRatio = 1 - ratio;
      tween.vars.repeatRefresh && tween._initted && tween.invalidate();
    }
  }
  if (ratio !== prevRatio || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
    if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents)) {
      return;
    }
    prevIteration = tween._zTime;
    tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
    suppressEvents || (suppressEvents = totalTime && !prevIteration);
    tween.ratio = ratio;
    tween._from && (ratio = 1 - ratio);
    tween._time = 0;
    tween._tTime = tTime;
    pt = tween._pt;
    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
    tween._startAt && totalTime < 0 && tween._startAt.render(totalTime, true, true);
    tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
    tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
    if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
      ratio && _removeFromParent(tween, 1);
      if (!suppressEvents) {
        _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
        tween._prom && tween._prom();
      }
    }
  } else if (!tween._zTime) {
    tween._zTime = totalTime;
  }
}, _findNextPauseTween = function _findNextPauseTween2(animation, prevTime, time) {
  var child;
  if (time > prevTime) {
    child = animation._first;
    while (child && child._start <= time) {
      if (child.data === "isPause" && child._start > prevTime) {
        return child;
      }
      child = child._next;
    }
  } else {
    child = animation._last;
    while (child && child._start >= time) {
      if (child.data === "isPause" && child._start < prevTime) {
        return child;
      }
      child = child._prev;
    }
  }
}, _setDuration = function _setDuration2(animation, duration2, skipUncache, leavePlayhead) {
  var repeat = animation._repeat, dur = _roundPrecise(duration2) || 0, totalProgress = animation._tTime / animation._tDur;
  totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
  animation._dur = dur;
  animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
  totalProgress > 0 && !leavePlayhead ? _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress) : animation.parent && _setEnd(animation);
  skipUncache || _uncache(animation.parent, animation);
  return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration2(animation) {
  return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
  _start: 0,
  endTime: _emptyFunc,
  totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition2(animation, position, percentAnimation) {
  var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, i2, offset, isPercent;
  if (_isString(position) && (isNaN(position) || position in labels)) {
    offset = position.charAt(0);
    isPercent = position.substr(-1) === "%";
    i2 = position.indexOf("=");
    if (offset === "<" || offset === ">") {
      i2 >= 0 && (position = position.replace(/=/, ""));
      return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i2 < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
    }
    if (i2 < 0) {
      position in labels || (labels[position] = clippedDuration);
      return labels[position];
    }
    offset = parseFloat(position.charAt(i2 - 1) + position.substr(i2 + 1));
    if (isPercent && percentAnimation) {
      offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
    }
    return i2 > 1 ? _parsePosition2(animation, position.substr(0, i2 - 1), percentAnimation) + offset : clippedDuration + offset;
  }
  return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType2(type, params, timeline2) {
  var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
  isLegacy && (vars.duration = params[1]);
  vars.parent = timeline2;
  if (type) {
    irVars = vars;
    parent = timeline2;
    while (parent && !("immediateRender" in irVars)) {
      irVars = parent.vars.defaults || {};
      parent = _isNotFalse(parent.vars.inherit) && parent.parent;
    }
    vars.immediateRender = _isNotFalse(irVars.immediateRender);
    type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1];
  }
  return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn2(value, func) {
  return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp2(min, max, value) {
  return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit2(value, v) {
  return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : value.substr(v.index + v[0].length);
}, clamp = function clamp2(min, max, value) {
  return _conditionalReturn(value, function(v) {
    return _clamp(min, max, v);
  });
}, _slice = [].slice, _isArrayLike = function _isArrayLike2(value, nonEmpty) {
  return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten2(ar, leaveStrings, accumulator) {
  if (accumulator === void 0) {
    accumulator = [];
  }
  return ar.forEach(function(value) {
    var _accumulator;
    return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
  }) || accumulator;
}, toArray = function toArray2(value, scope, leaveStrings) {
  return _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
}, selector = function selector2(value) {
  value = toArray(value)[0] || _warn("Invalid scope") || {};
  return function(v) {
    var el = value.current || value.nativeElement || value;
    return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
  };
}, shuffle = function shuffle2(a2) {
  return a2.sort(function() {
    return 0.5 - Math.random();
  });
}, distribute = function distribute2(v) {
  if (_isFunction(v)) {
    return v;
  }
  var vars = _isObject(v) ? v : {
    each: v
  }, ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
  if (_isString(from)) {
    ratioX = ratioY = {
      center: 0.5,
      edges: 0.5,
      end: 1
    }[from] || 0;
  } else if (!isDecimal && ratios) {
    ratioX = from[0];
    ratioY = from[1];
  }
  return function(i2, target, a2) {
    var l = (a2 || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
    if (!distances) {
      wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];
      if (!wrapAt) {
        max = -_bigNum;
        while (max < (max = a2[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {
        }
        wrapAt--;
      }
      distances = cache[l] = [];
      originX = ratios ? Math.min(wrapAt, l) * ratioX - 0.5 : from % wrapAt;
      originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - 0.5 : from / wrapAt | 0;
      max = 0;
      min = _bigNum;
      for (j = 0; j < l; j++) {
        x = j % wrapAt - originX;
        y = originY - (j / wrapAt | 0);
        distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
        d > max && (max = d);
        d < min && (min = d);
      }
      from === "random" && shuffle(distances);
      distances.max = max - min;
      distances.min = min;
      distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
      distances.b = l < 0 ? base - l : base;
      distances.u = getUnit(vars.amount || vars.each) || 0;
      ease = ease && l < 0 ? _invertEase(ease) : ease;
    }
    l = (distances[i2] - distances.min) / distances.max || 0;
    return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u;
  };
}, _roundModifier = function _roundModifier2(v) {
  var p = Math.pow(10, ((v + "").split(".")[1] || "").length);
  return function(raw) {
    var n2 = Math.round(parseFloat(raw) / v) * v * p;
    return (n2 - n2 % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw));
  };
}, snap = function snap2(snapTo, value) {
  var isArray = _isArray(snapTo), radius, is2D;
  if (!isArray && _isObject(snapTo)) {
    radius = isArray = snapTo.radius || _bigNum;
    if (snapTo.values) {
      snapTo = toArray(snapTo.values);
      if (is2D = !_isNumber(snapTo[0])) {
        radius *= radius;
      }
    } else {
      snapTo = _roundModifier(snapTo.increment);
    }
  }
  return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
    is2D = snapTo(raw);
    return Math.abs(is2D - raw) <= radius ? is2D : raw;
  } : function(raw) {
    var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i2 = snapTo.length, dx, dy;
    while (i2--) {
      if (is2D) {
        dx = snapTo[i2].x - x;
        dy = snapTo[i2].y - y;
        dx = dx * dx + dy * dy;
      } else {
        dx = Math.abs(snapTo[i2] - x);
      }
      if (dx < min) {
        min = dx;
        closest = i2;
      }
    }
    closest = !radius || min <= radius ? snapTo[closest] : raw;
    return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
  });
}, random = function random2(min, max, roundingIncrement, returnFunction) {
  return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function() {
    return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * 0.99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
  });
}, pipe = function pipe2() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }
  return function(value) {
    return functions.reduce(function(v, f2) {
      return f2(v);
    }, value);
  };
}, unitize = function unitize2(func, unit) {
  return function(value) {
    return func(parseFloat(value)) + (unit || getUnit(value));
  };
}, normalize = function normalize2(min, max, value) {
  return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray2(a2, wrapper, value) {
  return _conditionalReturn(value, function(index) {
    return a2[~~wrapper(index)];
  });
}, wrap = function wrap2(min, max, value) {
  var range = max - min;
  return _isArray(min) ? _wrapArray(min, wrap2(0, min.length), max) : _conditionalReturn(value, function(value2) {
    return (range + (value2 - min) % range) % range + min;
  });
}, wrapYoyo = function wrapYoyo2(min, max, value) {
  var range = max - min, total = range * 2;
  return _isArray(min) ? _wrapArray(min, wrapYoyo2(0, min.length - 1), max) : _conditionalReturn(value, function(value2) {
    value2 = (total + (value2 - min) % total) % total || 0;
    return min + (value2 > range ? total - value2 : value2);
  });
}, _replaceRandom = function _replaceRandom2(value) {
  var prev = 0, s2 = "", i2, nums, end, isArray;
  while (~(i2 = value.indexOf("random(", prev))) {
    end = value.indexOf(")", i2);
    isArray = value.charAt(i2 + 7) === "[";
    nums = value.substr(i2 + 7, end - i2 - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
    s2 += value.substr(prev, i2 - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
    prev = end + 1;
  }
  return s2 + value.substr(prev, value.length - prev);
}, mapRange = function mapRange2(inMin, inMax, outMin, outMax, value) {
  var inRange = inMax - inMin, outRange = outMax - outMin;
  return _conditionalReturn(value, function(value2) {
    return outMin + ((value2 - inMin) / inRange * outRange || 0);
  });
}, interpolate = function interpolate2(start, end, progress, mutate) {
  var func = isNaN(start + end) ? 0 : function(p2) {
    return (1 - p2) * start + p2 * end;
  };
  if (!func) {
    var isString = _isString(start), master = {}, p, i2, interpolators, l, il;
    progress === true && (mutate = 1) && (progress = null);
    if (isString) {
      start = {
        p: start
      };
      end = {
        p: end
      };
    } else if (_isArray(start) && !_isArray(end)) {
      interpolators = [];
      l = start.length;
      il = l - 2;
      for (i2 = 1; i2 < l; i2++) {
        interpolators.push(interpolate2(start[i2 - 1], start[i2]));
      }
      l--;
      func = function func2(p2) {
        p2 *= l;
        var i3 = Math.min(il, ~~p2);
        return interpolators[i3](p2 - i3);
      };
      progress = end;
    } else if (!mutate) {
      start = _merge(_isArray(start) ? [] : {}, start);
    }
    if (!interpolators) {
      for (p in end) {
        _addPropTween.call(master, start, p, "get", end[p]);
      }
      func = function func2(p2) {
        return _renderPropTweens(p2, master) || (isString ? start.p : start);
      };
    }
  }
  return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection2(timeline2, fromTime, backward) {
  var labels = timeline2.labels, min = _bigNum, p, distance, label;
  for (p in labels) {
    distance = labels[p] - fromTime;
    if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
      label = p;
      min = distance;
    }
  }
  return label;
}, _callback = function _callback2(animation, type, executeLazyFirst) {
  var v = animation.vars, callback = v[type], params, scope;
  if (!callback) {
    return;
  }
  params = v[type + "Params"];
  scope = v.callbackScope || animation;
  executeLazyFirst && _lazyTweens.length && _lazyRender();
  return params ? callback.apply(scope, params) : callback.call(scope);
}, _interrupt = function _interrupt2(animation) {
  _removeFromParent(animation);
  animation.scrollTrigger && animation.scrollTrigger.kill(false);
  animation.progress() < 1 && _callback(animation, "onInterrupt");
  return animation;
}, _quickTween, _createPlugin = function _createPlugin2(config3) {
  config3 = !config3.name && config3["default"] || config3;
  var name = config3.name, isFunc = _isFunction(config3), Plugin = name && !isFunc && config3.init ? function() {
    this._props = [];
  } : config3, instanceDefaults = {
    init: _emptyFunc,
    render: _renderPropTweens,
    add: _addPropTween,
    kill: _killPropTweensOf,
    modifier: _addPluginModifier,
    rawVars: 0
  }, statics = {
    targetTest: 0,
    get: 0,
    getSetter: _getSetter,
    aliases: {},
    register: 0
  };
  _wake();
  if (config3 !== Plugin) {
    if (_plugins[name]) {
      return;
    }
    _setDefaults(Plugin, _setDefaults(_copyExcluding(config3, instanceDefaults), statics));
    _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config3, statics)));
    _plugins[Plugin.prop = name] = Plugin;
    if (config3.targetTest) {
      _harnessPlugins.push(Plugin);
      _reservedProps[name] = 1;
    }
    name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
  }
  _addGlobal(name, Plugin);
  config3.register && config3.register(gsap, Plugin, PropTween);
}, _255 = 255, _colorLookup = {
  aqua: [0, _255, _255],
  lime: [0, _255, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, _255],
  navy: [0, 0, 128],
  white: [_255, _255, _255],
  olive: [128, 128, 0],
  yellow: [_255, _255, 0],
  orange: [_255, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [_255, 0, 0],
  pink: [_255, 192, 203],
  cyan: [0, _255, _255],
  transparent: [_255, _255, _255, 0]
}, _hue = function _hue2(h, m1, m2) {
  h += h < 0 ? 1 : h > 1 ? -1 : 0;
  return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < 0.5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + 0.5 | 0;
}, splitColor = function splitColor2(v, toHSL, forceAlpha) {
  var a2 = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0, r2, g, b, h, s2, l, max, min, d, wasHSL;
  if (!a2) {
    if (v.substr(-1) === ",") {
      v = v.substr(0, v.length - 1);
    }
    if (_colorLookup[v]) {
      a2 = _colorLookup[v];
    } else if (v.charAt(0) === "#") {
      if (v.length < 6) {
        r2 = v.charAt(1);
        g = v.charAt(2);
        b = v.charAt(3);
        v = "#" + r2 + r2 + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
      }
      if (v.length === 9) {
        a2 = parseInt(v.substr(1, 6), 16);
        return [a2 >> 16, a2 >> 8 & _255, a2 & _255, parseInt(v.substr(7), 16) / 255];
      }
      v = parseInt(v.substr(1), 16);
      a2 = [v >> 16, v >> 8 & _255, v & _255];
    } else if (v.substr(0, 3) === "hsl") {
      a2 = wasHSL = v.match(_strictNumExp);
      if (!toHSL) {
        h = +a2[0] % 360 / 360;
        s2 = +a2[1] / 100;
        l = +a2[2] / 100;
        g = l <= 0.5 ? l * (s2 + 1) : l + s2 - l * s2;
        r2 = l * 2 - g;
        a2.length > 3 && (a2[3] *= 1);
        a2[0] = _hue(h + 1 / 3, r2, g);
        a2[1] = _hue(h, r2, g);
        a2[2] = _hue(h - 1 / 3, r2, g);
      } else if (~v.indexOf("=")) {
        a2 = v.match(_numExp);
        forceAlpha && a2.length < 4 && (a2[3] = 1);
        return a2;
      }
    } else {
      a2 = v.match(_strictNumExp) || _colorLookup.transparent;
    }
    a2 = a2.map(Number);
  }
  if (toHSL && !wasHSL) {
    r2 = a2[0] / _255;
    g = a2[1] / _255;
    b = a2[2] / _255;
    max = Math.max(r2, g, b);
    min = Math.min(r2, g, b);
    l = (max + min) / 2;
    if (max === min) {
      h = s2 = 0;
    } else {
      d = max - min;
      s2 = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      h = max === r2 ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r2) / d + 2 : (r2 - g) / d + 4;
      h *= 60;
    }
    a2[0] = ~~(h + 0.5);
    a2[1] = ~~(s2 * 100 + 0.5);
    a2[2] = ~~(l * 100 + 0.5);
  }
  forceAlpha && a2.length < 4 && (a2[3] = 1);
  return a2;
}, _colorOrderData = function _colorOrderData2(v) {
  var values = [], c2 = [], i2 = -1;
  v.split(_colorExp).forEach(function(v2) {
    var a2 = v2.match(_numWithUnitExp) || [];
    values.push.apply(values, a2);
    c2.push(i2 += a2.length + 1);
  });
  values.c = c2;
  return values;
}, _formatColors = function _formatColors2(s2, toHSL, orderMatchData) {
  var result = "", colors = (s2 + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i2 = 0, c2, shell, d, l;
  if (!colors) {
    return s2;
  }
  colors = colors.map(function(color) {
    return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
  });
  if (orderMatchData) {
    d = _colorOrderData(s2);
    c2 = orderMatchData.c;
    if (c2.join(result) !== d.c.join(result)) {
      shell = s2.replace(_colorExp, "1").split(_numWithUnitExp);
      l = shell.length - 1;
      for (; i2 < l; i2++) {
        result += shell[i2] + (~c2.indexOf(i2) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
      }
    }
  }
  if (!shell) {
    shell = s2.split(_colorExp);
    l = shell.length - 1;
    for (; i2 < l; i2++) {
      result += shell[i2] + colors[i2];
    }
  }
  return result + shell[l];
}, _colorExp = function() {
  var s2 = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", p;
  for (p in _colorLookup) {
    s2 += "|" + p + "\\b";
  }
  return new RegExp(s2 + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter2(a2) {
  var combined = a2.join(" "), toHSL;
  _colorExp.lastIndex = 0;
  if (_colorExp.test(combined)) {
    toHSL = _hslExp.test(combined);
    a2[1] = _formatColors(a2[1], toHSL);
    a2[0] = _formatColors(a2[0], toHSL, _colorOrderData(a2[1]));
    return true;
  }
}, _tickerActive, _ticker = function() {
  var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1e3 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick2(v) {
    var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
    elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
    _lastUpdate += elapsed;
    time = _lastUpdate - _startTime;
    overlap = time - _nextTime;
    if (overlap > 0 || manual) {
      frame = ++_self.frame;
      _delta = time - _self.time * 1e3;
      _self.time = time = time / 1e3;
      _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
      dispatch = 1;
    }
    manual || (_id = _req(_tick2));
    if (dispatch) {
      for (_i = 0; _i < _listeners.length; _i++) {
        _listeners[_i](time, _delta, frame, v);
      }
    }
  };
  _self = {
    time: 0,
    frame: 0,
    tick: function tick() {
      _tick(true);
    },
    deltaRatio: function deltaRatio(fps) {
      return _delta / (1e3 / (fps || 60));
    },
    wake: function wake() {
      if (_coreReady) {
        if (!_coreInitted && _windowExists()) {
          _win = _coreInitted = window;
          _doc = _win.document || {};
          _globals.gsap = gsap;
          (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
          _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
          _raf = _win.requestAnimationFrame;
        }
        _id && _self.sleep();
        _req = _raf || function(f2) {
          return setTimeout(f2, _nextTime - _self.time * 1e3 + 1 | 0);
        };
        _tickerActive = 1;
        _tick(2);
      }
    },
    sleep: function sleep() {
      (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
      _tickerActive = 0;
      _req = _emptyFunc;
    },
    lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
      _lagThreshold = threshold || 1 / _tinyNum;
      _adjustedLag = Math.min(adjustedLag, _lagThreshold, 0);
    },
    fps: function fps(_fps) {
      _gap = 1e3 / (_fps || 240);
      _nextTime = _self.time * 1e3 + _gap;
    },
    add: function add(callback) {
      _listeners.indexOf(callback) < 0 && _listeners.push(callback);
      _wake();
    },
    remove: function remove(callback, i2) {
      ~(i2 = _listeners.indexOf(callback)) && _listeners.splice(i2, 1) && _i >= i2 && _i--;
    },
    _listeners
  };
  return _self;
}(), _wake = function _wake2() {
  return !_tickerActive && _ticker.wake();
}, _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString2(value) {
  var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i2 = 1, l = split.length, index, val, parsedVal;
  for (; i2 < l; i2++) {
    val = split[i2];
    index = i2 !== l - 1 ? val.lastIndexOf(",") : val.length;
    parsedVal = val.substr(0, index);
    obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
    key = val.substr(index + 1).trim();
  }
  return obj;
}, _valueInParentheses = function _valueInParentheses2(value) {
  var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
  return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString2(name) {
  var split = (name + "").split("("), ease = _easeMap[split[0]];
  return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase2(ease) {
  return function(p) {
    return 1 - ease(1 - p);
  };
}, _propagateYoyoEase = function _propagateYoyoEase2(timeline2, isYoyo) {
  var child = timeline2._first, ease;
  while (child) {
    if (child instanceof Timeline) {
      _propagateYoyoEase2(child, isYoyo);
    } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
      if (child.timeline) {
        _propagateYoyoEase2(child.timeline, isYoyo);
      } else {
        ease = child._ease;
        child._ease = child._yEase;
        child._yEase = ease;
        child._yoyo = isYoyo;
      }
    }
    child = child._next;
  }
}, _parseEase = function _parseEase2(ease, defaultEase) {
  return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase2(names, easeIn, easeOut, easeInOut) {
  if (easeOut === void 0) {
    easeOut = function easeOut2(p) {
      return 1 - easeIn(1 - p);
    };
  }
  if (easeInOut === void 0) {
    easeInOut = function easeInOut2(p) {
      return p < 0.5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
  }
  var ease = {
    easeIn,
    easeOut,
    easeInOut
  }, lowercaseName;
  _forEachName(names, function(name) {
    _easeMap[name] = _globals[name] = ease;
    _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
    for (var p in ease) {
      _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    }
  });
  return ease;
}, _easeInOutFromOut = function _easeInOutFromOut2(easeOut) {
  return function(p) {
    return p < 0.5 ? (1 - easeOut(1 - p * 2)) / 2 : 0.5 + easeOut((p - 0.5) * 2) / 2;
  };
}, _configElastic = function _configElastic2(type, amplitude, period) {
  var p1 = amplitude >= 1 ? amplitude : 1, p2 = (period || (type ? 0.3 : 0.45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut2(p) {
    return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
  }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);
  p2 = _2PI / p2;
  ease.config = function(amplitude2, period2) {
    return _configElastic2(type, amplitude2, period2);
  };
  return ease;
}, _configBack = function _configBack2(type, overshoot) {
  if (overshoot === void 0) {
    overshoot = 1.70158;
  }
  var easeOut = function easeOut2(p) {
    return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
  }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
    return 1 - easeOut(1 - p);
  } : _easeInOutFromOut(easeOut);
  ease.config = function(overshoot2) {
    return _configBack2(type, overshoot2);
  };
  return ease;
};
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i2) {
  var power = i2 < 5 ? i2 + 1 : i2;
  _insertEase(name + ",Power" + (power - 1), i2 ? function(p) {
    return Math.pow(p, power);
  } : function(p) {
    return p;
  }, function(p) {
    return 1 - Math.pow(1 - p, power);
  }, function(p) {
    return p < 0.5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
  });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n2, c2) {
  var n1 = 1 / c2, n22 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut2(p) {
    return p < n1 ? n2 * p * p : p < n22 ? n2 * Math.pow(p - 1.5 / c2, 2) + 0.75 : p < n3 ? n2 * (p -= 2.25 / c2) * p + 0.9375 : n2 * Math.pow(p - 2.625 / c2, 2) + 0.984375;
  };
  _insertEase("Bounce", function(p) {
    return 1 - easeOut(1 - p);
  }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
  return p ? Math.pow(2, 10 * (p - 1)) : 0;
});
_insertEase("Circ", function(p) {
  return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
  return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
  config: function config(steps, immediateStart) {
    if (steps === void 0) {
      steps = 1;
    }
    var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
    return function(p) {
      return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
    };
  }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
  return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache2(target, harness) {
  this.id = _gsID++;
  target._gsap = this;
  this.target = target;
  this.harness = harness;
  this.get = harness ? harness.get : _getProperty;
  this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /* @__PURE__ */ function() {
  function Animation2(vars) {
    this.vars = vars;
    this._delay = +vars.delay || 0;
    if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
      this._rDelay = vars.repeatDelay || 0;
      this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
    }
    this._ts = 1;
    _setDuration(this, +vars.duration, 1, 1);
    this.data = vars.data;
    _tickerActive || _ticker.wake();
  }
  var _proto = Animation2.prototype;
  _proto.delay = function delay(value) {
    if (value || value === 0) {
      this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
      this._delay = value;
      return this;
    }
    return this._delay;
  };
  _proto.duration = function duration2(value) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
  };
  _proto.totalDuration = function totalDuration(value) {
    if (!arguments.length) {
      return this._tDur;
    }
    this._dirty = 0;
    return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
  };
  _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
    _wake();
    if (!arguments.length) {
      return this._tTime;
    }
    var parent = this._dp;
    if (parent && parent.smoothChildTiming && this._ts) {
      _alignPlayhead(this, _totalTime);
      !parent._dp || parent.parent || _postAddChecks(parent, this);
      while (parent && parent.parent) {
        if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
          parent.totalTime(parent._tTime, true);
        }
        parent = parent.parent;
      }
      if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
        _addToTimeline(this._dp, this, this._start - this._delay);
      }
    }
    if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
      this._ts || (this._pTime = _totalTime);
      _lazySafeRender(this, _totalTime, suppressEvents);
    }
    return this;
  };
  _proto.time = function time(value, suppressEvents) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time;
  };
  _proto.totalProgress = function totalProgress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  };
  _proto.progress = function progress(value, suppressEvents) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  };
  _proto.iteration = function iteration(value, suppressEvents) {
    var cycleDuration = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
  };
  _proto.timeScale = function timeScale(value) {
    if (!arguments.length) {
      return this._rts === -_tinyNum ? 0 : this._rts;
    }
    if (this._rts === value) {
      return this;
    }
    var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
    this._rts = +value || 0;
    this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
    _recacheAncestors(this.totalTime(_clamp(-this._delay, this._tDur, tTime), true));
    _setEnd(this);
    return this;
  };
  _proto.paused = function paused(value) {
    if (!arguments.length) {
      return this._ps;
    }
    if (this._ps !== value) {
      this._ps = value;
      if (value) {
        this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
        this._ts = this._act = 0;
      } else {
        _wake();
        this._ts = this._rts;
        this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum));
      }
    }
    return this;
  };
  _proto.startTime = function startTime(value) {
    if (arguments.length) {
      this._start = value;
      var parent = this.parent || this._dp;
      parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
      return this;
    }
    return this._start;
  };
  _proto.endTime = function endTime(includeRepeats) {
    return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  };
  _proto.rawTime = function rawTime(wrapRepeats) {
    var parent = this.parent || this._dp;
    return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
  };
  _proto.globalTime = function globalTime(rawTime) {
    var animation = this, time = arguments.length ? rawTime : animation.rawTime();
    while (animation) {
      time = animation._start + time / (animation._ts || 1);
      animation = animation._dp;
    }
    return time;
  };
  _proto.repeat = function repeat(value) {
    if (arguments.length) {
      this._repeat = value === Infinity ? -2 : value;
      return _onUpdateTotalDuration(this);
    }
    return this._repeat === -2 ? Infinity : this._repeat;
  };
  _proto.repeatDelay = function repeatDelay(value) {
    if (arguments.length) {
      var time = this._time;
      this._rDelay = value;
      _onUpdateTotalDuration(this);
      return time ? this.time(time) : this;
    }
    return this._rDelay;
  };
  _proto.yoyo = function yoyo(value) {
    if (arguments.length) {
      this._yoyo = value;
      return this;
    }
    return this._yoyo;
  };
  _proto.seek = function seek(position, suppressEvents) {
    return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
  };
  _proto.restart = function restart(includeDelay, suppressEvents) {
    return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
  };
  _proto.play = function play(from, suppressEvents) {
    from != null && this.seek(from, suppressEvents);
    return this.reversed(false).paused(false);
  };
  _proto.reverse = function reverse(from, suppressEvents) {
    from != null && this.seek(from || this.totalDuration(), suppressEvents);
    return this.reversed(true).paused(false);
  };
  _proto.pause = function pause(atTime, suppressEvents) {
    atTime != null && this.seek(atTime, suppressEvents);
    return this.paused(true);
  };
  _proto.resume = function resume() {
    return this.paused(false);
  };
  _proto.reversed = function reversed(value) {
    if (arguments.length) {
      !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0));
      return this;
    }
    return this._rts < 0;
  };
  _proto.invalidate = function invalidate() {
    this._initted = this._act = 0;
    this._zTime = -_tinyNum;
    return this;
  };
  _proto.isActive = function isActive() {
    var parent = this.parent || this._dp, start = this._start, rawTime;
    return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
  };
  _proto.eventCallback = function eventCallback(type, callback, params) {
    var vars = this.vars;
    if (arguments.length > 1) {
      if (!callback) {
        delete vars[type];
      } else {
        vars[type] = callback;
        params && (vars[type + "Params"] = params);
        type === "onUpdate" && (this._onUpdate = callback);
      }
      return this;
    }
    return vars[type];
  };
  _proto.then = function then(onFulfilled) {
    var self = this;
    return new Promise(function(resolve) {
      var f2 = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve2() {
        var _then = self.then;
        self.then = null;
        _isFunction(f2) && (f2 = f2(self)) && (f2.then || f2 === self) && (self.then = _then);
        resolve(f2);
        self.then = _then;
      };
      if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
        _resolve();
      } else {
        self._prom = _resolve;
      }
    });
  };
  _proto.kill = function kill2() {
    _interrupt(this);
  };
  return Animation2;
}();
_setDefaults(Animation.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: false,
  parent: null,
  _initted: false,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -_tinyNum,
  _prom: 0,
  _ps: false,
  _rts: 1
});
var Timeline = /* @__PURE__ */ function(_Animation) {
  _inheritsLoose(Timeline2, _Animation);
  function Timeline2(vars, position) {
    var _this;
    if (vars === void 0) {
      vars = {};
    }
    _this = _Animation.call(this, vars) || this;
    _this.labels = {};
    _this.smoothChildTiming = !!vars.smoothChildTiming;
    _this.autoRemoveChildren = !!vars.autoRemoveChildren;
    _this._sort = _isNotFalse(vars.sortChildren);
    _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
    vars.reversed && _this.reverse();
    vars.paused && _this.paused(true);
    vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
    return _this;
  }
  var _proto2 = Timeline2.prototype;
  _proto2.to = function to(targets, vars, position) {
    _createTweenType(0, arguments, this);
    return this;
  };
  _proto2.from = function from(targets, vars, position) {
    _createTweenType(1, arguments, this);
    return this;
  };
  _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
    _createTweenType(2, arguments, this);
    return this;
  };
  _proto2.set = function set(targets, vars, position) {
    vars.duration = 0;
    vars.parent = this;
    _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
    vars.immediateRender = !!vars.immediateRender;
    new Tween(targets, vars, _parsePosition(this, position), 1);
    return this;
  };
  _proto2.call = function call(callback, params, position) {
    return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
  };
  _proto2.staggerTo = function staggerTo(targets, duration2, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.duration = duration2;
    vars.stagger = vars.stagger || stagger;
    vars.onComplete = onCompleteAll;
    vars.onCompleteParams = onCompleteAllParams;
    vars.parent = this;
    new Tween(targets, vars, _parsePosition(this, position));
    return this;
  };
  _proto2.staggerFrom = function staggerFrom(targets, duration2, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
    vars.runBackwards = 1;
    _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
    return this.staggerTo(targets, duration2, vars, stagger, position, onCompleteAll, onCompleteAllParams);
  };
  _proto2.staggerFromTo = function staggerFromTo(targets, duration2, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
    toVars.startAt = fromVars;
    _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
    return this.staggerTo(targets, duration2, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
  };
  _proto2.render = function render2(totalTime, suppressEvents, force) {
    var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
    this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
    if (tTime !== this._tTime || force || crossingStart) {
      if (prevTime !== this._time && dur) {
        tTime += this._time - prevTime;
        totalTime += this._time - prevTime;
      }
      time = tTime;
      prevStart = this._start;
      timeScale = this._ts;
      prevPaused = !timeScale;
      if (crossingStart) {
        dur || (prevTime = this._zTime);
        (totalTime || !suppressEvents) && (this._zTime = totalTime);
      }
      if (this._repeat) {
        yoyo = this._yoyo;
        cycleDuration = dur + this._rDelay;
        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }
        time = _roundPrecise(tTime % cycleDuration);
        if (tTime === tDur) {
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);
          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }
          time > dur && (time = dur);
        }
        prevIteration = _animationCycle(this._tTime, cycleDuration);
        !prevTime && this._tTime && prevIteration !== iteration && (prevIteration = iteration);
        if (yoyo && iteration & 1) {
          time = dur - time;
          isYoyo = 1;
        }
        if (iteration !== prevIteration && !this._lock) {
          var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
          iteration < prevIteration && (rewinding = !rewinding);
          prevTime = rewinding ? 0 : dur;
          this._lock = 1;
          this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
          this._tTime = tTime;
          !suppressEvents && this.parent && _callback(this, "onRepeat");
          this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
          if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
            return this;
          }
          dur = this._dur;
          tDur = this._tDur;
          if (doesWrap) {
            this._lock = 2;
            prevTime = rewinding ? dur : -1e-4;
            this.render(prevTime, true);
            this.vars.repeatRefresh && !isYoyo && this.invalidate();
          }
          this._lock = 0;
          if (!this._ts && !prevPaused) {
            return this;
          }
          _propagateYoyoEase(this, isYoyo);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2) {
        pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
        if (pauseTween) {
          tTime -= time - (time = pauseTween._start);
        }
      }
      this._tTime = tTime;
      this._time = time;
      this._act = !timeScale;
      if (!this._initted) {
        this._onUpdate = this.vars.onUpdate;
        this._initted = 1;
        this._zTime = totalTime;
        prevTime = 0;
      }
      if (!prevTime && time && !suppressEvents) {
        _callback(this, "onStart");
        if (this._tTime !== tTime) {
          return this;
        }
      }
      if (time >= prevTime && totalTime >= 0) {
        child = this._first;
        while (child) {
          next = child._next;
          if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
            if (time !== this._time || !this._ts && !prevPaused) {
              pauseTween = 0;
              next && (tTime += this._zTime = -_tinyNum);
              break;
            }
          }
          child = next;
        }
      } else {
        child = this._last;
        var adjustedTime = totalTime < 0 ? totalTime : time;
        while (child) {
          next = child._prev;
          if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
            if (child.parent !== this) {
              return this.render(totalTime, suppressEvents, force);
            }
            child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force);
            if (time !== this._time || !this._ts && !prevPaused) {
              pauseTween = 0;
              next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
              break;
            }
          }
          child = next;
        }
      }
      if (pauseTween && !suppressEvents) {
        this.pause();
        pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
        if (this._ts) {
          this._start = prevStart;
          _setEnd(this);
          return this.render(totalTime, suppressEvents, force);
        }
      }
      this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
      if (tTime === tDur && tDur >= this.totalDuration() || !tTime && prevTime) {
        if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
          if (!this._lock) {
            (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
            if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
              _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
              this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
            }
          }
        }
      }
    }
    return this;
  };
  _proto2.add = function add(child, position) {
    var _this2 = this;
    _isNumber(position) || (position = _parsePosition(this, position, child));
    if (!(child instanceof Animation)) {
      if (_isArray(child)) {
        child.forEach(function(obj) {
          return _this2.add(obj, position);
        });
        return this;
      }
      if (_isString(child)) {
        return this.addLabel(child, position);
      }
      if (_isFunction(child)) {
        child = Tween.delayedCall(0, child);
      } else {
        return this;
      }
    }
    return this !== child ? _addToTimeline(this, child, position) : this;
  };
  _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
    if (nested === void 0) {
      nested = true;
    }
    if (tweens === void 0) {
      tweens = true;
    }
    if (timelines === void 0) {
      timelines = true;
    }
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = -_bigNum;
    }
    var a2 = [], child = this._first;
    while (child) {
      if (child._start >= ignoreBeforeTime) {
        if (child instanceof Tween) {
          tweens && a2.push(child);
        } else {
          timelines && a2.push(child);
          nested && a2.push.apply(a2, child.getChildren(true, tweens, timelines));
        }
      }
      child = child._next;
    }
    return a2;
  };
  _proto2.getById = function getById2(id) {
    var animations = this.getChildren(1, 1, 1), i2 = animations.length;
    while (i2--) {
      if (animations[i2].vars.id === id) {
        return animations[i2];
      }
    }
  };
  _proto2.remove = function remove(child) {
    if (_isString(child)) {
      return this.removeLabel(child);
    }
    if (_isFunction(child)) {
      return this.killTweensOf(child);
    }
    _removeLinkedListItem(this, child);
    if (child === this._recent) {
      this._recent = this._last;
    }
    return _uncache(this);
  };
  _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
    if (!arguments.length) {
      return this._tTime;
    }
    this._forcing = 1;
    if (!this._dp && this._ts) {
      this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
    }
    _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
    this._forcing = 0;
    return this;
  };
  _proto2.addLabel = function addLabel(label, position) {
    this.labels[label] = _parsePosition(this, position);
    return this;
  };
  _proto2.removeLabel = function removeLabel(label) {
    delete this.labels[label];
    return this;
  };
  _proto2.addPause = function addPause(position, callback, params) {
    var t2 = Tween.delayedCall(0, callback || _emptyFunc, params);
    t2.data = "isPause";
    this._hasPause = 1;
    return _addToTimeline(this, t2, _parsePosition(this, position));
  };
  _proto2.removePause = function removePause(position) {
    var child = this._first;
    position = _parsePosition(this, position);
    while (child) {
      if (child._start === position && child.data === "isPause") {
        _removeFromParent(child);
      }
      child = child._next;
    }
  };
  _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    var tweens = this.getTweensOf(targets, onlyActive), i2 = tweens.length;
    while (i2--) {
      _overwritingTween !== tweens[i2] && tweens[i2].kill(targets, props);
    }
    return this;
  };
  _proto2.getTweensOf = function getTweensOf2(targets, onlyActive) {
    var a2 = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), children;
    while (child) {
      if (child instanceof Tween) {
        if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
          a2.push(child);
        }
      } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
        a2.push.apply(a2, children);
      }
      child = child._next;
    }
    return a2;
  };
  _proto2.tweenTo = function tweenTo(position, vars) {
    vars = vars || {};
    var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
      ease: vars.ease || "none",
      lazy: false,
      immediateRender: false,
      time: endTime,
      overwrite: "auto",
      duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
      onStart: function onStart() {
        tl.pause();
        if (!initted) {
          var duration2 = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
          tween._dur !== duration2 && _setDuration(tween, duration2, 0, 1).render(tween._time, true, true);
          initted = 1;
        }
        _onStart && _onStart.apply(tween, onStartParams || []);
      }
    }, vars));
    return immediateRender ? tween.render(0) : tween;
  };
  _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
    return this.tweenTo(toPosition, _setDefaults({
      startAt: {
        time: _parsePosition(this, fromPosition)
      }
    }, vars));
  };
  _proto2.recent = function recent() {
    return this._recent;
  };
  _proto2.nextLabel = function nextLabel(afterTime) {
    if (afterTime === void 0) {
      afterTime = this._time;
    }
    return _getLabelInDirection(this, _parsePosition(this, afterTime));
  };
  _proto2.previousLabel = function previousLabel(beforeTime) {
    if (beforeTime === void 0) {
      beforeTime = this._time;
    }
    return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
  };
  _proto2.currentLabel = function currentLabel(value) {
    return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
  };
  _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
    if (ignoreBeforeTime === void 0) {
      ignoreBeforeTime = 0;
    }
    var child = this._first, labels = this.labels, p;
    while (child) {
      if (child._start >= ignoreBeforeTime) {
        child._start += amount;
        child._end += amount;
      }
      child = child._next;
    }
    if (adjustLabels) {
      for (p in labels) {
        if (labels[p] >= ignoreBeforeTime) {
          labels[p] += amount;
        }
      }
    }
    return _uncache(this);
  };
  _proto2.invalidate = function invalidate() {
    var child = this._first;
    this._lock = 0;
    while (child) {
      child.invalidate();
      child = child._next;
    }
    return _Animation.prototype.invalidate.call(this);
  };
  _proto2.clear = function clear(includeLabels) {
    if (includeLabels === void 0) {
      includeLabels = true;
    }
    var child = this._first, next;
    while (child) {
      next = child._next;
      this.remove(child);
      child = next;
    }
    this._dp && (this._time = this._tTime = this._pTime = 0);
    includeLabels && (this.labels = {});
    return _uncache(this);
  };
  _proto2.totalDuration = function totalDuration(value) {
    var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
    if (arguments.length) {
      return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
    }
    if (self._dirty) {
      parent = self.parent;
      while (child) {
        prev = child._prev;
        child._dirty && child.totalDuration();
        start = child._start;
        if (start > prevStart && self._sort && child._ts && !self._lock) {
          self._lock = 1;
          _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
        } else {
          prevStart = start;
        }
        if (start < 0 && child._ts) {
          max -= start;
          if (!parent && !self._dp || parent && parent.smoothChildTiming) {
            self._start += start / self._ts;
            self._time -= start;
            self._tTime -= start;
          }
          self.shiftChildren(-start, false, -Infinity);
          prevStart = 0;
        }
        child._end > max && child._ts && (max = child._end);
        child = prev;
      }
      _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
      self._dirty = 0;
    }
    return self._tDur;
  };
  Timeline2.updateRoot = function updateRoot(time) {
    if (_globalTimeline._ts) {
      _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
      _lastRenderedFrame = _ticker.frame;
    }
    if (_ticker.frame >= _nextGCFrame) {
      _nextGCFrame += _config.autoSleep || 120;
      var child = _globalTimeline._first;
      if (!child || !child._ts) {
        if (_config.autoSleep && _ticker._listeners.length < 2) {
          while (child && !child._ts) {
            child = child._next;
          }
          child || _ticker.sleep();
        }
      }
    }
  };
  return Timeline2;
}(Animation);
_setDefaults(Timeline.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween2(target, prop, start, end, setter, stringFilter, funcParam) {
  var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a2;
  pt.b = start;
  pt.e = end;
  start += "";
  end += "";
  if (hasRandom = ~end.indexOf("random(")) {
    end = _replaceRandom(end);
  }
  if (stringFilter) {
    a2 = [start, end];
    stringFilter(a2, target, prop);
    start = a2[0];
    end = a2[1];
  }
  startNums = start.match(_complexStringNumExp) || [];
  while (result = _complexStringNumExp.exec(end)) {
    endNum = result[0];
    chunk = end.substring(index, result.index);
    if (color) {
      color = (color + 1) % 5;
    } else if (chunk.substr(-5) === "rgba(") {
      color = 1;
    }
    if (endNum !== startNums[matchIndex++]) {
      startNum = parseFloat(startNums[matchIndex - 1]) || 0;
      pt._pt = {
        _next: pt._pt,
        p: chunk || matchIndex === 1 ? chunk : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: startNum,
        c: endNum.charAt(1) === "=" ? parseFloat(endNum.substr(2)) * (endNum.charAt(0) === "-" ? -1 : 1) : parseFloat(endNum) - startNum,
        m: color && color < 4 ? Math.round : 0
      };
      index = _complexStringNumExp.lastIndex;
    }
  }
  pt.c = index < end.length ? end.substring(index, end.length) : "";
  pt.fp = funcParam;
  if (_relExp.test(end) || hasRandom) {
    pt.e = 0;
  }
  this._pt = pt;
  return pt;
}, _addPropTween = function _addPropTween2(target, prop, start, end, index, targets, modifier, stringFilter, funcParam) {
  _isFunction(end) && (end = end(index || 0, target, targets));
  var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
  if (_isString(end)) {
    if (~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }
    if (end.charAt(1) === "=") {
      pt = parseFloat(parsedStart) + parseFloat(end.substr(2)) * (end.charAt(0) === "-" ? -1 : 1) + (getUnit(parsedStart) || 0);
      if (pt || pt === 0) {
        end = pt;
      }
    }
  }
  if (parsedStart !== end) {
    if (!isNaN(parsedStart * end) && end !== "") {
      pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
      funcParam && (pt.fp = funcParam);
      modifier && pt.modifier(modifier, this, target);
      return this._pt = pt;
    }
    !currentValue && !(prop in target) && _missingPlugin(prop, end);
    return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
  }
}, _processVars = function _processVars2(vars, index, target, targets, tween) {
  _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
  if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
    return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
  }
  var copy = {}, p;
  for (p in vars) {
    copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
  }
  return copy;
}, _checkPlugin = function _checkPlugin2(property, vars, tween, index, target, targets) {
  var plugin, pt, ptLookup, i2;
  if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
    tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
    if (tween !== _quickTween) {
      ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
      i2 = plugin._props.length;
      while (i2--) {
        ptLookup[plugin._props[i2]] = pt;
      }
    }
  }
  return plugin;
}, _overwritingTween, _initTween = function _initTween2(tween, time) {
  var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, onUpdateParams = vars.onUpdateParams, callbackScope = vars.callbackScope, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.parent._targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i2, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
  tl && (!keyframes || !ease) && (ease = "none");
  tween._ease = _parseEase(ease, _defaults.ease);
  tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
  if (yoyoEase && tween._yoyo && !tween._repeat) {
    yoyoEase = tween._yEase;
    tween._yEase = tween._ease;
    tween._ease = yoyoEase;
  }
  tween._from = !tl && !!vars.runBackwards;
  if (!tl || keyframes && !vars.stagger) {
    harness = targets[0] ? _getCache(targets[0]).harness : 0;
    harnessVars = harness && vars[harness.prop];
    cleanVars = _copyExcluding(vars, _reservedProps);
    prevStartAt && _removeFromParent(prevStartAt.render(-1, true));
    if (startAt) {
      _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
        data: "isStart",
        overwrite: false,
        parent,
        immediateRender: true,
        lazy: _isNotFalse(lazy),
        startAt: null,
        delay: 0,
        onUpdate,
        onUpdateParams,
        callbackScope,
        stagger: 0
      }, startAt)));
      time < 0 && !immediateRender && !autoRevert && tween._startAt.render(-1, true);
      if (immediateRender) {
        time > 0 && !autoRevert && (tween._startAt = 0);
        if (dur && time <= 0) {
          time && (tween._zTime = time);
          return;
        }
      } else if (autoRevert === false) {
        tween._startAt = 0;
      }
    } else if (runBackwards && dur) {
      if (prevStartAt) {
        !autoRevert && (tween._startAt = 0);
      } else {
        time && (immediateRender = false);
        p = _setDefaults({
          overwrite: false,
          data: "isFromStart",
          //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
          lazy: immediateRender && _isNotFalse(lazy),
          immediateRender,
          //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
          stagger: 0,
          parent
          //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
        }, cleanVars);
        harnessVars && (p[harness.prop] = harnessVars);
        _removeFromParent(tween._startAt = Tween.set(targets, p));
        time < 0 && tween._startAt.render(-1, true);
        tween._zTime = time;
        if (!immediateRender) {
          _initTween2(tween._startAt, _tinyNum);
        } else if (!time) {
          return;
        }
      }
    }
    tween._pt = 0;
    lazy = dur && _isNotFalse(lazy) || lazy && !dur;
    for (i2 = 0; i2 < targets.length; i2++) {
      target = targets[i2];
      gsData = target._gsap || _harness(targets)[i2]._gsap;
      tween._ptLookup[i2] = ptLookup = {};
      _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender();
      index = fullTargets === targets ? i2 : fullTargets.indexOf(target);
      if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
        plugin._props.forEach(function(name) {
          ptLookup[name] = pt;
        });
        plugin.priority && (hasPriority = 1);
      }
      if (!harness || harnessVars) {
        for (p in cleanVars) {
          if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
            plugin.priority && (hasPriority = 1);
          } else {
            ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
          }
        }
      }
      tween._op && tween._op[i2] && tween.kill(target, tween._op[i2]);
      if (autoOverwrite && tween._pt) {
        _overwritingTween = tween;
        _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time));
        overwritten = !tween.parent;
        _overwritingTween = 0;
      }
      tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
    }
    hasPriority && _sortPropTweensByPriority(tween);
    tween._onInit && tween._onInit(tween);
  }
  tween._onUpdate = onUpdate;
  tween._initted = (!tween._op || tween._pt) && !overwritten;
  keyframes && time <= 0 && tl.render(_bigNum, true, true);
}, _addAliasesToVars = function _addAliasesToVars2(targets, vars) {
  var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i2, aliases;
  if (!propertyAliases) {
    return vars;
  }
  copy = _merge({}, vars);
  for (p in propertyAliases) {
    if (p in copy) {
      aliases = propertyAliases[p].split(",");
      i2 = aliases.length;
      while (i2--) {
        copy[aliases[i2]] = copy[p];
      }
    }
  }
  return copy;
}, _parseKeyframe = function _parseKeyframe2(prop, obj, allProps, easeEach) {
  var ease = obj.ease || easeEach || "power1.inOut", p, a2;
  if (_isArray(obj)) {
    a2 = allProps[prop] || (allProps[prop] = []);
    obj.forEach(function(value, i2) {
      return a2.push({
        t: i2 / (obj.length - 1) * 100,
        v: value,
        e: ease
      });
    });
  } else {
    for (p in obj) {
      a2 = allProps[p] || (allProps[p] = []);
      p === "ease" || a2.push({
        t: parseFloat(prop),
        v: obj[p],
        e: ease
      });
    }
  }
}, _parseFuncOrString = function _parseFuncOrString2(value, tween, i2, target, targets) {
  return _isFunction(value) ? value.call(tween, i2, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
  return _staggerPropsToSkip[name] = 1;
});
var Tween = /* @__PURE__ */ function(_Animation2) {
  _inheritsLoose(Tween2, _Animation2);
  function Tween2(targets, vars, position, skipInherit) {
    var _this3;
    if (typeof vars === "number") {
      position.duration = vars;
      vars = position;
      position = null;
    }
    _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
    var _this3$vars = _this3.vars, duration2 = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults2 = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets), tl, i2, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
    _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
    _this3._ptLookup = [];
    _this3._overwrite = overwrite;
    if (keyframes || stagger || _isFuncOrString(duration2) || _isFuncOrString(delay)) {
      vars = _this3.vars;
      tl = _this3.timeline = new Timeline({
        data: "nested",
        defaults: defaults2 || {}
      });
      tl.kill();
      tl.parent = tl._dp = _assertThisInitialized(_this3);
      tl._start = 0;
      if (stagger || _isFuncOrString(duration2) || _isFuncOrString(delay)) {
        l = parsedTargets.length;
        staggerFunc = stagger && distribute(stagger);
        if (_isObject(stagger)) {
          for (p in stagger) {
            if (~_staggerTweenProps.indexOf(p)) {
              staggerVarsToMerge || (staggerVarsToMerge = {});
              staggerVarsToMerge[p] = stagger[p];
            }
          }
        }
        for (i2 = 0; i2 < l; i2++) {
          copy = _copyExcluding(vars, _staggerPropsToSkip);
          copy.stagger = 0;
          yoyoEase && (copy.yoyoEase = yoyoEase);
          staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
          curTarget = parsedTargets[i2];
          copy.duration = +_parseFuncOrString(duration2, _assertThisInitialized(_this3), i2, curTarget, parsedTargets);
          copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i2, curTarget, parsedTargets) || 0) - _this3._delay;
          if (!stagger && l === 1 && copy.delay) {
            _this3._delay = delay = copy.delay;
            _this3._start += delay;
            copy.delay = 0;
          }
          tl.to(curTarget, copy, staggerFunc ? staggerFunc(i2, curTarget, parsedTargets) : 0);
          tl._ease = _easeMap.none;
        }
        tl.duration() ? duration2 = delay = 0 : _this3.timeline = 0;
      } else if (keyframes) {
        _inheritDefaults(_setDefaults(tl.vars.defaults, {
          ease: "none"
        }));
        tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
        var time = 0, a2, kf, v;
        if (_isArray(keyframes)) {
          keyframes.forEach(function(frame) {
            return tl.to(parsedTargets, frame, ">");
          });
        } else {
          copy = {};
          for (p in keyframes) {
            p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
          }
          for (p in copy) {
            a2 = copy[p].sort(function(a3, b) {
              return a3.t - b.t;
            });
            time = 0;
            for (i2 = 0; i2 < a2.length; i2++) {
              kf = a2[i2];
              v = {
                ease: kf.e,
                duration: (kf.t - (i2 ? a2[i2 - 1].t : 0)) / 100 * duration2
              };
              v[p] = kf.v;
              tl.to(parsedTargets, v, time);
              time += v.duration;
            }
          }
          tl.duration() < duration2 && tl.to({}, {
            duration: duration2 - tl.duration()
          });
        }
      }
      duration2 || _this3.duration(duration2 = tl.duration());
    } else {
      _this3.timeline = 0;
    }
    if (overwrite === true && !_suppressOverwrites) {
      _overwritingTween = _assertThisInitialized(_this3);
      _globalTimeline.killTweensOf(parsedTargets);
      _overwritingTween = 0;
    }
    _addToTimeline(parent, _assertThisInitialized(_this3), position);
    vars.reversed && _this3.reverse();
    vars.paused && _this3.paused(true);
    if (immediateRender || !duration2 && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
      _this3._tTime = -_tinyNum;
      _this3.render(Math.max(0, -delay));
    }
    scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
    return _this3;
  }
  var _proto3 = Tween2.prototype;
  _proto3.render = function render2(totalTime, suppressEvents, force) {
    var prevTime = this._time, tDur = this._tDur, dur = this._dur, tTime = totalTime > tDur - _tinyNum && totalTime >= 0 ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline2, yoyoEase;
    if (!dur) {
      _renderZeroDurationTween(this, totalTime, suppressEvents, force);
    } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== totalTime < 0) {
      time = tTime;
      timeline2 = this.timeline;
      if (this._repeat) {
        cycleDuration = dur + this._rDelay;
        if (this._repeat < -1 && totalTime < 0) {
          return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
        }
        time = _roundPrecise(tTime % cycleDuration);
        if (tTime === tDur) {
          iteration = this._repeat;
          time = dur;
        } else {
          iteration = ~~(tTime / cycleDuration);
          if (iteration && iteration === tTime / cycleDuration) {
            time = dur;
            iteration--;
          }
          time > dur && (time = dur);
        }
        isYoyo = this._yoyo && iteration & 1;
        if (isYoyo) {
          yoyoEase = this._yEase;
          time = dur - time;
        }
        prevIteration = _animationCycle(this._tTime, cycleDuration);
        if (time === prevTime && !force && this._initted) {
          return this;
        }
        if (iteration !== prevIteration) {
          timeline2 && this._yEase && _propagateYoyoEase(timeline2, isYoyo);
          if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
            this._lock = force = 1;
            this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
          }
        }
      }
      if (!this._initted) {
        if (_attemptInitTween(this, totalTime < 0 ? totalTime : time, force, suppressEvents)) {
          this._tTime = 0;
          return this;
        }
        if (dur !== this._dur) {
          return this.render(totalTime, suppressEvents, force);
        }
      }
      this._tTime = tTime;
      this._time = time;
      if (!this._act && this._ts) {
        this._act = 1;
        this._lazy = 0;
      }
      this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
      if (this._from) {
        this.ratio = ratio = 1 - ratio;
      }
      if (time && !prevTime && !suppressEvents) {
        _callback(this, "onStart");
        if (this._tTime !== tTime) {
          return this;
        }
      }
      pt = this._pt;
      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
      timeline2 && timeline2.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline2._dur * timeline2._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
      if (this._onUpdate && !suppressEvents) {
        totalTime < 0 && this._startAt && this._startAt.render(totalTime, true, force);
        _callback(this, "onUpdate");
      }
      this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
      if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
        totalTime < 0 && this._startAt && !this._onUpdate && this._startAt.render(totalTime, true, true);
        (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime)) {
          _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
          this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
        }
      }
    }
    return this;
  };
  _proto3.targets = function targets() {
    return this._targets;
  };
  _proto3.invalidate = function invalidate() {
    this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0;
    this._ptLookup = [];
    this.timeline && this.timeline.invalidate();
    return _Animation2.prototype.invalidate.call(this);
  };
  _proto3.kill = function kill2(targets, vars) {
    if (vars === void 0) {
      vars = "all";
    }
    if (!targets && (!vars || vars === "all")) {
      this._lazy = this._pt = 0;
      return this.parent ? _interrupt(this) : this;
    }
    if (this.timeline) {
      var tDur = this.timeline.totalDuration();
      this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this);
      this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1);
      return this;
    }
    var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i2;
    if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
      vars === "all" && (this._pt = 0);
      return _interrupt(this);
    }
    overwrittenProps = this._op = this._op || [];
    if (vars !== "all") {
      if (_isString(vars)) {
        p = {};
        _forEachName(vars, function(name) {
          return p[name] = 1;
        });
        vars = p;
      }
      vars = _addAliasesToVars(parsedTargets, vars);
    }
    i2 = parsedTargets.length;
    while (i2--) {
      if (~killingTargets.indexOf(parsedTargets[i2])) {
        curLookup = propTweenLookup[i2];
        if (vars === "all") {
          overwrittenProps[i2] = vars;
          props = curLookup;
          curOverwriteProps = {};
        } else {
          curOverwriteProps = overwrittenProps[i2] = overwrittenProps[i2] || {};
          props = vars;
        }
        for (p in props) {
          pt = curLookup && curLookup[p];
          if (pt) {
            if (!("kill" in pt.d) || pt.d.kill(p) === true) {
              _removeLinkedListItem(this, pt, "_pt");
            }
            delete curLookup[p];
          }
          if (curOverwriteProps !== "all") {
            curOverwriteProps[p] = 1;
          }
        }
      }
    }
    this._initted && !this._pt && firstPT && _interrupt(this);
    return this;
  };
  Tween2.to = function to(targets, vars) {
    return new Tween2(targets, vars, arguments[2]);
  };
  Tween2.from = function from(targets, vars) {
    return _createTweenType(1, arguments);
  };
  Tween2.delayedCall = function delayedCall(delay, callback, params, scope) {
    return new Tween2(callback, 0, {
      immediateRender: false,
      lazy: false,
      overwrite: false,
      delay,
      onComplete: callback,
      onReverseComplete: callback,
      onCompleteParams: params,
      onReverseCompleteParams: params,
      callbackScope: scope
    });
  };
  Tween2.fromTo = function fromTo(targets, fromVars, toVars) {
    return _createTweenType(2, arguments);
  };
  Tween2.set = function set(targets, vars) {
    vars.duration = 0;
    vars.repeatDelay || (vars.repeat = 0);
    return new Tween2(targets, vars);
  };
  Tween2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
    return _globalTimeline.killTweensOf(targets, props, onlyActive);
  };
  return Tween2;
}(Animation);
_setDefaults(Tween.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
  Tween[name] = function() {
    var tl = new Timeline(), params = _slice.call(arguments, 0);
    params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
    return tl[name].apply(tl, params);
  };
});
var _setterPlain = function _setterPlain2(target, property, value) {
  return target[property] = value;
}, _setterFunc = function _setterFunc2(target, property, value) {
  return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam2(target, property, value, data) {
  return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute2(target, property, value) {
  return target.setAttribute(property, value);
}, _getSetter = function _getSetter2(target, property) {
  return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain2(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e6) / 1e6, data);
}, _renderBoolean = function _renderBoolean2(ratio, data) {
  return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString2(ratio, data) {
  var pt = data._pt, s2 = "";
  if (!ratio && data.b) {
    s2 = data.b;
  } else if (ratio === 1 && data.e) {
    s2 = data.e;
  } else {
    while (pt) {
      s2 = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 1e4) / 1e4) + s2;
      pt = pt._next;
    }
    s2 += data.c;
  }
  data.set(data.t, data.p, s2, data);
}, _renderPropTweens = function _renderPropTweens2(ratio, data) {
  var pt = data._pt;
  while (pt) {
    pt.r(ratio, pt.d);
    pt = pt._next;
  }
}, _addPluginModifier = function _addPluginModifier2(modifier, tween, target, property) {
  var pt = this._pt, next;
  while (pt) {
    next = pt._next;
    pt.p === property && pt.modifier(modifier, tween, target);
    pt = next;
  }
}, _killPropTweensOf = function _killPropTweensOf2(property) {
  var pt = this._pt, hasNonDependentRemaining, next;
  while (pt) {
    next = pt._next;
    if (pt.p === property && !pt.op || pt.op === property) {
      _removeLinkedListItem(this, pt, "_pt");
    } else if (!pt.dep) {
      hasNonDependentRemaining = 1;
    }
    pt = next;
  }
  return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier2(target, property, value, data) {
  data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority2(parent) {
  var pt = parent._pt, next, pt2, first, last;
  while (pt) {
    next = pt._next;
    pt2 = first;
    while (pt2 && pt2.pr > pt.pr) {
      pt2 = pt2._next;
    }
    if (pt._prev = pt2 ? pt2._prev : last) {
      pt._prev._next = pt;
    } else {
      first = pt;
    }
    if (pt._next = pt2) {
      pt2._prev = pt;
    } else {
      last = pt;
    }
    pt = next;
  }
  parent._pt = first;
};
var PropTween = /* @__PURE__ */ function() {
  function PropTween2(next, target, prop, start, change, renderer, data, setter, priority) {
    this.t = target;
    this.s = start;
    this.c = change;
    this.p = prop;
    this.r = renderer || _renderPlain;
    this.d = data || this;
    this.set = setter || _setterPlain;
    this.pr = priority || 0;
    this._next = next;
    if (next) {
      next._prev = this;
    }
  }
  var _proto4 = PropTween2.prototype;
  _proto4.modifier = function modifier(func, tween, target) {
    this.mSet = this.mSet || this.set;
    this.set = _setterWithModifier;
    this.m = func;
    this.mt = target;
    this.tween = tween;
  };
  return PropTween2;
}();
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
  return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
  sortChildren: false,
  defaults: _defaults,
  autoRemoveChildren: true,
  id: "root",
  smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _gsap = {
  registerPlugin: function registerPlugin() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args.forEach(function(config3) {
      return _createPlugin(config3);
    });
  },
  timeline: function timeline(vars) {
    return new Timeline(vars);
  },
  getTweensOf: function getTweensOf(targets, onlyActive) {
    return _globalTimeline.getTweensOf(targets, onlyActive);
  },
  getProperty: function getProperty(target, property, unit, uncache) {
    _isString(target) && (target = toArray(target)[0]);
    var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
    unit === "native" && (unit = "");
    return !target ? target : !property ? function(property2, unit2, uncache2) {
      return format((_plugins[property2] && _plugins[property2].get || getter)(target, property2, unit2, uncache2));
    } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
  },
  quickSetter: function quickSetter(target, property, unit) {
    target = toArray(target);
    if (target.length > 1) {
      var setters = target.map(function(t2) {
        return gsap.quickSetter(t2, property, unit);
      }), l = setters.length;
      return function(value) {
        var i2 = l;
        while (i2--) {
          setters[i2](value);
        }
      };
    }
    target = target[0] || {};
    var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, setter = Plugin ? function(value) {
      var p2 = new Plugin();
      _quickTween._pt = 0;
      p2.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
      p2.render(1, p2);
      _quickTween._pt && _renderPropTweens(1, _quickTween);
    } : cache.set(target, p);
    return Plugin ? setter : function(value) {
      return setter(target, p, unit ? value + unit : value, cache, 1);
    };
  },
  isTweening: function isTweening(targets) {
    return _globalTimeline.getTweensOf(targets, true).length > 0;
  },
  defaults: function defaults(value) {
    value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
    return _mergeDeep(_defaults, value || {});
  },
  config: function config2(value) {
    return _mergeDeep(_config, value || {});
  },
  registerEffect: function registerEffect(_ref3) {
    var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults2 = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
    (plugins || "").split(",").forEach(function(pluginName) {
      return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
    });
    _effects[name] = function(targets, vars, tl) {
      return effect(toArray(targets), _setDefaults(vars || {}, defaults2), tl);
    };
    if (extendTimeline) {
      Timeline.prototype[name] = function(targets, vars, position) {
        return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
      };
    }
  },
  registerEase: function registerEase(name, ease) {
    _easeMap[name] = _parseEase(ease);
  },
  parseEase: function parseEase(ease, defaultEase) {
    return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
  },
  getById: function getById(id) {
    return _globalTimeline.getById(id);
  },
  exportRoot: function exportRoot(vars, includeDelayedCalls) {
    if (vars === void 0) {
      vars = {};
    }
    var tl = new Timeline(vars), child, next;
    tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
    _globalTimeline.remove(tl);
    tl._dp = 0;
    tl._time = tl._tTime = _globalTimeline._time;
    child = _globalTimeline._first;
    while (child) {
      next = child._next;
      if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
        _addToTimeline(tl, child, child._start - child._delay);
      }
      child = next;
    }
    _addToTimeline(_globalTimeline, tl, 0);
    return tl;
  },
  utils: {
    wrap,
    wrapYoyo,
    distribute,
    random,
    snap,
    normalize,
    getUnit,
    clamp,
    splitColor,
    toArray,
    selector,
    mapRange,
    pipe,
    unitize,
    interpolate,
    shuffle
  },
  install: _install,
  effects: _effects,
  ticker: _ticker,
  updateRoot: Timeline.updateRoot,
  plugins: _plugins,
  globalTimeline: _globalTimeline,
  core: {
    PropTween,
    globals: _addGlobal,
    Tween,
    Timeline,
    Animation,
    getCache: _getCache,
    _removeLinkedListItem,
    suppressOverwrites: function suppressOverwrites(value) {
      return _suppressOverwrites = value;
    }
  }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
  return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
  duration: 0
});
var _getPluginPropTween = function _getPluginPropTween2(plugin, prop) {
  var pt = plugin._pt;
  while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
    pt = pt._next;
  }
  return pt;
}, _addModifiers = function _addModifiers2(tween, modifiers) {
  var targets = tween._targets, p, i2, pt;
  for (p in modifiers) {
    i2 = targets.length;
    while (i2--) {
      pt = tween._ptLookup[i2][p];
      if (pt && (pt = pt.d)) {
        if (pt._pt) {
          pt = _getPluginPropTween(pt, p);
        }
        pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i2], p);
      }
    }
  }
}, _buildModifierPlugin = function _buildModifierPlugin2(name, modifier) {
  return {
    name,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function init5(target, vars, tween) {
      tween._onInit = function(tween2) {
        var temp, p;
        if (_isString(vars)) {
          temp = {};
          _forEachName(vars, function(name2) {
            return temp[name2] = 1;
          });
          vars = temp;
        }
        if (modifier) {
          temp = {};
          for (p in vars) {
            temp[p] = modifier(vars[p]);
          }
          vars = temp;
        }
        _addModifiers(tween2, vars);
      };
    }
  };
};
var gsap = _gsap.registerPlugin({
  name: "attr",
  init: function init(target, vars, tween, index, targets) {
    var p, pt;
    for (p in vars) {
      pt = this.add(target, "setAttribute", (target.getAttribute(p) || 0) + "", vars[p], index, targets, 0, 0, p);
      pt && (pt.op = p);
      this._props.push(p);
    }
  }
}, {
  name: "endArray",
  init: function init2(target, value) {
    var i2 = value.length;
    while (i2--) {
      this.add(target, i2, target[i2] || 0, value[i2]);
    }
  }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap;
Tween.version = Timeline.version = gsap.version = "3.9.1";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

// node_modules/gsap/CSSPlugin.js
var _win2, _doc2, _docElement, _pluginInitted, _tempDiv, _tempDivStyler, _recentSetterPlugin, _windowExists3 = function _windowExists4() {
  return typeof window !== "undefined";
}, _transformProps = {}, _RAD2DEG = 180 / Math.PI, _DEG2RAD = Math.PI / 180, _atan2 = Math.atan2, _bigNum2 = 1e8, _capsExp = /([A-Z])/g, _horizontalExp = /(?:left|right|width|margin|padding|x)/i, _complexExp = /[\s,\(]\S/, _propertyAliases = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, _renderCSSProp = function _renderCSSProp2(ratio, data) {
  return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
}, _renderPropWithEnd = function _renderPropWithEnd2(ratio, data) {
  return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
}, _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning2(ratio, data) {
  return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u : data.b, data);
}, _renderRoundedCSSProp = function _renderRoundedCSSProp2(ratio, data) {
  var value = data.s + data.c * ratio;
  data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : 0.5)) + data.u, data);
}, _renderNonTweeningValue = function _renderNonTweeningValue2(ratio, data) {
  return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd2(ratio, data) {
  return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, _setterCSSStyle = function _setterCSSStyle2(target, property, value) {
  return target.style[property] = value;
}, _setterCSSProp = function _setterCSSProp2(target, property, value) {
  return target.style.setProperty(property, value);
}, _setterTransform = function _setterTransform2(target, property, value) {
  return target._gsap[property] = value;
}, _setterScale = function _setterScale2(target, property, value) {
  return target._gsap.scaleX = target._gsap.scaleY = value;
}, _setterScaleWithRender = function _setterScaleWithRender2(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache.scaleX = cache.scaleY = value;
  cache.renderTransform(ratio, cache);
}, _setterTransformWithRender = function _setterTransformWithRender2(target, property, value, data, ratio) {
  var cache = target._gsap;
  cache[property] = value;
  cache.renderTransform(ratio, cache);
}, _transformProp = "transform", _transformOriginProp = _transformProp + "Origin", _supports3D, _createElement = function _createElement2(type, ns) {
  var e2 = _doc2.createElementNS ? _doc2.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc2.createElement(type);
  return e2.style ? e2 : _doc2.createElement(type);
}, _getComputedProperty = function _getComputedProperty2(target, property, skipPrefixFallback) {
  var cs = getComputedStyle(target);
  return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty2(target, _checkPropPrefix(property) || property, 1) || "";
}, _prefixes = "O,Moz,ms,Ms,Webkit".split(","), _checkPropPrefix = function _checkPropPrefix2(property, element, preferPrefix) {
  var e2 = element || _tempDiv, s2 = e2.style, i2 = 5;
  if (property in s2 && !preferPrefix) {
    return property;
  }
  property = property.charAt(0).toUpperCase() + property.substr(1);
  while (i2-- && !(_prefixes[i2] + property in s2)) {
  }
  return i2 < 0 ? null : (i2 === 3 ? "ms" : i2 >= 0 ? _prefixes[i2] : "") + property;
}, _initCore = function _initCore2() {
  if (_windowExists3() && window.document) {
    _win2 = window;
    _doc2 = _win2.document;
    _docElement = _doc2.documentElement;
    _tempDiv = _createElement("div") || {
      style: {}
    };
    _tempDivStyler = _createElement("div");
    _transformProp = _checkPropPrefix(_transformProp);
    _transformOriginProp = _transformProp + "Origin";
    _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
    _supports3D = !!_checkPropPrefix("perspective");
    _pluginInitted = 1;
  }
}, _getBBoxHack = function _getBBoxHack2(swapIfPossible) {
  var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), oldParent = this.parentNode, oldSibling = this.nextSibling, oldCSS = this.style.cssText, bbox;
  _docElement.appendChild(svg);
  svg.appendChild(this);
  this.style.display = "block";
  if (swapIfPossible) {
    try {
      bbox = this.getBBox();
      this._gsapBBox = this.getBBox;
      this.getBBox = _getBBoxHack2;
    } catch (e2) {
    }
  } else if (this._gsapBBox) {
    bbox = this._gsapBBox();
  }
  if (oldParent) {
    if (oldSibling) {
      oldParent.insertBefore(this, oldSibling);
    } else {
      oldParent.appendChild(this);
    }
  }
  _docElement.removeChild(svg);
  this.style.cssText = oldCSS;
  return bbox;
}, _getAttributeFallbacks = function _getAttributeFallbacks2(target, attributesArray) {
  var i2 = attributesArray.length;
  while (i2--) {
    if (target.hasAttribute(attributesArray[i2])) {
      return target.getAttribute(attributesArray[i2]);
    }
  }
}, _getBBox = function _getBBox2(target) {
  var bounds;
  try {
    bounds = target.getBBox();
  } catch (error) {
    bounds = _getBBoxHack.call(target, true);
  }
  bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true));
  return bounds && !bounds.width && !bounds.x && !bounds.y ? {
    x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
    y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : bounds;
}, _isSVG = function _isSVG2(e2) {
  return !!(e2.getCTM && (!e2.parentNode || e2.ownerSVGElement) && _getBBox(e2));
}, _removeProperty = function _removeProperty2(target, property) {
  if (property) {
    var style = target.style;
    if (property in _transformProps && property !== _transformOriginProp) {
      property = _transformProp;
    }
    if (style.removeProperty) {
      if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
        property = "-" + property;
      }
      style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
    } else {
      style.removeAttribute(property);
    }
  }
}, _addNonTweeningPT = function _addNonTweeningPT2(plugin, target, property, beginning, end, onlySetAtEnd) {
  var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
  plugin._pt = pt;
  pt.b = beginning;
  pt.e = end;
  plugin._props.push(property);
  return pt;
}, _nonConvertibleUnits = {
  deg: 1,
  rad: 1,
  turn: 1
}, _convertToUnit = function _convertToUnit2(target, property, value, unit) {
  var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", style = _tempDiv.style, horizontal = _horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
  if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
    return curValue;
  }
  curUnit !== "px" && !toPixels && (curValue = _convertToUnit2(target, property, value, "px"));
  isSVG = target.getCTM && _isSVG(target);
  if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
    px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
    return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
  }
  style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
  parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
  if (isSVG) {
    parent = (target.ownerSVGElement || {}).parentNode;
  }
  if (!parent || parent === _doc2 || !parent.appendChild) {
    parent = _doc2.body;
  }
  cache = parent._gsap;
  if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time) {
    return _round(curValue / cache.width * amount);
  } else {
    (toPercent || curUnit === "%") && (style.position = _getComputedProperty(target, "position"));
    parent === target && (style.position = "static");
    parent.appendChild(_tempDiv);
    px = _tempDiv[measureProperty];
    parent.removeChild(_tempDiv);
    style.position = "absolute";
    if (horizontal && toPercent) {
      cache = _getCache(parent);
      cache.time = _ticker.time;
      cache.width = parent[measureProperty];
    }
  }
  return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, _get = function _get2(target, property, unit, uncache) {
  var value;
  _pluginInitted || _initCore();
  if (property in _propertyAliases && property !== "transform") {
    property = _propertyAliases[property];
    if (~property.indexOf(",")) {
      property = property.split(",")[0];
    }
  }
  if (_transformProps[property] && property !== "transform") {
    value = _parseTransform(target, uncache);
    value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
  } else {
    value = target.style[property];
    if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
      value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
    }
  }
  return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
}, _tweenComplexCSSString = function _tweenComplexCSSString2(target, prop, start, end) {
  if (!start || start === "none") {
    var p = _checkPropPrefix(prop, target, 1), s2 = p && _getComputedProperty(target, p, 1);
    if (s2 && s2 !== start) {
      prop = p;
      start = s2;
    } else if (prop === "borderColor") {
      start = _getComputedProperty(target, "borderTopColor");
    }
  }
  var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString), index = 0, matchIndex = 0, a2, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, relative, endValues;
  pt.b = start;
  pt.e = end;
  start += "";
  end += "";
  if (end === "auto") {
    target.style[prop] = end;
    end = _getComputedProperty(target, prop) || end;
    target.style[prop] = start;
  }
  a2 = [start, end];
  _colorStringFilter(a2);
  start = a2[0];
  end = a2[1];
  startValues = start.match(_numWithUnitExp) || [];
  endValues = end.match(_numWithUnitExp) || [];
  if (endValues.length) {
    while (result = _numWithUnitExp.exec(end)) {
      endValue = result[0];
      chunk = end.substring(index, result.index);
      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
        color = 1;
      }
      if (endValue !== (startValue = startValues[matchIndex++] || "")) {
        startNum = parseFloat(startValue) || 0;
        startUnit = startValue.substr((startNum + "").length);
        relative = endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
        if (relative) {
          endValue = endValue.substr(2);
        }
        endNum = parseFloat(endValue);
        endUnit = endValue.substr((endNum + "").length);
        index = _numWithUnitExp.lastIndex - endUnit.length;
        if (!endUnit) {
          endUnit = endUnit || _config.units[prop] || startUnit;
          if (index === end.length) {
            end += endUnit;
            pt.e += endUnit;
          }
        }
        if (startUnit !== endUnit) {
          startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
        }
        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
          s: startNum,
          c: relative ? relative * endNum : endNum - startNum,
          m: color && color < 4 || prop === "zIndex" ? Math.round : 0
        };
      }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : "";
  } else {
    pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
  }
  _relExp.test(end) && (pt.e = 0);
  this._pt = pt;
  return pt;
}, _keywordToPercent = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, _convertKeywordsToPercentages = function _convertKeywordsToPercentages2(value) {
  var split = value.split(" "), x = split[0], y = split[1] || "50%";
  if (x === "top" || x === "bottom" || y === "left" || y === "right") {
    value = x;
    x = y;
    y = value;
  }
  split[0] = _keywordToPercent[x] || x;
  split[1] = _keywordToPercent[y] || y;
  return split.join(" ");
}, _renderClearProps = function _renderClearProps2(ratio, data) {
  if (data.tween && data.tween._time === data.tween._dur) {
    var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i2;
    if (props === "all" || props === true) {
      style.cssText = "";
      clearTransforms = 1;
    } else {
      props = props.split(",");
      i2 = props.length;
      while (--i2 > -1) {
        prop = props[i2];
        if (_transformProps[prop]) {
          clearTransforms = 1;
          prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
        }
        _removeProperty(target, prop);
      }
    }
    if (clearTransforms) {
      _removeProperty(target, _transformProp);
      if (cache) {
        cache.svg && target.removeAttribute("transform");
        _parseTransform(target, 1);
        cache.uncache = 1;
      }
    }
  }
}, _specialProps = {
  clearProps: function clearProps(plugin, target, property, endValue, tween) {
    if (tween.data !== "isFromStart") {
      var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
      pt.u = endValue;
      pt.pr = -10;
      pt.tween = tween;
      plugin._props.push(property);
      return 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, _identity2DMatrix = [1, 0, 0, 1, 0, 0], _rotationalProperties = {}, _isNullTransform = function _isNullTransform2(value) {
  return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray2(target) {
  var matrixString = _getComputedProperty(target, _transformProp);
  return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
}, _getMatrix = function _getMatrix2(target, force2D) {
  var cache = target._gsap || _getCache(target), style = target.style, matrix = _getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
  if (cache.svg && target.getAttribute("transform")) {
    temp = target.transform.baseVal.consolidate().matrix;
    matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
    return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
  } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
    temp = style.display;
    style.display = "block";
    parent = target.parentNode;
    if (!parent || !target.offsetParent) {
      addedToDOM = 1;
      nextSibling = target.nextSibling;
      _docElement.appendChild(target);
    }
    matrix = _getComputedTransformMatrixAsArray(target);
    temp ? style.display = temp : _removeProperty(target, "display");
    if (addedToDOM) {
      nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
  }
  return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
}, _applySVGOrigin = function _applySVGOrigin2(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
  var cache = target._gsap, matrix = matrixArray || _getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a2 = matrix[0], b = matrix[1], c2 = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
  if (!originIsAbsolute) {
    bounds = _getBBox(target);
    xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
    yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
  } else if (matrix !== _identity2DMatrix && (determinant = a2 * d - b * c2)) {
    x = xOrigin * (d / determinant) + yOrigin * (-c2 / determinant) + (c2 * ty - d * tx) / determinant;
    y = xOrigin * (-b / determinant) + yOrigin * (a2 / determinant) - (a2 * ty - b * tx) / determinant;
    xOrigin = x;
    yOrigin = y;
  }
  if (smooth || smooth !== false && cache.smooth) {
    tx = xOrigin - xOriginOld;
    ty = yOrigin - yOriginOld;
    cache.xOffset = xOffsetOld + (tx * a2 + ty * c2) - tx;
    cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
  } else {
    cache.xOffset = cache.yOffset = 0;
  }
  cache.xOrigin = xOrigin;
  cache.yOrigin = yOrigin;
  cache.smooth = !!smooth;
  cache.origin = origin;
  cache.originIsAbsolute = !!originIsAbsolute;
  target.style[_transformOriginProp] = "0px 0px";
  if (pluginToAddPropTweensTo) {
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
    _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
  }
  target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, _parseTransform = function _parseTransform2(target, uncache) {
  var cache = target._gsap || new GSCache(target);
  if ("x" in cache && !uncache && !cache.uncache) {
    return cache;
  }
  var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", origin = _getComputedProperty(target, _transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a2, b, c2, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
  x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
  scaleX = scaleY = 1;
  cache.svg = !!(target.getCTM && _isSVG(target));
  matrix = _getMatrix(target, cache.svg);
  if (cache.svg) {
    t1 = (!cache.uncache || origin === "0px 0px") && !uncache && target.getAttribute("data-svg-origin");
    _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
  }
  xOrigin = cache.xOrigin || 0;
  yOrigin = cache.yOrigin || 0;
  if (matrix !== _identity2DMatrix) {
    a2 = matrix[0];
    b = matrix[1];
    c2 = matrix[2];
    d = matrix[3];
    x = a12 = matrix[4];
    y = a22 = matrix[5];
    if (matrix.length === 6) {
      scaleX = Math.sqrt(a2 * a2 + b * b);
      scaleY = Math.sqrt(d * d + c2 * c2);
      rotation = a2 || b ? _atan2(b, a2) * _RAD2DEG : 0;
      skewX = c2 || d ? _atan2(c2, d) * _RAD2DEG + rotation : 0;
      skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));
      if (cache.svg) {
        x -= xOrigin - (xOrigin * a2 + yOrigin * c2);
        y -= yOrigin - (xOrigin * b + yOrigin * d);
      }
    } else {
      a32 = matrix[6];
      a42 = matrix[7];
      a13 = matrix[8];
      a23 = matrix[9];
      a33 = matrix[10];
      a43 = matrix[11];
      x = matrix[12];
      y = matrix[13];
      z = matrix[14];
      angle = _atan2(a32, a33);
      rotationX = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a12 * cos + a13 * sin;
        t2 = a22 * cos + a23 * sin;
        t3 = a32 * cos + a33 * sin;
        a13 = a12 * -sin + a13 * cos;
        a23 = a22 * -sin + a23 * cos;
        a33 = a32 * -sin + a33 * cos;
        a43 = a42 * -sin + a43 * cos;
        a12 = t1;
        a22 = t2;
        a32 = t3;
      }
      angle = _atan2(-c2, a33);
      rotationY = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(-angle);
        sin = Math.sin(-angle);
        t1 = a2 * cos - a13 * sin;
        t2 = b * cos - a23 * sin;
        t3 = c2 * cos - a33 * sin;
        a43 = d * sin + a43 * cos;
        a2 = t1;
        b = t2;
        c2 = t3;
      }
      angle = _atan2(b, a2);
      rotation = angle * _RAD2DEG;
      if (angle) {
        cos = Math.cos(angle);
        sin = Math.sin(angle);
        t1 = a2 * cos + b * sin;
        t2 = a12 * cos + a22 * sin;
        b = b * cos - a2 * sin;
        a22 = a22 * cos - a12 * sin;
        a2 = t1;
        a12 = t2;
      }
      if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
        rotationX = rotation = 0;
        rotationY = 180 - rotationY;
      }
      scaleX = _round(Math.sqrt(a2 * a2 + b * b + c2 * c2));
      scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
      angle = _atan2(a12, a22);
      skewX = Math.abs(angle) > 2e-4 ? angle * _RAD2DEG : 0;
      perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
    }
    if (cache.svg) {
      t1 = target.getAttribute("transform");
      cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
      t1 && target.setAttribute("transform", t1);
    }
  }
  if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
    if (invertedScaleX) {
      scaleX *= -1;
      skewX += rotation <= 0 ? 180 : -180;
      rotation += rotation <= 0 ? 180 : -180;
    } else {
      scaleY *= -1;
      skewX += skewX <= 0 ? 180 : -180;
    }
  }
  cache.x = x - ((cache.xPercent = x && (cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
  cache.y = y - ((cache.yPercent = y && (cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
  cache.z = z + px;
  cache.scaleX = _round(scaleX);
  cache.scaleY = _round(scaleY);
  cache.rotation = _round(rotation) + deg;
  cache.rotationX = _round(rotationX) + deg;
  cache.rotationY = _round(rotationY) + deg;
  cache.skewX = skewX + deg;
  cache.skewY = skewY + deg;
  cache.transformPerspective = perspective + px;
  if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
    style[_transformOriginProp] = _firstTwoOnly(origin);
  }
  cache.xOffset = cache.yOffset = 0;
  cache.force3D = _config.force3D;
  cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
  cache.uncache = 0;
  return cache;
}, _firstTwoOnly = function _firstTwoOnly2(value) {
  return (value = value.split(" "))[0] + " " + value[1];
}, _addPxTranslate = function _addPxTranslate2(target, start, value) {
  var unit = getUnit(start);
  return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
}, _renderNon3DTransforms = function _renderNon3DTransforms2(ratio, cache) {
  cache.z = "0px";
  cache.rotationY = cache.rotationX = "0deg";
  cache.force3D = 0;
  _renderCSSTransforms(ratio, cache);
}, _zeroDeg = "0deg", _zeroPx = "0px", _endParenthesis = ") ", _renderCSSTransforms = function _renderCSSTransforms2(ratio, cache) {
  var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;
  if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
    var angle = parseFloat(rotationY) * _DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
    angle = parseFloat(rotationX) * _DEG2RAD;
    cos = Math.cos(angle);
    x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
    y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
    z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
  }
  if (transformPerspective !== _zeroPx) {
    transforms += "perspective(" + transformPerspective + _endParenthesis;
  }
  if (xPercent || yPercent) {
    transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
  }
  if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
    transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
  }
  if (rotation !== _zeroDeg) {
    transforms += "rotate(" + rotation + _endParenthesis;
  }
  if (rotationY !== _zeroDeg) {
    transforms += "rotateY(" + rotationY + _endParenthesis;
  }
  if (rotationX !== _zeroDeg) {
    transforms += "rotateX(" + rotationX + _endParenthesis;
  }
  if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
    transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
  }
  if (scaleX !== 1 || scaleY !== 1) {
    transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
  }
  target.style[_transformProp] = transforms || "translate(0, 0)";
}, _renderSVGTransforms = function _renderSVGTransforms2(ratio, cache) {
  var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
  rotation = parseFloat(rotation);
  skewX = parseFloat(skewX);
  skewY = parseFloat(skewY);
  if (skewY) {
    skewY = parseFloat(skewY);
    skewX += skewY;
    rotation += skewY;
  }
  if (rotation || skewX) {
    rotation *= _DEG2RAD;
    skewX *= _DEG2RAD;
    a11 = Math.cos(rotation) * scaleX;
    a21 = Math.sin(rotation) * scaleX;
    a12 = Math.sin(rotation - skewX) * -scaleY;
    a22 = Math.cos(rotation - skewX) * scaleY;
    if (skewX) {
      skewY *= _DEG2RAD;
      temp = Math.tan(skewX - skewY);
      temp = Math.sqrt(1 + temp * temp);
      a12 *= temp;
      a22 *= temp;
      if (skewY) {
        temp = Math.tan(skewY);
        temp = Math.sqrt(1 + temp * temp);
        a11 *= temp;
        a21 *= temp;
      }
    }
    a11 = _round(a11);
    a21 = _round(a21);
    a12 = _round(a12);
    a22 = _round(a22);
  } else {
    a11 = scaleX;
    a22 = scaleY;
    a21 = a12 = 0;
  }
  if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
    tx = _convertToUnit(target, "x", x, "px");
    ty = _convertToUnit(target, "y", y, "px");
  }
  if (xOrigin || yOrigin || xOffset || yOffset) {
    tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
    ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
  }
  if (xPercent || yPercent) {
    temp = target.getBBox();
    tx = _round(tx + xPercent / 100 * temp.width);
    ty = _round(ty + yPercent / 100 * temp.height);
  }
  temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
  target.setAttribute("transform", temp);
  forceCSS && (target.style[_transformProp] = temp);
}, _addRotationalPropTween = function _addRotationalPropTween2(plugin, target, property, startNum, endValue, relative) {
  var cap = 360, isString = _isString(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1), change = relative ? endNum * relative : endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
  if (isString) {
    direction = endValue.split("_")[1];
    if (direction === "short") {
      change %= cap;
      if (change !== change % (cap / 2)) {
        change += change < 0 ? cap : -cap;
      }
    }
    if (direction === "cw" && change < 0) {
      change = (change + cap * _bigNum2) % cap - ~~(change / cap) * cap;
    } else if (direction === "ccw" && change > 0) {
      change = (change - cap * _bigNum2) % cap - ~~(change / cap) * cap;
    }
  }
  plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
  pt.e = finalValue;
  pt.u = "deg";
  plugin._props.push(property);
  return pt;
}, _assign = function _assign2(target, source) {
  for (var p in source) {
    target[p] = source[p];
  }
  return target;
}, _addRawTransformPTs = function _addRawTransformPTs2(plugin, transforms, target) {
  var startCache = _assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
  if (startCache.svg) {
    startValue = target.getAttribute("transform");
    target.setAttribute("transform", "");
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    _removeProperty(target, _transformProp);
    target.setAttribute("transform", startValue);
  } else {
    startValue = getComputedStyle(target)[_transformProp];
    style[_transformProp] = transforms;
    endCache = _parseTransform(target, 1);
    style[_transformProp] = startValue;
  }
  for (p in _transformProps) {
    startValue = startCache[p];
    endValue = endCache[p];
    if (startValue !== endValue && exclude.indexOf(p) < 0) {
      startUnit = getUnit(startValue);
      endUnit = getUnit(endValue);
      startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
      endNum = parseFloat(endValue);
      plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
      plugin._pt.u = endUnit || 0;
      plugin._props.push(p);
    }
  }
  _assign(endCache, startCache);
};
_forEachName("padding,margin,Width,Radius", function(name, index) {
  var t2 = "Top", r2 = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [t2, r2, b, l] : [t2 + l, t2 + r2, b + r2, b + l]).map(function(side) {
    return index < 2 ? name + side : "border" + side + name;
  });
  _specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
    var a2, vars;
    if (arguments.length < 4) {
      a2 = props.map(function(prop) {
        return _get(plugin, prop, property);
      });
      vars = a2.join(" ");
      return vars.split(a2[0]).length === 5 ? a2[0] : vars;
    }
    a2 = (endValue + "").split(" ");
    vars = {};
    props.forEach(function(prop, i2) {
      return vars[prop] = a2[i2] = a2[i2] || a2[(i2 - 1) / 2 | 0];
    });
    plugin.init(target, vars, tween);
  };
});
var CSSPlugin = {
  name: "css",
  register: _initCore,
  targetTest: function targetTest(target) {
    return target.style && target.nodeType;
  },
  init: function init3(target, vars, tween, index, targets) {
    var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority;
    _pluginInitted || _initCore();
    for (p in vars) {
      if (p === "autoRound") {
        continue;
      }
      endValue = vars[p];
      if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
        continue;
      }
      type = typeof endValue;
      specialProp = _specialProps[p];
      if (type === "function") {
        endValue = endValue.call(tween, index, target, targets);
        type = typeof endValue;
      }
      if (type === "string" && ~endValue.indexOf("random(")) {
        endValue = _replaceRandom(endValue);
      }
      if (specialProp) {
        specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
      } else if (p.substr(0, 2) === "--") {
        startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
        endValue += "";
        _colorExp.lastIndex = 0;
        if (!_colorExp.test(startValue)) {
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
        }
        endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
        this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
        props.push(p);
      } else if (type !== "undefined") {
        if (startAt && p in startAt) {
          startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
          _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
          getUnit(startValue + "") || (startValue += _config.units[p] || getUnit(_get(target, p)) || "");
          (startValue + "").charAt(1) === "=" && (startValue = _get(target, p));
        } else {
          startValue = _get(target, p);
        }
        startNum = parseFloat(startValue);
        relative = type === "string" && endValue.charAt(1) === "=" ? +(endValue.charAt(0) + "1") : 0;
        relative && (endValue = endValue.substr(2));
        endNum = parseFloat(endValue);
        if (p in _propertyAliases) {
          if (p === "autoAlpha") {
            if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
              startNum = 0;
            }
            _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
          }
          if (p !== "scale" && p !== "transform") {
            p = _propertyAliases[p];
            ~p.indexOf(",") && (p = p.split(",")[0]);
          }
        }
        isTransformRelated = p in _transformProps;
        if (isTransformRelated) {
          if (!transformPropTween) {
            cache = target._gsap;
            cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform);
            smooth = vars.smoothOrigin !== false && cache.smooth;
            transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1);
            transformPropTween.dep = 1;
          }
          if (p === "scale") {
            this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? relative * endNum : endNum - cache.scaleY) || 0);
            props.push("scaleY", p);
            p += "X";
          } else if (p === "transformOrigin") {
            endValue = _convertKeywordsToPercentages(endValue);
            if (cache.svg) {
              _applySVGOrigin(target, endValue, 0, smooth, 0, this);
            } else {
              endUnit = parseFloat(endValue.split(" ")[2]) || 0;
              endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
              _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
            }
            continue;
          } else if (p === "svgOrigin") {
            _applySVGOrigin(target, endValue, 1, smooth, 0, this);
            continue;
          } else if (p in _rotationalProperties) {
            _addRotationalPropTween(this, cache, p, startNum, endValue, relative);
            continue;
          } else if (p === "smoothOrigin") {
            _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
            continue;
          } else if (p === "force3D") {
            cache[p] = endValue;
            continue;
          } else if (p === "transform") {
            _addRawTransformPTs(this, endValue, target);
            continue;
          }
        } else if (!(p in style)) {
          p = _checkPropPrefix(p) || p;
        }
        if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
          startUnit = (startValue + "").substr((startNum + "").length);
          endNum || (endNum = 0);
          endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
          startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
          this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, relative ? relative * endNum : endNum - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
          this._pt.u = endUnit || 0;
          if (startUnit !== endUnit && endUnit !== "%") {
            this._pt.b = startValue;
            this._pt.r = _renderCSSPropWithBeginning;
          }
        } else if (!(p in style)) {
          if (p in target) {
            this.add(target, p, startValue || target[p], endValue, index, targets);
          } else {
            _missingPlugin(p, endValue);
            continue;
          }
        } else {
          _tweenComplexCSSString.call(this, target, p, startValue, endValue);
        }
        props.push(p);
      }
    }
    hasPriority && _sortPropTweensByPriority(this);
  },
  get: _get,
  aliases: _propertyAliases,
  getSetter: function getSetter(target, property, plugin) {
    var p = _propertyAliases[property];
    p && p.indexOf(",") < 0 && (property = p);
    return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
  },
  core: {
    _removeProperty,
    _getMatrix
  }
};
gsap.utils.checkPrefix = _checkPropPrefix;
(function(positionAndScale, rotation, others, aliases) {
  var all = _forEachName(positionAndScale + "," + rotation + "," + others, function(name) {
    _transformProps[name] = 1;
  });
  _forEachName(rotation, function(name) {
    _config.units[name] = "deg";
    _rotationalProperties[name] = 1;
  });
  _propertyAliases[all[13]] = positionAndScale + "," + rotation;
  _forEachName(aliases, function(name) {
    var split = name.split(":");
    _propertyAliases[split[1]] = all[split[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
_forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
  _config.units[name] = "px";
});
gsap.registerPlugin(CSSPlugin);

// node_modules/gsap/index.js
var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap, TweenMaxWithCSS = gsapWithCSS.core.Tween;

// src/animations/details-option-card.js
gsapWithCSS.registerPlugin();
var duration = 0.3;
var DetailsOptionCard = class {
  constructor() {
  }
  /**
   * Open details element.
   *
   * @param {HTMLElement} detailsElement
   */
  openDetailsElement(detailsElement) {
    const contentElement = detailsElement.querySelector(".details__content");
    const innerContentElement = contentElement ? contentElement.querySelector(".content__inner") : null;
    const clientHeight = innerContentElement ? innerContentElement.clientHeight : null;
    if (contentElement && clientHeight) {
      gsapWithCSS.fromTo(
        contentElement,
        {
          height: "0px"
        },
        {
          height: `${clientHeight}px`,
          duration
        }
      );
      gsapWithCSS.to(contentElement, {
        height: "auto"
      });
    }
  }
  /**
   * Close details element.
   *
   * @param {HTMLElement} detailsElement
   */
  closeDetailsElement(detailsElement) {
    const contentElement = detailsElement.querySelector(".details__content");
    gsapWithCSS.to(contentElement, {
      height: "0px",
      duration
    });
  }
  /**
   * Update height of the details element.
   *
   * @param {HTMLElement} detailsElement
   */
  updateHeight(detailsElement) {
    const contentElement = detailsElement.querySelector(".details__content");
    const innerContentElement = contentElement ? contentElement.querySelector(".content__inner") : null;
    gsapWithCSS.to(contentElement, {
      height: `${innerContentElement.clientHeight}px`,
      duration
    });
  }
};
var details_option_card_default = new DetailsOptionCard();

// node_modules/gsap/ScrollToPlugin.js
var gsap2, _coreInitted2, _window, _docEl, _body, _toArray, _config2, _windowExists5 = function _windowExists6() {
  return typeof window !== "undefined";
}, _getGSAP = function _getGSAP2() {
  return gsap2 || _windowExists5() && (gsap2 = window.gsap) && gsap2.registerPlugin && gsap2;
}, _isString3 = function _isString4(value) {
  return typeof value === "string";
}, _isFunction3 = function _isFunction4(value) {
  return typeof value === "function";
}, _max = function _max2(element, axis) {
  var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
  return element === _window || element === _docEl || element === _body ? Math.max(_docEl[scroll], _body[scroll]) - (_window["inner" + dim] || _docEl[client] || _body[client]) : element[scroll] - element["offset" + dim];
}, _buildGetter = function _buildGetter2(e2, axis) {
  var p = "scroll" + (axis === "x" ? "Left" : "Top");
  if (e2 === _window) {
    if (e2.pageXOffset != null) {
      p = "page" + axis.toUpperCase() + "Offset";
    } else {
      e2 = _docEl[p] != null ? _docEl : _body;
    }
  }
  return function() {
    return e2[p];
  };
}, _clean = function _clean2(value, index, target, targets) {
  _isFunction3(value) && (value = value(index, target, targets));
  if (typeof value !== "object") {
    return _isString3(value) && value !== "max" && value.charAt(1) !== "=" ? {
      x: value,
      y: value
    } : {
      y: value
    };
  } else if (value.nodeType) {
    return {
      y: value,
      x: value
    };
  } else {
    var result = {}, p;
    for (p in value) {
      result[p] = p !== "onAutoKill" && _isFunction3(value[p]) ? value[p](index, target, targets) : value[p];
    }
    return result;
  }
}, _getOffset = function _getOffset2(element, container) {
  element = _toArray(element)[0];
  if (!element || !element.getBoundingClientRect) {
    return console.warn("scrollTo target doesn't exist. Using 0") || {
      x: 0,
      y: 0
    };
  }
  var rect = element.getBoundingClientRect(), isRoot = !container || container === _window || container === _body, cRect = isRoot ? {
    top: _docEl.clientTop - (_window.pageYOffset || _docEl.scrollTop || _body.scrollTop || 0),
    left: _docEl.clientLeft - (_window.pageXOffset || _docEl.scrollLeft || _body.scrollLeft || 0)
  } : container.getBoundingClientRect(), offsets = {
    x: rect.left - cRect.left,
    y: rect.top - cRect.top
  };
  if (!isRoot && container) {
    offsets.x += _buildGetter(container, "x")();
    offsets.y += _buildGetter(container, "y")();
  }
  return offsets;
}, _parseVal = function _parseVal2(value, target, axis, currentVal, offset) {
  return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : _isString3(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? _max(target, axis) - offset : Math.min(_max(target, axis), _getOffset(value, target)[axis] - offset);
}, _initCore3 = function _initCore4() {
  gsap2 = _getGSAP();
  if (_windowExists5() && gsap2 && document.body) {
    _window = window;
    _body = document.body;
    _docEl = document.documentElement;
    _toArray = gsap2.utils.toArray;
    gsap2.config({
      autoKillThreshold: 7
    });
    _config2 = gsap2.config();
    _coreInitted2 = 1;
  }
};
var ScrollToPlugin = {
  version: "3.9.1",
  name: "scrollTo",
  rawVars: 1,
  register: function register(core) {
    gsap2 = core;
    _initCore3();
  },
  init: function init4(target, value, tween, index, targets) {
    _coreInitted2 || _initCore3();
    var data = this, snapType = gsap2.getProperty(target, "scrollSnapType");
    data.isWin = target === _window;
    data.target = target;
    data.tween = tween;
    value = _clean(value, index, target, targets);
    data.vars = value;
    data.autoKill = !!value.autoKill;
    data.getX = _buildGetter(target, "x");
    data.getY = _buildGetter(target, "y");
    data.x = data.xPrev = data.getX();
    data.y = data.yPrev = data.getY();
    if (snapType && snapType !== "none") {
      data.snap = 1;
      data.snapInline = target.style.scrollSnapType;
      target.style.scrollSnapType = "none";
    }
    if (value.x != null) {
      data.add(data, "x", data.x, _parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
      data._props.push("scrollTo_x");
    } else {
      data.skipX = 1;
    }
    if (value.y != null) {
      data.add(data, "y", data.y, _parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
      data._props.push("scrollTo_y");
    } else {
      data.skipY = 1;
    }
  },
  render: function render(ratio, data) {
    var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap3 = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
    x = isWin || !data.skipX ? data.getX() : xPrev;
    y = isWin || !data.skipY ? data.getY() : yPrev;
    yDif = y - yPrev;
    xDif = x - xPrev;
    threshold = _config2.autoKillThreshold;
    if (data.x < 0) {
      data.x = 0;
    }
    if (data.y < 0) {
      data.y = 0;
    }
    if (autoKill) {
      if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < _max(target, "x")) {
        data.skipX = 1;
      }
      if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < _max(target, "y")) {
        data.skipY = 1;
      }
      if (data.skipX && data.skipY) {
        tween.kill();
        data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
      }
    }
    if (isWin) {
      _window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
    } else {
      data.skipY || (target.scrollTop = data.y);
      data.skipX || (target.scrollLeft = data.x);
    }
    if (snap3 && (ratio === 1 || ratio === 0)) {
      y = target.scrollTop;
      x = target.scrollLeft;
      snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
      target.scrollTop = y + 1;
      target.scrollLeft = x + 1;
      target.scrollTop = y;
      target.scrollLeft = x;
    }
    data.xPrev = data.x;
    data.yPrev = data.y;
  },
  kill: function kill(property) {
    var both = property === "scrollTo";
    if (both || property === "scrollTo_x") {
      this.skipX = 1;
    }
    if (both || property === "scrollTo_y") {
      this.skipY = 1;
    }
  }
};
ScrollToPlugin.max = _max;
ScrollToPlugin.getOffset = _getOffset;
ScrollToPlugin.buildGetter = _buildGetter;
_getGSAP() && gsap2.registerPlugin(ScrollToPlugin);

// src/utils/normalize-property.js
var stripAndLower = (value) => String(value != null ? value : "").toLowerCase().replace(/\s+/g, "");
var SLAT_WIDTH = {
  "25mm": "25mm",
  "50mm": "50mm",
  "65mm": "65mm"
};
var LADDER_CORD = "ladderkoord";
var LADDER_BAND = "ladderband";
var LADDER_TAPING = {
  ladderkoord: LADDER_CORD,
  laddercord: LADDER_CORD,
  cord: LADDER_CORD,
  leiterschnur: LADDER_CORD,
  ladderband: LADDER_BAND,
  ladderstrap: LADDER_BAND,
  laddertape: LADDER_BAND,
  strap: LADDER_BAND,
  ladderkleber: LADDER_BAND,
  leiterband: LADDER_BAND
};
var LADDER_TAPING_STEMS = [
  [/koord|kord|cord|schnur|corde|cuerda/, LADDER_CORD],
  [/band|tape|strap|kleber|ruban|cinta|nastro/, LADDER_BAND]
];
var foldLabel = (value) => String(value != null ? value : "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
var translatedLadderLabels = () => {
  const product = typeof window !== "undefined" ? window.product : null;
  return {
    [foldLabel(product == null ? void 0 : product.ladderkoord)]: LADDER_CORD,
    [foldLabel(product == null ? void 0 : product.ladderband)]: LADDER_BAND
  };
};
var resolveLadderTaping = (value) => {
  const key = foldLabel(value);
  if (!key)
    return null;
  if (LADDER_TAPING[key])
    return LADDER_TAPING[key];
  const translated = translatedLadderLabels()[key];
  if (translated)
    return translated;
  const stem = LADDER_TAPING_STEMS.find(([pattern]) => pattern.test(key));
  return stem ? stem[1] : null;
};
var LADDER_TAPING_VARIANT_TOKENS = {
  [LADDER_CORD]: "ladderCord",
  [LADDER_BAND]: "ladderStrap"
};
var ladderTapingVariantToken = (value) => {
  const canonical = resolveLadderTaping(value);
  return canonical ? LADDER_TAPING_VARIANT_TOKENS[canonical] : null;
};
var ladderTapingVariantTokenFromElement = (element) => {
  var _a, _b;
  if (!element)
    return null;
  const candidates = [
    (_a = element.getAttribute) == null ? void 0 : _a.call(element, "data-canonical-value"),
    (_b = element.getAttribute) == null ? void 0 : _b.call(element, "data-variant-option-value"),
    element.value
  ];
  for (const candidate of candidates) {
    const token = ladderTapingVariantToken(candidate);
    if (token)
      return token;
  }
  return null;
};
var COLOR_STYLE_PREMIUM = "premium";
var COLOR_STYLE_BASIC = "basic";
var COLOR_STYLE = {
  premium: COLOR_STYLE_PREMIUM,
  pramie: COLOR_STYLE_PREMIUM,
  praemie: COLOR_STYLE_PREMIUM,
  premie: COLOR_STYLE_PREMIUM,
  basic: COLOR_STYLE_BASIC,
  basis: COLOR_STYLE_BASIC,
  standaard: COLOR_STYLE_BASIC
};
var resolveColorStyle = (value) => {
  const key = foldLabel(value);
  if (!key)
    return null;
  if (COLOR_STYLE[key])
    return COLOR_STYLE[key];
  const product = typeof window !== "undefined" ? window.product : null;
  if (key === foldLabel(product == null ? void 0 : product.premium))
    return COLOR_STYLE_PREMIUM;
  if (key === foldLabel(product == null ? void 0 : product.basic))
    return COLOR_STYLE_BASIC;
  return null;
};
var resolveSlatWidth = (value) => {
  const match = foldLabel(value).match(/^(\d{2,3})mm$/);
  return match ? `${match[1]}mm` : null;
};
var OPTION_VALUE_RESOLVERS = [resolveLadderTaping, resolveColorStyle, resolveSlatWidth];
var optionValuesMatch = (selectedValue, variantValue) => {
  const selected = foldLabel(selectedValue);
  const variant = foldLabel(variantValue);
  if (!selected || !variant)
    return false;
  if (selected === variant)
    return true;
  return OPTION_VALUE_RESOLVERS.some((resolve) => {
    const resolvedSelected = resolve(selectedValue);
    const resolvedVariant = resolve(variantValue);
    return Boolean(resolvedSelected) && resolvedSelected === resolvedVariant;
  });
};
var COLOR_KEYWORD = {
  matchend: "matchend",
  matching: "matchend",
  passend: "matchend",
  black: "black",
  zwart: "black",
  schwarz: "black",
  white: "white",
  wit: "white",
  weiss: "white",
  wei\u00DF: "white"
};
var CONTROLS = {
  shared: "shared",
  gedeeld: "shared",
  geteilt: "shared",
  left: "left",
  links: "left",
  right: "right",
  rechts: "right"
};
var FRAME_SPACING = {
  betweenframe: "betweenFrame",
  tussendedag: "betweenFrame",
  indedag: "betweenFrame",
  inderlaibung: "betweenFrame",
  zwischendemrahmen: "betweenFrame",
  insidemount: "betweenFrame",
  onframe: "onFrame",
  opdedag: "onFrame",
  aufderlaibung: "onFrame",
  aufdemrahmen: "onFrame",
  outsidemount: "onFrame"
};
var lookup = (map, value) => {
  var _a;
  if (value == null || value === "")
    return value;
  return (_a = map[stripAndLower(value)]) != null ? _a : value;
};
var normalizeSlatWidth = (value) => lookup(SLAT_WIDTH, value);
var normalizeLadderTaping = (value) => {
  var _a;
  if (value == null || value === "")
    return value;
  return (_a = resolveLadderTaping(value)) != null ? _a : value;
};
var normalizeColorKeyword = (value) => lookup(COLOR_KEYWORD, value);
var normalizeControls = (value) => lookup(CONTROLS, value);
var normalizeFrameSpacing = (value) => lookup(FRAME_SPACING, value);
var OPTION_VALUE_NORMALIZERS = {
  slatWidth: normalizeSlatWidth,
  ladderTaping: normalizeLadderTaping,
  ladderTapingColor: normalizeColorKeyword,
  topBottomRailColor: normalizeColorKeyword,
  controls: normalizeControls,
  frameSpacing: normalizeFrameSpacing,
  colorStyle: (value) => {
    var _a;
    return (_a = resolveColorStyle(value)) != null ? _a : value;
  }
};
var canonicalOptionValue = (optionName, value) => {
  const normalize3 = OPTION_VALUE_NORMALIZERS[optionName];
  return normalize3 ? normalize3(value) : value;
};
var URL_PARAM_OPTIONS = {
  sw: "slatWidth",
  f: "frameSpacing",
  lt: "ladderTaping",
  "lt-col": "ladderTapingColor",
  con: "controls",
  tbr: "topBottomRailColor"
};
var CANONICAL_URL_VALUES = {
  ladderTaping: [LADDER_CORD, LADDER_BAND],
  frameSpacing: ["betweenFrame", "onFrame"],
  controls: ["shared", "left", "right"],
  ladderTapingColor: ["matchend", "black", "white"],
  topBottomRailColor: ["matchend", "black", "white"]
};
var URL_VALUE_SAFETY_NET = {
  ladderTaping: {
    ladderkoord: LADDER_CORD,
    laddercord: LADDER_CORD,
    leiterschnur: LADDER_CORD,
    koord: LADDER_CORD,
    schnur: LADDER_CORD,
    cord: LADDER_CORD,
    ladderband: LADDER_BAND,
    ladderstrap: LADDER_BAND,
    laddertape: LADDER_BAND,
    leiterband: LADDER_BAND,
    band: LADDER_BAND,
    tape: LADDER_BAND,
    strap: LADDER_BAND
  },
  frameSpacing: {
    indedag: "betweenFrame",
    tussendedag: "betweenFrame",
    zwischendemrahmen: "betweenFrame",
    zwischenrahmen: "betweenFrame",
    betweenframe: "betweenFrame",
    inframe: "betweenFrame",
    opdedag: "onFrame",
    aufdemrahmen: "onFrame",
    aufrahmen: "onFrame",
    onframe: "onFrame"
  },
  controls: {
    gedeeld: "shared",
    geteilt: "shared",
    shared: "shared",
    links: "left",
    left: "left",
    rechts: "right",
    right: "right"
  },
  ladderTapingColor: {
    matchend: "matchend",
    matching: "matchend",
    passend: "matchend",
    zwart: "black",
    schwarz: "black",
    black: "black",
    wit: "white",
    weiss: "white",
    white: "white"
  }
};
URL_VALUE_SAFETY_NET.topBottomRailColor = URL_VALUE_SAFETY_NET.ladderTapingColor;
var canonicalUrlValue = (param, value) => {
  var _a, _b;
  const optionName = URL_PARAM_OPTIONS[param];
  if (!optionName || value == null || value === "")
    return value;
  const resolved = canonicalOptionValue(optionName, value);
  const allowed = CANONICAL_URL_VALUES[optionName];
  if (!allowed || allowed.includes(resolved))
    return resolved;
  return (_b = (_a = URL_VALUE_SAFETY_NET[optionName]) == null ? void 0 : _a[foldLabel(value)]) != null ? _b : resolved;
};
var canonicalizeUrlOptionValues = (url) => {
  let changed = false;
  Object.keys(URL_PARAM_OPTIONS).forEach((param) => {
    const value = url.searchParams.get(param);
    if (value == null || value === "")
      return;
    const canonical = canonicalUrlValue(param, value);
    if (canonical != null && canonical !== value) {
      url.searchParams.set(param, canonical);
      changed = true;
    }
  });
  return changed;
};
var findOptionInput = (fieldsetName, value, root = typeof document !== "undefined" ? document : null) => {
  var _a;
  const fieldset = (_a = root == null ? void 0 : root.querySelector) == null ? void 0 : _a.call(root, `fieldset[name="${fieldsetName}"]`);
  if (!fieldset)
    return null;
  const inputs = Array.from(fieldset.querySelectorAll("input"));
  return inputs.find((input) => input.value === value) || inputs.find((input) => optionValuesMatch(input.getAttribute("data-canonical-value") || input.value, value)) || null;
};

// src/utils/product-handlers.js
var handleFoundCorrectVariant = (variantData) => {
  handleSetVariant(variantData);
};
var handleSetVariant = (variant) => {
  const variantId = variant.id;
  setVariantId(variantId);
};
var handleVariantImage = async () => {
};
var handleFieldsetChange = (fieldsetElement, updateProductMedia) => {
  const searchParameter = fieldsetElement.dataset.searchName;
  const detailsElement = fieldsetElement.closest(".details");
  const currentValue = getValueFromFieldset(fieldsetElement);
  const translatedValue = getTranslatedValueFromFieldset(fieldsetElement);
  if (currentValue) {
    setValueInUrl(canonicalOptionValue(fieldsetElement.getAttribute("name"), currentValue), searchParameter);
    setDetailsToValid(detailsElement);
    setValueInDetails(detailsElement, translatedValue || currentValue);
    setFieldsetState(fieldsetElement);
    if (updateProductMedia) {
      handleVariantImage();
    }
  }
};
var handleMinMaxSizeChange = (selectedColorObject) => {
  const slatWidthFieldsetElement = document.querySelector(
    'fieldset[name="slatWidth"]'
  );
  const ladderTappingFieldsetElement = document.querySelector(
    'fieldset[name="ladderTaping"]'
  );
  const slatWidthValue = normalizeSlatWidth(getValueFromFieldset(slatWidthFieldsetElement));
  const ladderTappingElement = ladderTappingFieldsetElement == null ? void 0 : ladderTappingFieldsetElement.querySelector(
    'input[name="ladderTaping"]:checked'
  );
  const ladderTappingToken = ladderTapingVariantTokenFromElement(ladderTappingElement) || ladderTapingVariantToken(getValueFromFieldset(ladderTappingFieldsetElement)) || "ladderCord";
  const widthInput = document.querySelector(
    'fieldset[name="size"] input[name="width"]'
  );
  const heightInput = document.querySelector(
    'fieldset[name="size"] input[name="height"]'
  );
  const slatWidthKey = slatWidthValue === "25mm" ? "25-mm" : "50-mm";
  const sizingObject = selectedColorObject.variants[`${slatWidthKey}-${ladderTappingToken}`] || selectedColorObject.variants[`${slatWidthKey}-ladderCord`] || null;
  const maxWidthValue = sizingObject ? sizingObject["max-width"] : null;
  const maxHeightValue = sizingObject ? sizingObject["max-height"] : null;
  const minWidthValue = sizingObject ? sizingObject["min-width"] : null;
  const minHeightValue = sizingObject ? sizingObject["min-height"] : null;
  if (widthInput && minWidthValue) {
    setValueInputMin(minWidthValue, widthInput);
  } else {
    console.warn("No width input or min width value could be set for this color");
  }
  if (heightInput && minHeightValue) {
    setValueInputMin(minHeightValue, heightInput);
  } else {
    console.warn("No height input or min height value could be set for this color");
  }
  if (widthInput && maxWidthValue) {
    setValueInputMax(maxWidthValue, widthInput);
  } else {
    console.warn("No width input or max width value could be set for this color");
  }
  if (heightInput && maxHeightValue) {
    setValueInputMax(maxHeightValue, heightInput);
  } else {
    console.warn("No height input or max height value could be set for this color");
  }
};

// src/utils/product.js
gsapWithCSS.registerPlugin(ScrollToPlugin);
var ladderTapingTokenFromSelector = (variantElement, value, fallback = "ladderCord") => {
  const checkedElement = variantElement == null ? void 0 : variantElement.querySelector(
    'input[name="ladderTaping"]:checked'
  );
  return ladderTapingVariantTokenFromElement(checkedElement) || ladderTapingVariantToken(value) || value || fallback;
};
var areAllOptionsValid = () => {
  const allFieldsetElements = document.querySelectorAll(
    "product-form fieldset[data-progress-value]"
  );
  const arrayWithAllFieldsetElements = allFieldsetElements ? [...allFieldsetElements] : null;
  const indexTotalFieldsets = arrayWithAllFieldsetElements ? arrayWithAllFieldsetElements.length + 1 : null;
  const allValidFieldsets = document.querySelectorAll(
    'product-form fieldset[data-progress-value][data-state="valid"]'
  );
  const arrayWithAllValidFieldsetElements = allValidFieldsets ? [...allValidFieldsets] : null;
  const indexTotalValidFieldsets = arrayWithAllValidFieldsetElements ? arrayWithAllValidFieldsetElements.length + 1 : null;
  return returnBooleanOrNull(indexTotalFieldsets === indexTotalValidFieldsets);
};
var getStateDetailsElement = (detailsElement) => {
  if (detailsElement.classList.contains("js-open")) {
    return {
      state: "open",
      isDetailsOpen: true
    };
  } else {
    return {
      state: "closed",
      isDetailsOpen: false
    };
  }
};
var closeAllDetailsElements = (currentDetailsElement) => {
  const parentElement = currentDetailsElement.closest("section");
  const allDetailsElements = parentElement.querySelectorAll(".details");
  allDetailsElements.forEach((detailsElement) => {
    if (detailsElement !== currentDetailsElement) {
      closeDetailsElement(detailsElement);
    }
  });
};
var openDetailsElement = (detailsElement) => {
  const chevronIconElement = detailsElement.querySelector(".icon-chevron");
  details_option_card_default.openDetailsElement(detailsElement);
  closeAllDetailsElements(detailsElement);
  detailsElement.classList.add("js-open");
  if (chevronIconElement) {
    chevronIconElement.classList.remove("js-closed");
    chevronIconElement.classList.add("js-open");
  }
  window.addEventListener("resize", () => {
    if (getStateDetailsElement(detailsElement).isDetailsOpen === true) {
      details_option_card_default.updateHeight(detailsElement);
    }
  });
};
var onlyOpenDetailsElement = (detailsElement) => {
  const chevronIconElement = detailsElement.querySelector(".icon-chevron");
  details_option_card_default.openDetailsElement(detailsElement);
  detailsElement.classList.add("js-open");
  if (chevronIconElement) {
    chevronIconElement.classList.remove("js-closed");
    chevronIconElement.classList.add("js-open");
  }
  window.addEventListener("resize", () => {
    if (getStateDetailsElement(detailsElement).isDetailsOpen === true) {
      details_option_card_default.updateHeight(detailsElement);
    }
  });
};
var closeDetailsElement = (detailsElement) => {
  const chevronIconElement = detailsElement.querySelector(".icon-chevron");
  details_option_card_default.closeDetailsElement(detailsElement);
  detailsElement.classList.remove("js-open");
  if (chevronIconElement) {
    chevronIconElement.classList.add("js-closed");
    chevronIconElement.classList.remove("js-open");
  }
};
var setValueInUrl = (value, searchValue) => {
  const currentUrl = new URL(window.location.href);
  const urlSafeValue = encodeURI(value);
  currentUrl.searchParams.set(searchValue, urlSafeValue);
  window.history.replaceState({}, "", `${currentUrl.toString()}`);
};
var setValueInDetails = (detailsElement, value) => {
  const summaryOptionValueElement = detailsElement.querySelector(".option-value");
  summaryOptionValueElement.innerHTML = value;
};
var setDetailsToValid = (detailsElement) => {
  detailsElement.classList.add("js-valid");
};
var setDetailsToInvalid = (detailsElement) => {
  detailsElement.classList.remove("js-valid");
};
var setFieldsetState = (fieldsetElement) => {
  fieldsetElement.dataset.state = "valid";
  const event2 = new Event("UpdateStatusBar");
  document.dispatchEvent(event2);
};
var setValueFromUrlOrReturnNull = (fieldsetElement) => {
  const searchParameterName = fieldsetElement.dataset.searchName;
  const parameterValue = getValueFromSearchInUrl(searchParameterName);
  const inputElement = fieldsetElement.querySelector(
    `input[value="${parameterValue}"]`
  );
  if (inputElement) {
    inputElement.checked = true;
    handleFieldsetChange(fieldsetElement);
  } else {
    return null;
  }
};
var areAllVariantElementsAValidVariant = () => {
  const parentVariantsElement = document.querySelector("product-form");
  const allVariantElements = parentVariantsElement.querySelectorAll(".variant");
  const correctVariant = getCorrectVariantFromOptions(allVariantElements);
  return returnBooleanOrNull(correctVariant !== null);
};
var returnCorrectVariant = () => {
  const parentVariantsElement = document.querySelector("product-form");
  const allVariantElements = parentVariantsElement.querySelectorAll(".variant");
  const correctVariant = getCorrectVariantFromOptions(allVariantElements);
  return returnObjectOrNull(correctVariant);
};
var returnPartialCorrectVariants = () => {
  const parentVariantsElement = document.querySelector("product-form");
  const allVariantElements = parentVariantsElement.querySelectorAll(".variant");
  const correctVariants = getAllPartiallyCorrectVariantsFromOptions(allVariantElements);
  return returnArrayOrNull(correctVariants);
};
var lowestPrice = (variantData) => {
  let lowestPrice2 = null;
  if (variantData) {
    lowestPrice2 = Math.min(...variantData.map((variant) => variant.price));
  }
  return returnNumberOrNull(Number(lowestPrice2));
};
var insertImageFormat = (image, sizes) => {
  let imageUrl = image.replace(".png", sizes + ".png");
  imageUrl = image.replace(".jpg", sizes + ".jpg");
  return imageUrl;
};
var setImagesInProductMediaSlider = (images, color) => {
  const productMediaElement = document.querySelector(".product-media-scroll");
  const navProductMediaElement = document.querySelector(".thumbs-product-media-scroll");
  const imageFormat = "_613x766";
  if (images && images.length > 0) {
    productMediaElement.innerHTML = "";
    navProductMediaElement.innerHTML = "";
    images.forEach((image, index) => {
      const baseImage = insertImageFormat(image, imageFormat);
      const thumbnailImage = insertImageFormat(image, "_30x40");
      if (baseImage) {
        productMediaElement.insertAdjacentHTML("beforeEnd", createProductMediaSlider(image, baseImage, color, index));
        navProductMediaElement.insertAdjacentHTML("beforeEnd", createProductMediaThumbnail(thumbnailImage, color, index));
      }
    });
  }
};
var getCorrectColorFromTitle = (title, data) => returnObjectOrNull(data.find((element) => element.title === title));
var getImageValuesFromData = (data) => {
  const imageArray = [];
  const images25mmLadderkoordArray = [];
  const images25mmLadderbandArray = [];
  const images50mmLadderkoordArray = [];
  const images50mmLadderbandArray = [];
  if (data) {
    for (const [key, value] of Object.entries(data)) {
      if (key.includes("image")) {
        if (key.includes("25")) {
          if (key.includes("ladderkoord")) {
            images25mmLadderkoordArray.push(value);
          } else {
            images25mmLadderbandArray.push(value);
          }
        } else if (key.includes("50")) {
          if (key.includes("ladderkoord")) {
            images50mmLadderkoordArray.push(value);
          } else {
            images50mmLadderbandArray.push(value);
          }
        } else {
          imageArray.push(value);
        }
      }
    }
  }
  return returnObjectOrNull({
    images: imageArray,
    images25mm: {
      ladderkoord: images25mmLadderkoordArray,
      ladderband: images25mmLadderbandArray
    },
    images50mm: {
      ladderkoord: images50mmLadderkoordArray,
      ladderband: images50mmLadderbandArray
    }
  });
};
var getColorData = () => {
  const colorDataJSON = document.querySelector("#colors-data");
  const colorDataObject = colorDataJSON ? JSON.parse(colorDataJSON.innerHTML).colors : null;
  return returnArrayOrNull(colorDataObject);
};
var getProductMaterial = () => {
  const productMaterialElement = document.querySelector(
    'input[name="material"]'
  );
  if (productMaterialElement && productMaterialElement.value.includes("wood")) {
    return returnStringOrNull("houten");
  } else {
    return returnStringOrNull("aluminium");
  }
};
var getValueFromFieldset = (fieldsetElement) => {
  if (!fieldsetElement)
    return null;
  const name = fieldsetElement.getAttribute("name");
  const checkedElement = fieldsetElement.querySelector(
    `input[name="${name}"]:checked`
  );
  return returnStringOrNull(checkedElement ? checkedElement.value : null);
};
var getTranslatedValueFromFieldset = (fieldsetElement) => {
  if (!fieldsetElement)
    return null;
  const name = fieldsetElement.getAttribute("name");
  const checkedElement = fieldsetElement.querySelector(
    `input[name="${name}"]:checked`
  );
  return returnStringOrNull(checkedElement ? checkedElement.getAttribute("data-translated-value") : null);
};
var getAllVariants = () => {
  const variantsDataElement = document.getElementById("variants-data");
  const allVariants = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
  return returnObjectOrNull(allVariants);
};
var getAllSwatchVariants = (productMaterial) => {
  const variantsDataElement = document.querySelector(`.swatch-variants-data[data-material="${productMaterial}"]`);
  const allVariants = variantsDataElement ? JSON.parse(variantsDataElement.innerHTML).variants : null;
  return returnObjectOrNull(allVariants);
};
var getValueFromVariantSelector = (variantElement, optionName) => {
  const checkedElement = variantElement.querySelector(
    `input[name="${optionName}"]:checked`
  );
  return returnStringOrNull(checkedElement ? checkedElement.value : null);
};
var getCorrectVariantFromOptions = (variantOptions) => {
  const allVariants = getAllVariants();
  if (allVariants != null) {
    let selectedOptions = "";
    variantOptions.forEach((variantElement) => {
      const optionName = variantElement.dataset.optionName;
      let value = getValueFromVariantSelector(variantElement, optionName) || null;
      if (optionName === "ladderTaping") {
        value = ladderTapingTokenFromSelector(variantElement, value);
      } else if (optionName === "slatWidth") {
        if (value === "25 mm" || value === "25mm") {
          value = "25mm";
        }
        if (value === "50 mm") {
          value = "50mm";
        }
        if (!value) {
          value = "50mm";
        }
      }
      if (value !== null) {
        selectedOptions = selectedOptions + " - " + value.toLowerCase();
      }
    });
    selectedOptions = selectedOptions.slice(3);
    return returnObjectOrNull(
      allVariants.find((element) => element.options.toLowerCase() === selectedOptions)
    );
  }
  return null;
};
var getCorrectColorVariantData = (variantOptions, colorData) => {
  if (colorData != null) {
    let selectedOptions = "";
    let returnDefault = true;
    const currentUrl = new URL(window.location.href);
    const searchParams = new URLSearchParams(currentUrl.search);
    const ladderTapping = searchParams.get("lt");
    if (ladderTapping) {
      returnDefault = false;
    }
    variantOptions.forEach((variantElement) => {
      const optionName = variantElement.dataset.optionName;
      let value = getValueFromVariantSelector(variantElement, optionName) || null;
      if (optionName === "ladderTaping") {
        if (!value && !returnDefault) {
          return null;
        }
        value = ladderTapingTokenFromSelector(variantElement, value);
      } else if (optionName === "slatWidth") {
        if (value === "25 mm" || value === "25mm") {
          value = "50-mm";
        }
        if (value === "50 mm") {
          value = "50-mm";
        }
        if (value === "50mm") {
          value = "50-mm";
        }
        if (!value) {
          value = "50-mm";
        }
      }
      if (value !== null) {
        selectedOptions = selectedOptions + "-" + value;
      }
    });
    selectedOptions = selectedOptions.slice(1);
    return returnObjectOrNull(
      colorData[selectedOptions]
    );
  }
  return null;
};
var getAllPartiallyCorrectVariantsFromOptions = (variantOptions) => {
  const allVariants = getAllVariants();
  if (allVariants != null) {
    let selectedOptions = "";
    variantOptions.forEach((variantElement) => {
      const optionName = variantElement.dataset.optionName;
      let value = getValueFromVariantSelector(variantElement, optionName) || null;
      if (optionName === "ladderTaping") {
        value = ladderTapingTokenFromSelector(variantElement, value);
      } else if (optionName === "slatWidth") {
        if (value === "25 mm" || value === "25mm") {
          value = "25mm";
        }
        if (value === "50 mm") {
          value = "50mm";
        }
      }
      if (value !== null) {
        selectedOptions = selectedOptions + " - " + value.toLowerCase();
      }
    });
    selectedOptions = selectedOptions.slice(3);
    return returnArrayOrNull(
      allVariants.filter((element) => element.options.toLowerCase().includes(selectedOptions))
    );
  }
  return null;
};
var getCorrectSwatchVariantFromOptions = (variantOptions, material) => {
  const allVariants = getAllSwatchVariants(material);
  if (allVariants != null) {
    let selectedOptions = "";
    variantOptions.forEach((variantValue) => {
      selectedOptions = selectedOptions + " - " + variantValue;
    });
    selectedOptions = selectedOptions.slice(3);
    return returnObjectOrNull(
      allVariants.find((element) => element.options === selectedOptions)
    );
  }
  return null;
};
var setVariantId = (variantId) => {
  const variantIdElement = document.querySelector("#variantId");
  variantIdElement.value = variantId;
};
var setVariantTitle = (variantTitle) => {
  const variantTitleElement = document.querySelector('input[name="_product_title"]');
  variantTitleElement.value = variantTitle;
};
var getValueFromSearchInUrl = (parameter) => {
  const allSearchParameters = new Proxy(
    new URLSearchParams(window.location.search),
    {
      get: (searchParams, prop) => searchParams.get(prop)
    }
  );
  return returnStringOrNull(decodeURI(allSearchParameters[parameter]));
};
var createProductUrlFromLineItem = (lineItemProduct, productUrl) => {
  var _a, _b;
  const urlBase = `${window.location.origin}`;
  const splitUrlOnMaterialAndSize = productUrl.split("-");
  const materialUrl = splitUrlOnMaterialAndSize[0];
  const color = (_a = returnStringOrNull(lineItemProduct["Kleur"])) == null ? void 0 : _a.toLowerCase().replaceAll(" ", "-");
  const finish = (_b = returnStringOrNull(lineItemProduct["Afwerking"])) == null ? void 0 : _b.toLowerCase().replaceAll(" ", "-");
  return new URL(
    new URL(
      `${materialUrl}?col=${color}-${finish}`,
      urlBase
    ),
    urlBase
  );
};
var getProductIdFromUrl = () => {
  const params = new URLSearchParams(window.location.search);
  return returnStringOrNull(params.get("replace"));
};
var selectFirstOption = (fieldsetElement) => {
  const allOptionElementsOfFieldset = fieldsetElement.querySelectorAll("label");
  if (allOptionElementsOfFieldset) {
    allOptionElementsOfFieldset.forEach((optionElement, index) => {
      const inputElement = optionElement.querySelector("input");
      if (index === 0) {
        inputElement.checked = true;
      }
    });
  }
};
var getSelectedColorData = () => {
  const allColorFieldsetElement = document.querySelector(
    'fieldset[name="color"]'
  );
  const selectedColorInputElement = allColorFieldsetElement.querySelector(
    "input:checked"
  );
  const selectedColorParentElement = selectedColorInputElement ? selectedColorInputElement.closest("label") : null;
  const selectedColorJson = selectedColorParentElement ? selectedColorParentElement.querySelector(".color-object") : null;
  const selectedColorObject = selectedColorJson ? JSON.parse(selectedColorJson.innerHTML) : null;
  return returnObjectOrNull(selectedColorObject);
};
var setNewColorAsSelected = (newColorElement) => {
  const colorFieldsetElement = document.querySelector('fieldset[name="color"]');
  const allColorSwatchElements = colorFieldsetElement.querySelectorAll(".slide");
  const selectedItemElement = newColorElement.closest(".slide");
  allColorSwatchElements.forEach((element) => {
    element.classList.remove("js-selected");
  });
  selectedItemElement.classList.add("js-selected");
};
var setValueInputMax = (value, targetElement) => {
  const placeholder = targetElement.dataset.placeholderText;
  const newPlaceholderText = placeholder.replace("%maxs", value).replace("%mins", targetElement.min);
  targetElement.placeholder = newPlaceholderText;
  targetElement.max = value;
};
var setValueInputMin = (value, targetElement) => {
  const placeholder = targetElement.dataset.placeholderText;
  const newPlaceholderText = placeholder.replace("%maxs", targetElement.max).replace("%mins", value);
  targetElement.placeholder = newPlaceholderText;
  targetElement.min = value;
};
var capatalizeString = (string) => string.toLowerCase().split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
var handleLadderTapingColorChange = (selectedColorData) => {
  if (selectedColorData) {
    const fieldsetElement = document.querySelector(".variant--ladder-taping");
    if (!fieldsetElement)
      return;
    const laderTapingColorElement = document.querySelector(".ladder-taping-color");
    const valueOfLadderTaping = getValueFromFieldset(fieldsetElement) || "ladderCord";
    const translationLadderband = "ladderStrap";
    const translationLadderkoord = "ladderCord";
    const valueOfLadderTapingColor = getValueFromFieldset(
      laderTapingColorElement
    ) || "matchend";
    const ladderkoordImageHolderElement = fieldsetElement.querySelector(
      'label[for="ProductSelect-option-LadderCord"] .image-holder'
    );
    const ladderbandImageHolderElement = fieldsetElement.querySelector(
      'label[for="ProductSelect-option-LadderStrap"] .image-holder'
    );
    const ladderkoordImageElement = fieldsetElement.querySelector(
      'label[for="ProductSelect-option-LadderCord"] img'
    );
    const ladderbandImageElement = fieldsetElement.querySelector(
      'label[for="ProductSelect-option-LadderStrap"] img'
    );
    if (valueOfLadderTaping) {
      ladderkoordImageHolderElement == null ? void 0 : ladderkoordImageHolderElement.classList.add("js-loading");
      ladderbandImageHolderElement == null ? void 0 : ladderbandImageHolderElement.classList.add("js-loading");
      const colorName = valueOfLadderTapingColor.toLocaleLowerCase();
      let finalColorName = null;
      switch (colorName) {
        case "matchend":
          finalColorName = "matchend";
          break;
        case "black":
          finalColorName = "black";
          break;
        case "white":
          finalColorName = "white";
          break;
      }
      const correctLadderkoordImage = selectedColorData.images.ladderTaping[translationLadderkoord][finalColorName];
      const correctLadderbandImage = selectedColorData.images.ladderTaping[translationLadderband][finalColorName];
      if (correctLadderkoordImage) {
        const newLadderkoordImage = new Image();
        newLadderkoordImage.src = correctLadderkoordImage;
        newLadderkoordImage.alt = `Ladder cord ${selectedColorData.title}`;
        newLadderkoordImage.onload = () => {
          ladderkoordImageHolderElement.classList.remove("js-loading");
          ladderkoordImageElement.replaceWith(newLadderkoordImage);
        };
      }
      if (correctLadderbandImage) {
        const newLadderbandImage = new Image();
        newLadderbandImage.src = correctLadderbandImage;
        newLadderbandImage.alt = `Ladder strap ${selectedColorData.title}`;
        newLadderbandImage.onload = () => {
          ladderbandImageHolderElement.classList.remove("js-loading");
          ladderbandImageElement.replaceWith(newLadderbandImage);
        };
      }
    }
  }
};

// src/templates/color-swatch.js
var createColorSwatchElement = (swatchUrlTop, swatchUrlBottom, colorTitle2) => returnStringOrNull(`
    <div class="color-swatch open">
      <img class="swatch-material js-loading" src="${swatchUrlTop}" loading="lazy" width="380px" height="380px" alt="${colorTitle2} swatch"/>
      <img class="swatch-material js-loading" src="${swatchUrlBottom ? swatchUrlBottom : swatchUrlTop}" loading="lazy" width="380px" height="380px" alt="${colorTitle2} swatch"/>
    </div>
  `);
var createColorSwatchImage = (imageUrl, colorTitle2) => returnStringOrNull(`
  <div class="image-holder">
    <img
        src="${insertImageFormat(imageUrl, "_540x540")}"
        srcset="
          ${insertImageFormat(imageUrl, "_550x550")} 550w,
          ${insertImageFormat(imageUrl, "_1100x1100")} 1100w,
          ${insertImageFormat(imageUrl, "_1445x1445")} 1445w,
          ${insertImageFormat(imageUrl, "_1680x1680")} 1680w,
          ${insertImageFormat(imageUrl, "_2048x2048")} 2048w,
          ${insertImageFormat(imageUrl, "_540x540")} 540w
        "
        sizes="(min-width: 750px) calc(100vw - 22rem), 1100px"
        loading="lazy"
        height="540"
        width="540"
        alt="${colorTitle2}"
    >
  </div>
`);
var createColorSwatchVideo = (videoUrl) => returnStringOrNull(`
    <video class="color-swatch-video" autoplay loop muted playsinline>
      <source src="${videoUrl}" type="video/mp4">
    </video>
  `);

// src/utils/constants.js
var PUB_SUB_EVENTS = {
  colorChange: "color-change",
  sizeChange: "size-change",
  variantChange: "variant-change",
  blindsChange: "blinds-change",
  initialize: "initialize",
  onlyUpdateUrl: "only-update-url",
  blindsUpdatePrice: "blinds-update-price",
  updateControls: "update-controls",
  upsellChange: "upsell-change"
};

// src/services/shopify-services.js
var axios = require_axios2();
var { handleChangeCart: handleChangeCart2 } = (init_cart_state(), __toCommonJS(cart_state_exports));
var ShopifyServices = class {
  /**
   * Update cart with a axios call.
   *
   * @param method {string}
   * @param url {string}
   * @param selectedElement {HTMLElement}
   * @param body {string}
   */
  async updateCart(method, url, selectedElement, body) {
    try {
      if (selectedElement) {
        selectedElement.classList.add("js-is-loading");
      }
      await axios({
        method,
        url,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        },
        data: body
      }).then((response) => {
        const responseData = response.data;
        handleChangeCart2(responseData);
      });
    } catch (error) {
      if (error.response ? error.response.status === 422 : false) {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading");
          selectedElement.classList.add("js-all-in-cart");
        }
      } else {
        if (selectedElement) {
          selectedElement.classList.remove("js-is-loading");
          selectedElement.classList.add("js-change-failed");
        }
      }
    }
  }
  /**
   * Get product.
   *
   * @param {string} productHandle
   *
   * @returns {object}
   */
  async getProduct(productHandle) {
    try {
      const productFetchUrl = `${window.location.origin}/products/${productHandle}.js`;
      return await axios({
        method: "get",
        url: productFetchUrl,
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "X-Requested-With": "xmlhttprequest"
        }
      }).then((response) => {
        const responseData = response.data;
        return responseData;
      });
    } catch (error) {
    }
  }
};
var shopify_services_default = ShopifyServices;

// src/utils/blinds-config.js
var CONFIG_VERSION = 1;
var ROLE_COLOR = "color";
var ROLE_SIZE = "size";
var ROLE_RAIL = "rail";
var ROLE_ADDON = "addon";
var text = (formData, key) => {
  const value = formData.get(key);
  if (value == null)
    return null;
  const trimmed = String(value).trim();
  return trimmed.length > 0 && trimmed !== "undefined" && trimmed !== "null" ? trimmed : null;
};
var number = (formData, key) => {
  const value = text(formData, key);
  if (value == null)
    return null;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};
var compact = (object) => {
  const result = {};
  Object.entries(object).forEach(([key, value]) => {
    if (value !== null && value !== void 0 && value !== "")
      result[key] = value;
  });
  return result;
};
var resolveMaterial = (formData) => {
  const explicit = text(formData, "_material");
  if (explicit === "wood" || explicit === "aluminium")
    return explicit;
  const url = `${text(formData, "_color_handle") || ""} ${text(formData, "_reconfigure_url") || ""}`.toLowerCase();
  if (url.includes("wood") || url.includes("hout"))
    return "wood";
  return explicit || null;
};
var selectedAddons = (formData) => {
  const raw = text(formData, "_upSellIds");
  if (!raw)
    return [];
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (error) {
    console.error("blinds-config: could not parse _upSellIds", error);
    return [];
  }
  if (!Array.isArray(parsed))
    return [];
  const baseboardVariantId = text(formData, "_baseboard_variant_id");
  return parsed.filter((addon) => addon && addon.id).map((addon) => {
    const entry = compact({
      variantId: String(addon.id),
      title: addon.title ? String(addon.title) : null
    });
    if (baseboardVariantId && String(addon.id) === baseboardVariantId) {
      const baseboard = compact({
        leftHeight: number(formData, "baseboard_left_height"),
        leftDepth: number(formData, "baseboard_left_depth"),
        rightHeight: number(formData, "baseboard_right_height"),
        rightDepth: number(formData, "baseboard_right_depth")
      });
      if (Object.keys(baseboard).length > 0)
        entry.baseboard = baseboard;
    }
    return entry;
  });
};
var buildBlindsConfig = (formData, { parentId } = {}) => {
  const railColor = normalizeColorKeyword(text(formData, "topBottomRailColor"));
  const config3 = {
    v: CONFIG_VERSION,
    type: "blinds",
    parentId: parentId || null,
    material: resolveMaterial(formData),
    color: compact({ productId: text(formData, "_color_product_id") }),
    size: compact({
      width: number(formData, "width"),
      height: number(formData, "height")
    }),
    slatWidth: normalizeSlatWidth(text(formData, "slatWidth")),
    ladderTaping: normalizeLadderTaping(text(formData, "ladderTaping")),
    ladderTapingColor: normalizeColorKeyword(text(formData, "ladderTapingColor")),
    controls: normalizeControls(text(formData, "controls")),
    frameSpacing: normalizeFrameSpacing(text(formData, "frameSpacing")),
    note: text(formData, "note")
  };
  if (railColor)
    config3.topBottomRail = { color: railColor };
  const addons = selectedAddons(formData).filter((addon) => addon.baseboard).map((addon) => ({ variantId: addon.variantId, baseboard: addon.baseboard }));
  if (addons.length > 0)
    config3.addons = addons;
  return compact(config3);
};

// src/utils/cart-labels.js
var ENGLISH_KEYS = {
  material: "Material",
  color: "Color",
  width: "Width",
  height: "Height",
  slatWidth: "Slat width",
  ladder: "Ladder type",
  ladderTapingColor: "Ladder color",
  controls: "Controls",
  frameSpacing: "Placement",
  topBottomRail: "Top and bottom rail",
  note: "Room or note",
  baseboardLeftHeight: "Baseboard left height",
  baseboardLeftDepth: "Baseboard left depth",
  baseboardRightHeight: "Baseboard right height",
  baseboardRightDepth: "Baseboard right depth"
};
var ENGLISH_VALUES = {
  material: { aluminium: "Aluminium", wood: "Wood" },
  ladderTaping: { ladderkoord: "Ladder cord", ladderband: "Ladder strap" },
  colorKeyword: { matchend: "Matching", black: "Black", white: "White" },
  controls: { shared: "Shared", left: "Left", right: "Right" },
  frameSpacing: { betweenFrame: "Between frame", onFrame: "On frame" }
};
var globalCart = () => (typeof window !== "undefined" ? window.cart : null) || {};
var capitalize = (value) => {
  if (value == null)
    return null;
  const text2 = String(value).trim();
  if (text2.length === 0)
    return null;
  return text2.charAt(0).toUpperCase() + text2.slice(1);
};
var propertyKey = (key) => {
  const translated = capitalize(globalCart()[key]);
  return translated || capitalize(ENGLISH_KEYS[key]) || key;
};
var propertyValue = (group, value) => {
  var _a, _b, _c;
  if (value == null || value === "")
    return null;
  const translated = capitalize((_b = (_a = globalCart().labels) == null ? void 0 : _a[group]) == null ? void 0 : _b[value]);
  if (translated)
    return translated;
  return capitalize((_c = ENGLISH_VALUES[group]) == null ? void 0 : _c[value]) || capitalize(value);
};
var selectedLabels = (root = typeof document !== "undefined" ? document : null) => {
  const labels = {};
  if (!(root == null ? void 0 : root.querySelectorAll))
    return labels;
  root.querySelectorAll("fieldset input:checked, fieldset select option[selected]").forEach((element) => {
    var _a;
    const name = (_a = element.getAttribute) == null ? void 0 : _a.call(element, "name");
    if (!name)
      return;
    const label = element.getAttribute("data-translated-value") || element.getAttribute("data-product-title") || element.value;
    if (label)
      labels[name] = String(label);
  });
  return labels;
};
var optionLabel = (labels, inputName, group, canonicalValue) => {
  const fromDom = capitalize(labels == null ? void 0 : labels[inputName]);
  if (fromDom)
    return fromDom;
  return group ? propertyValue(group, canonicalValue) : capitalize(canonicalValue);
};
var millimetres = (value) => {
  if (value == null || value === "")
    return null;
  const number2 = Number(value);
  return Number.isFinite(number2) ? `${number2} mm` : String(value);
};

// src/utils/dissect-form.js
var generateParentId = () => Date.now().toString(36) + Math.random().toString(36).substring(2);
var withColorLine = () => {
  var _a;
  return Boolean(typeof window !== "undefined" && ((_a = window.cart) == null ? void 0 : _a.bundleParent));
};
var withValue = (properties, key, value) => {
  if (value == null || value === "")
    return properties;
  properties[key] = value;
  return properties;
};
var translatedProperties = (config3, labels, colorTitle2) => {
  var _a, _b, _c;
  const properties = {};
  withValue(properties, propertyKey("material"), propertyValue("material", config3.material));
  withValue(properties, propertyKey("color"), capitalize(labels.color || colorTitle2));
  withValue(properties, propertyKey("width"), millimetres((_a = config3.size) == null ? void 0 : _a.width));
  withValue(properties, propertyKey("height"), millimetres((_b = config3.size) == null ? void 0 : _b.height));
  withValue(properties, propertyKey("slatWidth"), optionLabel(labels, "slatWidth", null, config3.slatWidth));
  withValue(properties, propertyKey("ladder"), optionLabel(labels, "ladderTaping", "ladderTaping", config3.ladderTaping));
  withValue(
    properties,
    propertyKey("ladderTapingColor"),
    optionLabel(labels, "ladderTapingColor", "colorKeyword", config3.ladderTapingColor)
  );
  withValue(properties, propertyKey("controls"), optionLabel(labels, "controls", "controls", config3.controls));
  withValue(
    properties,
    propertyKey("frameSpacing"),
    optionLabel(labels, "frameSpacing", "frameSpacing", config3.frameSpacing)
  );
  withValue(
    properties,
    propertyKey("topBottomRail"),
    optionLabel(labels, "topBottomRailColor", "colorKeyword", (_c = config3.topBottomRail) == null ? void 0 : _c.color)
  );
  withValue(properties, propertyKey("note"), capitalize(config3.note));
  return properties;
};
var sizeProperties = (config3, { width = true } = {}) => {
  var _a, _b;
  const properties = {};
  if (width)
    withValue(properties, propertyKey("width"), millimetres((_a = config3.size) == null ? void 0 : _a.width));
  withValue(properties, propertyKey("height"), millimetres((_b = config3.size) == null ? void 0 : _b.height));
  return properties;
};
var baseboardProperties = (baseboard) => {
  const properties = {};
  if (!baseboard)
    return properties;
  withValue(properties, propertyKey("baseboardLeftHeight"), millimetres(baseboard.leftHeight));
  withValue(properties, propertyKey("baseboardLeftDepth"), millimetres(baseboard.leftDepth));
  withValue(properties, propertyKey("baseboardRightHeight"), millimetres(baseboard.rightHeight));
  withValue(properties, propertyKey("baseboardRightDepth"), millimetres(baseboard.rightDepth));
  return properties;
};
var dissectForm = (formData) => {
  var _a, _b, _c;
  const defaultQuantity = 1;
  const parentId = generateParentId();
  const labels = selectedLabels();
  const value = (key) => formData.get(key) ? formData.get(key) : null;
  const quantity = value("quantity") || defaultQuantity;
  const colorVariantId = value("id");
  const sizeVariantId = value("size-variant-id");
  const railVariantId = value("_topBottomRailId");
  const colorTitle2 = value("color");
  const colorHandle = value("_color_handle");
  const reconfigureUrl = typeof window !== "undefined" ? String(new URL(window.location)) : null;
  const config3 = buildBlindsConfig(formData, { parentId });
  const cart = typeof document !== "undefined" ? document.querySelector("cart-notification") || document.querySelector("cart-drawer") : null;
  const visibleProperties = translatedProperties(config3, labels, colorTitle2);
  const items = [];
  const colorItem = colorVariantId ? {
    id: colorVariantId,
    quantity,
    "product-id": ((_a = config3.color) == null ? void 0 : _a.productId) || null,
    properties: { _parentId: parentId, _role: ROLE_COLOR }
  } : null;
  const sizeItem = sizeVariantId ? {
    id: sizeVariantId,
    quantity,
    "product-id": value("size-product-id"),
    properties: { _parentId: parentId, _role: ROLE_SIZE, ...sizeProperties(config3) }
  } : null;
  if (withColorLine() && colorItem) {
    items.push(colorItem);
    if (sizeItem)
      items.push(sizeItem);
  } else if (sizeItem) {
    items.push(sizeItem);
  } else if (colorItem) {
    items.push(colorItem);
  }
  const parentProperties = (_b = items[0]) == null ? void 0 : _b.properties;
  if (parentProperties) {
    parentProperties._type = "blinds";
    parentProperties._config = JSON.stringify(config3);
    parentProperties._display = JSON.stringify(Object.entries(visibleProperties));
    withValue(parentProperties, "_slatWidth", config3.slatWidth);
    withValue(parentProperties, "_reconfigureUrl", reconfigureUrl);
    withValue(parentProperties, "_colorTitle", colorTitle2);
    withValue(parentProperties, "_colorHandle", colorHandle);
    Object.assign(parentProperties, visibleProperties);
  }
  if (railVariantId) {
    items.push({
      id: railVariantId,
      quantity: defaultQuantity,
      properties: {
        _parentId: parentId,
        _role: ROLE_RAIL,
        // Kept so carts and orders created before the bundle rollout keep rendering.
        _isTopBottomRail: true,
        ...withValue(
          sizeProperties(config3, { width: false }),
          propertyKey("color"),
          optionLabel(labels, "topBottomRailColor", "colorKeyword", (_c = config3.topBottomRail) == null ? void 0 : _c.color)
        )
      }
    });
  }
  selectedAddons(formData).forEach((addon) => {
    items.push({
      id: addon.variantId,
      quantity: defaultQuantity,
      properties: {
        _parentId: parentId,
        _role: ROLE_ADDON,
        _isUpSell: true,
        ...sizeProperties(config3, { width: false }),
        ...baseboardProperties(addon.baseboard)
      }
    });
  });
  return JSON.stringify({
    items,
    sections: cart ? cart.getSectionsToRender().map((section) => section.id) : []
  });
};

// src/services/shopify-cart.js
init_get_sections();
var ShopifyCart = class extends shopify_services_default {
  /**
   * Add array of objects to the cart
   * https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   *
   * @param formData {object}
   * @param selectedElement {HTMLElement}
   *
   * @returns cart object
   */
  async add(formData, selectedElement) {
    const method = "POST";
    const url = "/cart/add.js";
    const body = JSON.stringify({
      ...JSON.parse(dissectForm(formData))
    });
  }
  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async remove(line, selectedElement) {
    const method = "POST";
    const url = "/cart/change.js";
    const body = JSON.stringify({
      line,
      quantity: 0,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Remove item from the cart.
   *
   * @param id {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async removeById(id, selectedElement) {
    const method = "POST";
    const url = "/cart/change.js";
    const body = JSON.stringify({
      id,
      quantity: 0,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async updateQuantity(line, quantity, selectedElement) {
    const method = "POST";
    const url = "/cart/change.js";
    const body = JSON.stringify({
      id: line,
      quantity,
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Quick buy option.
   *
   * @param variantId {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async quickBuy(variantId, quantity, selectedElement) {
    const method = "POST";
    const url = "/cart/add.js";
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: getCartSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Add Swatch or multiple swatches to the cart.
   *
   * @param allVariantIds {array<Number>}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async addSwatchGroup(allVariants, selectedElement) {
    const method = "POST";
    const url = "/cart/add.js";
    const items = [];
    allVariants.forEach((variant) => {
      items.push({
        id: variant.id,
        quantity: 1,
        properties: {
          color: variant.color,
          Lamelbreedte: variant.slatWidth,
          "_color-code": variant["_color-code"]
        }
      });
    });
    const body = JSON.stringify({
      items,
      sections: getCartSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });
    await this.updateCart(method, url, selectedElement, body);
  }
  /**
   * Remove item from the cart.
   *
   * @param line {number}
   * @param quantity {number}
   * @param selectedElement {HTMLElement}
   *
   * @returns {Promise<unknown>}
   */
  async removeInBulk(selectedElement, updateObject) {
    const method = "POST";
    const url = "/cart/update.js";
    const body = {
      sections: getCartSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    };
    if (updateObject) {
      body.updates = updateObject;
    }
    await this.updateCart(method, url, selectedElement, JSON.stringify(body));
  }
};
var shopify_cart_default = new ShopifyCart();

// src/extenders/zoom-lightbox.js
var import_pubsub_js = __toESM(require_pubsub(), 1);
init_surf_modal();
var ZoomLightbox = class extends HTMLElement {
  constructor() {
    super();
    const targetId = "zoomLightbox";
    const conformElement = this.querySelector(".js-select-color");
    const orderSwatchElement = this.querySelector(".js-order-swatch");
    const baseModal = new surf_modal_default();
    const setColorSwatchInLightbox = (colorSwatchUrlTop, colorSwatchUrlBottom, colorTitle2) => {
      const imageParentElement = this.querySelector(".color-swatch-holder");
      imageParentElement.innerHTML = createColorSwatchElement(
        colorSwatchUrlTop,
        colorSwatchUrlBottom,
        colorTitle2
      );
      const allSwatchImages = [...imageParentElement.querySelectorAll("img")];
      allSwatchImages.map((swatchElement) => {
        const variantImageElementUrl = swatchElement ? swatchElement.getAttribute("src") : null;
        const finalImageUrl = variantImageElementUrl ? variantImageElementUrl.replace("height=118", "height=1500").replace("width=118", "width=1500") : null;
        const targetImage = new Image();
        targetImage.width = 1500;
        targetImage.height = 1500;
        targetImage.alt = "color swatch";
        targetImage.src = finalImageUrl;
        targetImage.onload = () => {
          swatchElement.replaceWith(targetImage);
        };
      });
    };
    const setColorImageInLightbox = (imageUrl, colorTitle2) => {
      const imageParentElement = this.querySelector(".color-swatch-holder");
      imageParentElement.innerHTML = createColorSwatchImage(
        imageUrl,
        colorTitle2
      );
    };
    const setColorVideoInLightbox = (colorVideoUrl) => {
      const imageParentElement = this.querySelector(".color-swatch-holder");
      imageParentElement.innerHTML = createColorSwatchVideo(colorVideoUrl);
    };
    const setTextHolderInHtml = (selectedColorObject) => {
      const selectColorElement = this.querySelector(".button-color-title");
      const titleElement = this.querySelector(".color-title");
      const colorFinishElement = this.querySelector(".color-finish");
      const colorDescriptionElement = this.querySelector(".color-description");
      const correctlyEncodedDescription = selectedColorObject.description.replaceAll(
        "+",
        "%20"
      );
      const translation = titleElement ? titleElement.dataset.translation : null;
      conformElement.dataset.handle = selectedColorObject.handle;
      conformElement.dataset.colorFinish = selectedColorObject.finish;
      titleElement.innerHTML = selectedColorObject.title;
      colorFinishElement.innerHTML = selectedColorObject.finish;
      colorDescriptionElement.innerHTML = decodeURIComponent(
        correctlyEncodedDescription
      );
      if (translation) {
        selectColorElement.innerHTML = `${translation} <span>${selectedColorObject.title}</span>`;
      }
    };
    const setColorContent = (selectedColorObject) => {
      if (selectedColorObject) {
        if (selectedColorObject["color-swatch-video"]) {
          setColorVideoInLightbox(selectedColorObject["color-swatch-video"]);
        } else if (selectedColorObject["color-swatch-zoom"]) {
          setColorImageInLightbox(selectedColorObject["color-swatch-zoom"], colorTitle);
        } else {
          setColorSwatchInLightbox(
            selectedColorObject.images.swatchTop,
            selectedColorObject.images.swatchBottom,
            selectedColorObject.title
          );
        }
        setTextHolderInHtml(selectedColorObject);
      }
    };
    const hideOnClick = () => {
      const outsideClickListener = (event2) => {
        const target = event2.target;
        const allModalOpeners = document.querySelectorAll(".js-open-modal");
        const arrayAllModalOpeners = [...allModalOpeners];
        if (arrayAllModalOpeners.filter(
          (modalOpener) => modalOpener === target.closest(".js-open-modal")
        ).length !== 0) {
        } else {
          baseModal.closeModal(targetId);
          removeClickListener();
        }
      };
      const removeClickListener = () => {
        document.removeEventListener("click", outsideClickListener);
      };
      document.addEventListener("click", outsideClickListener);
    };
    const setInputWithColorTitleAndFinish = (colorHandle) => {
      const colorFieldsetElement = document.querySelector('fieldset[name="color"]');
      const newSelectedColorInputElement = colorFieldsetElement.querySelector(`input[name="color"][data-handle="${colorHandle}"]`);
      const swiperElement = colorFieldsetElement.querySelector(".swiper");
      const indexNewSelectedColorInputElement = [...swiperElement.querySelectorAll('input[name="color"]')].indexOf(newSelectedColorInputElement);
      newSelectedColorInputElement.checked = true;
      const swiperInstance = swiperElement.swiper;
      swiperInstance.slideTo(Number(indexNewSelectedColorInputElement / 2), 0);
      const target = newSelectedColorInputElement;
      const closestFieldsetElement = colorFieldsetElement;
      import_pubsub_js.PubSub.publish(PUB_SUB_EVENTS.blindsChange, {
        data: {
          event,
          target,
          closestFieldsetElement,
          selectedOptionValues: this.selectedOptionValues
        }
      });
      baseModal.closeModal(targetId);
    };
    document.addEventListener("modal-state", (event2) => {
      if (event2.detail) {
        const eventDetails = event2.detail;
        if (eventDetails.targetId === targetId && eventDetails.state === "open") {
          const colorFieldsetElement = document.querySelector('fieldset[name="color"]');
          const selectedColorElement = colorFieldsetElement.querySelector('input[name="color"]:checked');
          let colorId = selectedColorElement.getAttribute("data-product-id");
          if (eventDetails.element.classList.contains("zoom-color-swatch")) {
            colorId = eventDetails.element.dataset.colorId;
          }
          if (colorId) {
            const zoomLightboxElement = document.querySelector(".zoom-lightbox");
            const zoomLightboxSlider = zoomLightboxElement.querySelector("swiper-slider");
            const swiperElement = zoomLightboxElement.querySelector(".swiper");
            const slideElementById = zoomLightboxSlider.querySelector(`[data-slide-id="${colorId}"]`);
            const indexNewSelectedColorInputElement = [...swiperElement.querySelectorAll(".swiper-slide")].indexOf(slideElementById);
            const swiperInstance = swiperElement.swiper;
            swiperInstance.slideTo(Number(indexNewSelectedColorInputElement), 0);
          }
        }
      }
    });
    conformElement.addEventListener("click", () => {
      var _a;
      const sliderElement = document.querySelector('.zoom-lightbox swiper-slider[data-role="zoom-media"]');
      const activeSlideElement = sliderElement.querySelector(".swiper-slide.swiper-slide-active");
      const colorHandle = (_a = activeSlideElement == null ? void 0 : activeSlideElement.dataset) == null ? void 0 : _a.handle;
      if (colorHandle) {
        setInputWithColorTitleAndFinish(colorHandle);
      }
    });
    orderSwatchElement.addEventListener("click", () => {
      var _a;
      const sliderElement = document.querySelector('.zoom-lightbox swiper-slider[data-role="zoom-media"]');
      const activeSlideElement = sliderElement.querySelector(".swiper-slide.swiper-slide-active");
      const colorHandle = (_a = activeSlideElement == null ? void 0 : activeSlideElement.dataset) == null ? void 0 : _a.handle;
      let productMaterial = getProductMaterial();
      if (productMaterial === "houten") {
        productMaterial = "wood";
      }
      const swatchFormElement = document.querySelector("product-form-swatch");
      const swatchVariantDataElement = swatchFormElement.querySelector(`input[data-handle="${colorHandle}"]`);
      if (swatchVariantDataElement && swatchVariantDataElement.getAttribute("data-variant-id")) {
        shopify_cart_default.quickBuy(swatchVariantDataElement.getAttribute("data-variant-id"), 1, orderSwatchElement);
        baseModal.closeModal(targetId);
      }
    });
  }
  get selectedOptionValues() {
    const productInfoElement = document.querySelector("product-info");
    const selectedValues = Array.from(productInfoElement.querySelectorAll("select option[selected], fieldset input:checked")).map(
      (input) => ({
        name: input.name,
        value: input.value,
        productUrl: input.getAttribute("data-product-url"),
        searchName: input.getAttribute("data-search-name"),
        optionValueId: input.getAttribute("data-option-value-id"),
        translatedValue: input.getAttribute("data-translated-value")
      })
    );
    const sizingValue = {
      name: "size",
      value: {
        width: productInfoElement.querySelector("product-size").querySelector('input[name="width"]').value,
        height: productInfoElement.querySelector("product-size").querySelector('input[name="height"]').value
      }
    };
    return [...selectedValues, sizingValue];
  }
};
if (customElements.get("zoom-lightbox") === void 0) {
  customElements.define("zoom-lightbox", ZoomLightbox);
}

// src/components/meta-theme-color-state.js
var metaThemeColorElement = document.querySelector("meta[name=theme-color]");
var MetaThemeColor = class {
  /**
   * Set modal color as the theme color.
   */
  setModalColor() {
    const color = "#FBE9E8";
    metaThemeColorElement.setAttribute("content", color);
  }
  /**
   * Set default color as the theme color.
   */
  setDefaultColor() {
    const color = "#F1D4D0";
    metaThemeColorElement.setAttribute("content", color);
  }
};
var meta_theme_color_state_default = new MetaThemeColor();

// src/utils/debounce.js
var debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      timeout = null;
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// src/utils/bfcache.js
var import_axios = __toESM(require_axios2(), 1);
init_get_sections();
var enableBFCacheSupport = () => {
  window.addEventListener("pageshow", (event2) => {
    if (event2.persisted) {
      const url = new URL(window.location.href);
      url.searchParams.append("sections", getCartSectionsToRender().map((section) => section.section).join(","));
      import_axios.default.get(url.href).then((response) => {
        const newRenderedSectionsObject = response.data;
        const sectionObjects = Object.keys(newRenderedSectionsObject).map((key) => ({
          name: key,
          html: newRenderedSectionsObject[key]
        }));
        sectionObjects.forEach((renderedSection) => {
          var _a;
          const parser = new DOMParser();
          const destinationSelector = (_a = getCartSectionsToRender().find((sectionInfo) => sectionInfo.section == renderedSection.name)) == null ? void 0 : _a.selector;
          const destinationElement = document.querySelector(destinationSelector);
          const rawSectionData = parser.parseFromString(renderedSection.html, "text/html");
          const newSectionElement = rawSectionData.querySelector(destinationSelector);
          if (destinationElement) {
            destinationElement.innerHTML = newSectionElement.innerHTML;
          }
        });
      });
    }
  }, false, { passive: true });
};

// node_modules/quicklink/dist/quicklink.mjs
function e(e2) {
  return new Promise(function(n2, r2, t2) {
    (t2 = new XMLHttpRequest()).open("GET", e2, t2.withCredentials = true), t2.onload = function() {
      200 === t2.status ? n2() : r2();
    }, t2.send();
  });
}
var n, r = (n = document.createElement("link")).relList && n.relList.supports && n.relList.supports("prefetch") ? function(e2) {
  return new Promise(function(n2, r2, t2) {
    (t2 = document.createElement("link")).rel = "prefetch", t2.href = e2, t2.onload = n2, t2.onerror = r2, document.head.appendChild(t2);
  });
} : e, t = window.requestIdleCallback || function(e2) {
  var n2 = Date.now();
  return setTimeout(function() {
    e2({ didTimeout: false, timeRemaining: function() {
      return Math.max(0, 50 - (Date.now() - n2));
    } });
  }, 1);
}, o = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set(), c = false;
function a(e2) {
  if (e2) {
    if (e2.saveData)
      return new Error("Save-Data is enabled");
    if (/2g/.test(e2.effectiveType))
      return new Error("network conditions are poor");
  }
  return true;
}
function u(e2) {
  if (e2 || (e2 = {}), window.IntersectionObserver) {
    var n2 = function(e3) {
      e3 = e3 || 1;
      var n3 = [], r3 = 0;
      function t2() {
        r3 < e3 && n3.length > 0 && (n3.shift()(), r3++);
      }
      return [function(e4) {
        n3.push(e4) > 1 || t2();
      }, function() {
        r3--, t2();
      }];
    }(e2.throttle || 1 / 0), r2 = n2[0], a2 = n2[1], u2 = e2.limit || 1 / 0, l = e2.origins || [location.hostname], d = e2.ignores || [], h = e2.delay || 0, p = [], m = e2.timeoutFn || t, w = "function" == typeof e2.hrefFn && e2.hrefFn, g = e2.prerender || false;
    c = e2.prerenderAndPrefetch || false;
    var v = new IntersectionObserver(function(n3) {
      n3.forEach(function(n4) {
        if (n4.isIntersecting)
          p.push((n4 = n4.target).href), function(e3, n5) {
            n5 ? setTimeout(e3, n5) : e3();
          }(function() {
            -1 !== p.indexOf(n4.href) && (v.unobserve(n4), (c || g) && i.size < 1 ? f(w ? w(n4) : n4.href).catch(function(n5) {
              if (!e2.onError)
                throw n5;
              e2.onError(n5);
            }) : o.size < u2 && !g && r2(function() {
              s(w ? w(n4) : n4.href, e2.priority).then(a2).catch(function(n5) {
                a2(), e2.onError && e2.onError(n5);
              });
            }));
          }, h);
        else {
          var t2 = p.indexOf((n4 = n4.target).href);
          t2 > -1 && p.splice(t2);
        }
      });
    }, { threshold: e2.threshold || 0 });
    return m(function() {
      (e2.el || document).querySelectorAll("a").forEach(function(e3) {
        l.length && !l.includes(e3.hostname) || function e4(n3, r3) {
          return Array.isArray(r3) ? r3.some(function(r4) {
            return e4(n3, r4);
          }) : (r3.test || r3).call(r3, n3.href, n3);
        }(e3, d) || v.observe(e3);
      });
    }, { timeout: e2.timeout || 2e3 }), function() {
      o.clear(), v.disconnect();
    };
  }
}
function s(n2, t2, u2) {
  var s2 = a(navigator.connection);
  return s2 instanceof Error ? Promise.reject(new Error("Cannot prefetch, " + s2.message)) : (i.size > 0 && !c && console.warn("[Warning] You are using both prefetching and prerendering on the same document"), Promise.all([].concat(n2).map(function(n3) {
    if (!o.has(n3))
      return o.add(n3), (t2 ? function(n4) {
        return window.fetch ? fetch(n4, { credentials: "include" }) : e(n4);
      } : r)(new URL(n3, location.href).toString());
  })));
}
function f(e2, n2) {
  var r2 = a(navigator.connection);
  if (r2 instanceof Error)
    return Promise.reject(new Error("Cannot prerender, " + r2.message));
  if (!HTMLScriptElement.supports("speculationrules"))
    return s(e2), Promise.reject(new Error("This browser does not support the speculation rules API. Falling back to prefetch."));
  if (document.querySelector('script[type="speculationrules"]'))
    return Promise.reject(new Error("Speculation Rules is already defined and cannot be altered."));
  for (var t2 = 0, u2 = [].concat(e2); t2 < u2.length; t2 += 1) {
    var f2 = u2[t2];
    if (window.location.origin !== new URL(f2, window.location.href).origin)
      return Promise.reject(new Error("Only same origin URLs are allowed: " + f2));
    i.add(f2);
  }
  o.size > 0 && !c && console.warn("[Warning] You are using both prefetching and prerendering on the same document");
  var l = function(e3) {
    var n3 = document.createElement("script");
    n3.type = "speculationrules", n3.text = '{"prerender":[{"source": "list","urls": ["' + Array.from(e3).join('","') + '"]}]}';
    try {
      document.head.appendChild(n3);
    } catch (e4) {
      return e4;
    }
    return true;
  }(i);
  return true === l ? Promise.resolve() : Promise.reject(l);
}

// src/utils/utils-events.js
var sendVariantImageUpdateEvent = debounce((variantId) => {
  const event2 = new CustomEvent("updateVariantImage", { detail: variantId });
  document.dispatchEvent(event2);
}, 100);
var sendProductAddedToCartEvent = debounce((product) => {
  const event2 = new CustomEvent("productAddedToCart", { detail: product });
  document.dispatchEvent(event2);
}, 100);
var sendVariantOptionsChanged = debounce(() => {
  const event2 = new CustomEvent("variantOptionsChanged");
  document.dispatchEvent(event2);
}, 100);
var listenForVariantImageUpdateEvent = (callbackFunction) => {
  document.addEventListener("updateVariantImage", (event2) => callbackFunction(event2));
};
var listenForProductAddedToCartEvent = (callbackFunction) => {
  document.addEventListener("productAddedToCart", (event2) => callbackFunction(event2));
};
var listenForVariantOptionsChanges = (callbackFunction) => {
  document.addEventListener("variantOptionsChanged", callbackFunction);
};
var listenForUpdatesOnModalState = (callbackFunction) => {
  document.addEventListener("modal-state", callbackFunction);
};

// src/config/base.js
var import_marquee3000 = __toESM(require_marquee3k(), 1);
init_surf_modal();
var setMarqueeSlider = () => {
  import_marquee3000.default.init({
    selector: "marquee-slider"
    // define a custom classname
  });
  window.addEventListener("resize", () => {
    import_marquee3000.default.refreshAll();
  });
  document.addEventListener("shopify:section:load", () => {
    import_marquee3000.default.refreshAll();
  });
};
var handleAllModals = () => {
  const allOpenModalButtonElements = document.querySelectorAll(".js-open-modal");
  if (allOpenModalButtonElements.length > 0) {
    const baseModal = new surf_modal_default();
    allOpenModalButtonElements.forEach((openModalButtonElement) => {
      const targetId = openModalButtonElement ? openModalButtonElement.dataset.target : null;
      const deeplinkTarget = openModalButtonElement ? openModalButtonElement.dataset.deeplinkTarget : null;
      if (targetId) {
        openModalButtonElement.addEventListener("click", () => {
          baseModal.openModal(targetId, openModalButtonElement, deeplinkTarget);
        });
      }
    });
  }
  document.addEventListener("handleCloseModal", (event2) => {
    const baseModal = new surf_modal_default();
    baseModal.closeModal(event2.detail);
  });
};
var removeAllModalEventListeners = () => {
  const allOpenModalButtonElements = document.querySelectorAll(".js-open-modal");
  if (allOpenModalButtonElements.length > 0) {
    const baseModal = new surf_modal_default();
    allOpenModalButtonElements.forEach((openModalButtonElement) => {
      const targetId = openModalButtonElement ? openModalButtonElement.dataset.target : null;
      const deeplinkTarget = openModalButtonElement ? openModalButtonElement.dataset.deeplinkTarget : null;
      if (targetId) {
        openModalButtonElement.removeEventListener("click", () => {
          baseModal.openModal(targetId, openModalButtonElement, deeplinkTarget);
        });
      }
    });
  }
  document.removeEventListener("handleCloseModal", (event2) => {
    const baseModal = new surf_modal_default();
    baseModal.closeModal(event2.detail);
  });
};
window.addEventListener("product-info:variant-change:completed", () => {
  removeAllModalEventListeners();
  handleAllModals();
});
listenForUpdatesOnModalState((event2) => {
  const state = event2.detail.state;
  if (state === "open") {
    meta_theme_color_state_default.setModalColor();
  } else {
    meta_theme_color_state_default.setDefaultColor();
  }
});
window.addEventListener("load", () => {
});
setMarqueeSlider();
handleAllModals();
enableBFCacheSupport();
/*! Bundled license information:

gsap/gsap-core.js:
  (*!
   * GSAP 3.9.1
   * https://greensock.com
   *
   * @license Copyright 2008-2021, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  *)

gsap/CSSPlugin.js:
  (*!
   * CSSPlugin 3.9.1
   * https://greensock.com
   *
   * Copyright 2008-2021, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  *)

gsap/ScrollToPlugin.js:
  (*!
   * ScrollToPlugin 3.9.1
   * https://greensock.com
   *
   * @license Copyright 2008-2021, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  *)
*/
